import PropTypes, { shape } from 'prop-types';
import React, { Component } from 'react';
import createEmotionStyled from 'create-emotion-styled';
import createEmotion from 'create-emotion';
import { withTheme } from 'emotion-theming';
import moment from 'moment';
import 'classnames';
import 'react-emotion';
import 'react-modal';
import 'react-datepicker';
import 'react-autocomplete';

var breakpoints = {
  xs1: '0',
  xs2: '480px',
  sm1: '540px',
  sm2: '640px',
  md1: '768px',
  md2: '960px',
  lg1: '1024px',
  lg2: '1280px',
  lg3: '1328px',
  xl1: '1420px',
  xl2: '1920px'
};

var getMediaQuery = function getMediaQuery(css, breakpoint) {
  return '@media (min-width: ' + breakpoint + ') { ' + css + ' }';
};

var breakpointAndUp = {};

var _loop = function _loop(_breakpoint2) {
  if (breakpoints[_breakpoint2] !== '0') {
    breakpointAndUp[_breakpoint2] = function (css) {
      return getMediaQuery(css, breakpoints[_breakpoint2]);
    };
  }
};

for (var _breakpoint2 in breakpoints) {
  _loop(_breakpoint2);
}

var theme = { baseFontSize: 16 }; //DEBTxCYBG pull this from theme component or global?
var baseSpacing = 8;

var spacingHelper = function spacingHelper(value) {
    var fontMultiple = value * baseSpacing;
    var rems = fontMultiple / theme.baseFontSize;
    return rems + 'rem';
};

var spacing = {
    EIGHTH: spacingHelper(0.125),
    QUARTER: spacingHelper(0.25),
    HALF: spacingHelper(0.5),
    THREE_QUARTERS: spacingHelper(0.75),
    SINGLE: spacingHelper(1),
    ONE_AND_QUARTER: spacingHelper(1.25),
    ONE_AND_HALF: spacingHelper(1.5),
    ONE_AND_THREE_QUARTERS: spacingHelper(1.75),
    DOUBLE: spacingHelper(2),
    TWO_AND_HALF: spacingHelper(2.5),
    TRIPLE: spacingHelper(3),
    THREE_AND_HALF: spacingHelper(3.5),
    QUADRUPLE: spacingHelper(4),
    QUINTUPLE: spacingHelper(5),
    SEXTUPLE: spacingHelper(6),
    SEPTUPLE: spacingHelper(7),
    OCTUPLE: spacingHelper(8),
    NONUPLE: spacingHelper(9),
    DECUPLE: spacingHelper(10)
};

var externalMarginRegular = '\n    margin-right: ' + spacing.DOUBLE + ';\n    margin-bottom: ' + spacing.DOUBLE + ';\n';

var internalPaddingShell = '\n    overflow: auto;\n    padding-bottom: ' + spacing.SINGLE + '; \n    padding-left: ' + spacing.DOUBLE + '; \n    padding-right: 0; \n    padding-top: ' + spacing.DOUBLE + ';\n    ' + breakpointAndUp.md1('\n        padding-left: ' + spacing.TRIPLE + ';\n        padding-right: ' + spacing.SINGLE + ';\n    ') + '\n';

/* Font size config: usage example ${fontSize('arran')} */

var fontConfig = {
  lewis: {
    xs1: { fontSize: 37, lineHeight: 1.189 },
    sm1: { fontSize: 37, lineHeight: 1.189 },
    md1: { fontSize: 45, lineHeight: 1.067 },
    lg1: { fontSize: 52, lineHeight: 1.154 },
    xl1: { fontSize: 52, lineHeight: 1.154 }
  },
  skye: {
    xs1: { fontSize: 32, lineHeight: 1.125 },
    sm1: { fontSize: 32, lineHeight: 1.125 },
    md1: { fontSize: 40, lineHeight: 1.1 },
    lg1: { fontSize: 45, lineHeight: 1.156 },
    xl1: { fontSize: 45, lineHeight: 1.156 }
  },
  shetland: {
    xs1: { fontSize: 29, lineHeight: 1.241 },
    sm1: { fontSize: 29, lineHeight: 1.241 },
    md1: { fontSize: 34, lineHeight: 1.176 },
    lg1: { fontSize: 39, lineHeight: 1.128 },
    xl1: { fontSize: 39, lineHeight: 1.128 }
  },
  mull: {
    xs1: { fontSize: 26, lineHeight: 1.231 },
    sm1: { fontSize: 26, lineHeight: 1.231 },
    md1: { fontSize: 29, lineHeight: 1.241 },
    lg1: { fontSize: 33, lineHeight: 1.212 },
    xl1: { fontSize: 33, lineHeight: 1.212 }
  },
  islay: {
    xs1: { fontSize: 23, lineHeight: 1.217 },
    sm1: { fontSize: 23, lineHeight: 1.217 },
    md1: { fontSize: 25, lineHeight: 1.28 },
    lg1: { fontSize: 28, lineHeight: 1.286 },
    xl1: { fontSize: 28, lineHeight: 1.286 }
  },
  orkney: {
    xs1: { fontSize: 20, lineHeight: 1.4 },
    sm1: { fontSize: 20, lineHeight: 1.4 },
    md1: { fontSize: 22, lineHeight: 1.273 },
    lg1: { fontSize: 25, lineHeight: 1.28 },
    xl1: { fontSize: 25, lineHeight: 1.28 }
  },
  arran: {
    xs1: { fontSize: 18, lineHeight: 1.333 },
    sm1: { fontSize: 18, lineHeight: 1.333 },
    md1: { fontSize: 19, lineHeight: 1.474 },
    lg1: { fontSize: 21, lineHeight: 1.333 },
    xl1: { fontSize: 21, lineHeight: 1.333 }
  },
  jura: {
    xs1: { fontSize: 16, lineHeight: 1.5 },
    sm1: { fontSize: 16, lineHeight: 1.5 },
    md1: { fontSize: 16, lineHeight: 1.5 },
    lg1: { fontSize: 18, lineHeight: 1.556 },
    xl1: { fontSize: 18, lineHeight: 1.556 }
  },
  uist: {
    xs1: { fontSize: 14, lineHeight: 1.429 },
    sm1: { fontSize: 14, lineHeight: 1.429 },
    md1: { fontSize: 14, lineHeight: 1.429 },
    lg1: { fontSize: 16, lineHeight: 1.5 },
    xl1: { fontSize: 16, lineHeight: 1.5 }
  },
  bute: {
    xs1: { fontSize: 12, lineHeight: 1.333 },
    sm1: { fontSize: 12, lineHeight: 1.333 },
    md1: { fontSize: 13, lineHeight: 1.538 },
    lg1: { fontSize: 13, lineHeight: 1.538 },
    xl1: { fontSize: 13, lineHeight: 1.538 }
  },
  cumbrae: {
    xs1: { fontSize: 11, lineHeight: 1.455 },
    sm1: { fontSize: 11, lineHeight: 1.455 },
    md1: { fontSize: 12, lineHeight: 1.333 },
    lg1: { fontSize: 12, lineHeight: 1.333 },
    xl1: { fontSize: 12, lineHeight: 1.333 }
  }
};

var generateSASS = function generateSASS(mqBreakpoint, size, lineHeight) {
  var styles = '';
  if (parseInt(mqBreakpoint) === 0) {
    styles = 'font-size: ' + size + 'px; line-height: ' + lineHeight + ';';
  } else {
    styles = '\n      @media (min-width: ' + mqBreakpoint + ') {\n        font-size: ' + size + 'px;\n        line-height: ' + lineHeight + ';\n      } \n    ';
  }
  return styles;
};

var fontSizes = {};

for (var _fontSize in fontConfig) {
  if (fontConfig.hasOwnProperty(_fontSize)) {
    var style = '';
    for (var breakpoint in fontConfig[_fontSize]) {
      if (fontConfig[_fontSize].hasOwnProperty(breakpoint)) {
        var _fontConfig$_fontSize = fontConfig[_fontSize][breakpoint],
            size = _fontConfig$_fontSize.fontSize,
            lineHeight = _fontConfig$_fontSize.lineHeight;

        style += generateSASS(breakpoints[breakpoint], size, lineHeight);
      }
    }
    fontSizes[_fontSize] = style;
  }
}

var fontSize = function fontSize(font) {
  return fontSizes[font];
};

var useFontSize = {

  of: {
    lewis: function lewis() {
      return fontSizes['lewis'];
    },
    skye: function skye() {
      return fontSizes['skye'];
    },
    shetland: function shetland() {
      return fontSizes['shetland'];
    },
    mull: function mull() {
      return fontSizes['mull'];
    },
    islay: function islay() {
      return fontSizes['islay'];
    },
    orkney: function orkney() {
      return fontSizes['orkney'];
    },
    arran: function arran() {
      return fontSizes['arran'];
    },
    jura: function jura() {
      return fontSizes['jura'];
    },
    uist: function uist() {
      return fontSizes['uist'];
    },
    bute: function bute() {
      return fontSizes['bute'];
    },
    cumbrae: function cumbrae() {
      return fontSizes['cumbrae'];
    }
  },

  biggerThan: {
    lewis: function lewis() {
      throw new Error("lewis is the biggest font");
    },
    skye: function skye() {
      return fontSizes['lewis'];
    },
    shetland: function shetland() {
      return fontSizes['skye'];
    },
    mull: function mull() {
      return fontSizes['shetland'];
    },
    islay: function islay() {
      return fontSizes['mull'];
    },
    orkney: function orkney() {
      return fontSizes['islay'];
    },
    arran: function arran() {
      return fontSizes['orkney'];
    },
    jura: function jura() {
      return fontSizes['arran'];
    },
    uist: function uist() {
      return fontSizes['jura'];
    },
    bute: function bute() {
      return fontSizes['uist'];
    },
    cumbrae: function cumbrae() {
      return fontSizes['bute'];
    }
  },

  smallerThan: {
    lewis: function lewis() {
      return fontSizes['skye'];
    },
    skye: function skye() {
      return fontSizes['shetland'];
    },
    shetland: function shetland() {
      return fontSizes['mull'];
    },
    mull: function mull() {
      return fontSizes['islay'];
    },
    islay: function islay() {
      return fontSizes['orkney'];
    },
    orkney: function orkney() {
      return fontSizes['arran'];
    },
    arran: function arran() {
      return fontSizes['jura'];
    },
    jura: function jura() {
      return fontSizes['uist'];
    },
    uist: function uist() {
      return fontSizes['bute'];
    },
    bute: function bute() {
      return fontSizes['cumbrae'];
    },
    cumbrae: function cumbrae() {
      throw new Error("cumbrae is the smallest font");
    }
  }
};

var layers = {
  datepicker1: 2147483647,
  globalTakeoverContent: 1053,
  globalTakeoverTransparency: 1052,
  globalTakeover: 1051,
  loader: 1051,
  modal1: 1050,
  modal2: 1040,
  localTakeover: 1020,
  popper: 110,
  webchat: 110,
  multiButtonModal: 104,
  wideModal: 104,
  accountLegacyPanelDropdown: 100,
  modal3: 100,
  paymentAccountSelector1: 16,
  paymentAccountSelector2: 15,
  checkboxToggleOffIcon: 10,
  comparisonTable: 10,
  accountSelectDropdown: 10,
  currencySelectDropdown: 10,
  header: 10,
  listPayment: 10,
  payeeFooterBar: 9,
  payeeList: 9,
  datepicker2: 5,
  searchAndSelect2: 5,
  searchAndSelect1: 3,
  datepicker: 2,
  datepicker3: 2,
  fauxBlockLink: 2,
  sortCardGroup: 2,
  submittedTransactionTable: 2,
  tileButtonOverlay: 2,
  root: 1,
  sub: -1
};

var context = typeof global !== 'undefined' ? global : {};

var _createEmotion = createEmotion(context, {
	nonce: btoa('web-ui-components')
}),
    caches = _createEmotion.caches,
    css = _createEmotion.css,
    cx = _createEmotion.cx,
    flush = _createEmotion.flush,
    getRegisteredStyles = _createEmotion.getRegisteredStyles,
    hydrate = _createEmotion.hydrate,
    injectGlobal = _createEmotion.injectGlobal,
    keyframes = _createEmotion.keyframes,
    merge = _createEmotion.merge,
    sheet = _createEmotion.sheet;

var emotion = /*#__PURE__*/Object.freeze({
  __proto__: null,
  caches: caches,
  css: css,
  cx: cx,
  flush: flush,
  getRegisteredStyles: getRegisteredStyles,
  hydrate: hydrate,
  injectGlobal: injectGlobal,
  keyframes: keyframes,
  merge: merge,
  sheet: sheet
});

var styled = createEmotionStyled(emotion, React);

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var taggedTemplateLiteral = function (strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
};

var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

var HSL_SLICE_START = 4;
var DEFAULT_AMOUNT = 5;

var hslAdjust = function hslAdjust(hslText) {
	var splitHSL = hslText.slice(HSL_SLICE_START, hslText.length - 1).split(',');

	var _splitHSL = slicedToArray(splitHSL, 3),
	    hueLabel = _splitHSL[0],
	    saturationLabel = _splitHSL[1],
	    lightnessLabel = _splitHSL[2];

	var hue = parseInt(hueLabel, 10);
	var saturation = parseInt(saturationLabel.slice(0, saturationLabel.length - 1), 10);
	var lightness = parseInt(lightnessLabel.slice(0, lightnessLabel.length - 1), 10);

	return {
		darken: function darken() {
			var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_AMOUNT;
			return 'hsl(' + hue + ', ' + saturation + '%, ' + (lightness - amount) + '%)';
		},
		lighten: function lighten() {
			var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_AMOUNT;
			return 'hsl(' + hue + ', ' + saturation + '%, ' + (lightness + amount) + '%)';
		},
		saturate: function saturate() {
			var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_AMOUNT;
			return 'hsl(' + hue + ', ' + (saturation + amount) + '%, ' + lightness + '%)';
		},
		desaturate: function desaturate() {
			var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_AMOUNT;
			return 'hsl(' + hue + ', ' + (saturation - amount) + '%, ' + lightness + '%)';
		}
	};
};

var _templateObject = taggedTemplateLiteral(['\n  0% {\n    box-shadow: 0 0 0 0 rgba(121, 0, 202, 0.8);\n  }\n  100% {\n    box-shadow: 0 0 0 ', ' rgba(121, 0, 202, 0);\n  }\n'], ['\n  0% {\n    box-shadow: 0 0 0 0 rgba(121, 0, 202, 0.8);\n  }\n  100% {\n    box-shadow: 0 0 0 ', ' rgba(121, 0, 202, 0);\n  }\n']),
    _templateObject2 = taggedTemplateLiteral(['\n  0% {\n    box-shadow: 0 0 0 0 rgba(248, 0, 0, 0.8);\n  }\n  100% {\n    box-shadow: 0 0 0 ', ' rgba(248, 0, 0, 0);\n  }\n'], ['\n  0% {\n    box-shadow: 0 0 0 0 rgba(248, 0, 0, 0.8);\n  }\n  100% {\n    box-shadow: 0 0 0 ', ' rgba(248, 0, 0, 0);\n  }\n']),
    _templateObject3 = taggedTemplateLiteral(['\n  0% {\n    box-shadow: 0 0 0 0 rgba(0, 148, 211, 0.8);\n  }\n  100% {\n    box-shadow: 0 0 0 ', ' rgba(0, 148, 211, 0);\n  }\n'], ['\n  0% {\n    box-shadow: 0 0 0 0 rgba(0, 148, 211, 0.8);\n  }\n  100% {\n    box-shadow: 0 0 0 ', ' rgba(0, 148, 211, 0);\n  }\n']),
    _templateObject4 = taggedTemplateLiteral(['\n  0% {\n    opacity: 0;\n  }\n  25% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n'], ['\n  0% {\n    opacity: 0;\n  }\n  25% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n']),
    _templateObject5 = taggedTemplateLiteral(['\n  0% {\n    opacity: 1;\n  }\n  25% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 0;\n  }\n'], ['\n  0% {\n    opacity: 1;\n  }\n  25% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 0;\n  }\n']),
    _templateObject6 = taggedTemplateLiteral(['\n  from {\n    fill: ', ';\n  }\n  to {\n    fill: ', ';\n  }\n'], ['\n  from {\n    fill: ', ';\n  }\n  to {\n    fill: ', ';\n  }\n']),
    _templateObject7 = taggedTemplateLiteral(['\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n'], ['\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n']),
    _templateObject8 = taggedTemplateLiteral(['\n  0% {\n    transform: scale(0.8);\n  }\n  65.5% {\n    transform: scale(1.03);\n  }\n  100% {\n    transform: scale(1);\n  }\n'], ['\n  0% {\n    transform: scale(0.8);\n  }\n  65.5% {\n    transform: scale(1.03);\n  }\n  100% {\n    transform: scale(1);\n  }\n']);

var circularPulseB = keyframes(_templateObject, spacing.QUADRUPLE);

var circularPulseCB = keyframes(_templateObject2, spacing.QUADRUPLE);

var circularPulseYB = keyframes(_templateObject3, spacing.QUADRUPLE);

var fadeIn = keyframes(_templateObject4);

var fadeOut = keyframes(_templateObject5);

var iconPulse = function iconPulse(colour) {
  return keyframes(_templateObject6, colour, hslAdjust(colour).lighten(0.2));
};

var rotate = keyframes(_templateObject7);

var scaleFadeIn = keyframes(_templateObject8);

var animations = {
  circularPulseB: circularPulseB,
  circularPulseCB: circularPulseCB,
  circularPulseYB: circularPulseYB,
  fadeIn: fadeIn,
  fadeOut: fadeOut,
  iconPulse: iconPulse,
  rotate: rotate,
  scaleFadeIn: scaleFadeIn
};

var generalPalette = {
  black: 'hsl(0, 0%, 0%)',
  blue: 'hsl(204, 52%, 48%)',
  blueLight: 'hsl(208, 59%, 60%)',
  green: 'hsl(135, 41%, 48%)',
  greenFaint: 'hsl(135, 41%, 70%)',
  greyDarkest: 'hsl(0, 0%, 28%)',
  greyDarker: 'hsl(0, 0%, 45%)',
  grey: 'hsl(0, 0%, 60%)',
  greyLighter: 'hsl(0, 0%, 75%)',
  greyLightest: 'hsl(0, 0%, 85%)',
  orange: 'hsl(29, 77%, 56%)',
  red: 'hsl(8, 52%, 50%)',
  purple: 'hsl(282, 25%, 57%)',
  white: 'hsl(0, 0%, 100%)'
};

var black = generalPalette.black,
    blue = generalPalette.blue,
    blueLight = generalPalette.blueLight,
    green = generalPalette.green,
    greenFaint = generalPalette.greenFaint,
    greyDarker = generalPalette.greyDarker,
    greyDarkest = generalPalette.greyDarkest,
    greyLightest = generalPalette.greyLightest,
    orange = generalPalette.orange,
    red = generalPalette.red,
    grey = generalPalette.grey,
    greyLighter = generalPalette.greyLighter,
    purple = generalPalette.purple,
    white = generalPalette.white;


var colours = {
  backgrounds: {
    alternateBody: 'hsl(212, 100%, 97%)',
    alternateHeader: greyLightest,
    component: white,
    modalBackdrop: black,
    modalBackdropOpaque: 'rgba(0, 0, 0, 0.8)',
    shell: 'hsl(0, 0%, 95.3%)',
    tableCell: 'hsl(0, 0%, 97%)',
    tableCellAlternate: 'hsl(0, 71%, 97%)',
    tableCellHeader: 'hsl(0, 0%, 94%)'
  },
  component: {
    border: greyLightest,
    focusOutline: 'hsl(208, 59%, 60%)',
    hover: greyLightest,
    locked: greyDarker,
    frame: {
      active: {
        background: 'repeating-linear-gradient(45deg, hsl(45, 0%, 85%),' + 'hsl(45, 0%, 85%) 28px, hsl(46, 0%, 95%) 28px, hsl(46, 0%, 95%) 56px)',
        content: 'hsl(45, 0%, 85%)',
        contentAlternate: 'hsl(46, 0%, 95%)'
      },
      bespoke: {
        background: 'repeating-linear-gradient(45deg, hsl(302, 44%, 70%), ' + 'hsl(302, 44%, 70%) 28px, hsl(302, 44%, 90%) 28px, hsl(302, 44%, 90%) 56px)',
        content: 'hsl(302, 44%, 70%)',
        contentAlternate: 'hsl(302, 44%, 90%)'
      },
      deprecated: {
        background: 'repeating-linear-gradient(45deg, hsl(45, 100%, 46%), ' + 'hsl(45, 100%, 46%) 28px, hsl(46, 100%, 64%) 28px, hsl(46, 100%, 64%) 56px)',
        content: 'hsl(45, 100%, 46%)',
        contentAlternate: 'hsl(46, 100%, 64%)'
      },
      draft: {
        background: 'repeating-linear-gradient(45deg, hsl(204, 52%, 48%), ' + 'hsl(204, 52%, 48%) 28px, hsl(205, 52%, 58%) 28px, hsl(205, 52%, 58%) 56px)',
        content: 'hsl(204, 52%, 48%)',
        contentAlternate: 'hsl(205, 52%, 58%)'
      },
      outdated: {
        background: 'repeating-linear-gradient(45deg, hsl(269, 69%, 69%), ' + 'hsl(269, 69%, 69%) 28px, hsl(270, 69%, 79%) 28px, hsl(270, 69%, 79%) 56px)',
        content: 'hsl(269, 69%, 69%)',
        contentAlternate: 'hsl(270, 69%, 79%)'
      }
    }
  },
  disabled: {
    background: greyLightest,
    border: greyDarkest
  },
  neutral: {
    black: black,
    grey: grey,
    greyDarker: greyDarker,
    greyDarkest: greyDarkest,
    greyLighter: greyLighter,
    greyLightest: greyLightest,
    white: white
  },
  telephony: {
    answerCallGradient: 'linear-gradient(hsl(54, 100%, 73%), hsl(49, 99%, 64%));',
    calledGradient: 'linear-gradient(hsl(159, 52%, 67%), hsl(153, 41%, 49%));',
    conferenceCallGradient: 'linear-gradient(hsl(193, 100%, 91%), hsl(196, 96%, 80%));',
    conferenceMaskGradient: 'linear-gradient(hsl(248, 86%, 83%), hsl(260, 94%, 72%));',
    dialingCallGradient: 'linear-gradient(hsl(54, 100%, 73%), hsl(49, 99%, 64%));',
    holdCallGradient: 'linear-gradient(hsl(45, 95%, 75%), hsl(37, 91%, 65%));',
    makeCallGradient: 'linear-gradient(hsl(33, 15%, 86%), hsl(180, 3%, 69%));',
    onCallGradient: 'linear-gradient(hsl(129, 80%, 82%), hsl(127, 67%, 63%));',
    answerCall: 'hsl(89, 91%, 40%)',
    closeCall: 'hsl(353, 98%, 41%)',
    dialCall: 'hsl(89, 91%, 40%)',
    endCall: 'hsl(353, 98%, 41%)',
    holdCall: 'hsl(37, 94%, 49%)',
    resumeCall: 'hsl(89, 91%, 40%)'
  },
  typography: {
    body: greyDarkest,
    secondaryBody: greyDarker,
    supplementaryBody: grey
  },
  utility: {
    active: green,
    archived: greyLightest,
    blocker: 'hsl(0, 60%, 96%)',
    empty: 'hsl(0, 0%, 100%)',
    emptyBorder: 'hsl(0, 0%, 40%)',
    error: red,
    errorBodyBackground: 'hsl(8,52%,96%)',
    focus: blueLight,
    help: 'hsl(210, 38%, 91%)',
    inactive: red,
    indicative: orange,
    information: blue,
    notStarted: greyDarker,
    off: grey,
    offDisabled: greyLighter,
    ongoing: purple,
    paused: blue,
    pending: orange,
    success: green,
    successDisabled: greenFaint,
    warning: orange
  },
  utilityLegacy: {
    infoBackground: 'hsl(210, 46%, 91%)',
    infoBorder: 'hsl(204, 52%, 48%)',
    noteBackground: 'hsl(45, 53%, 94%)',
    noteBorder: 'hsl(46, 88%, 24%)',
    tipBackground: 'hsl(125, 21%, 88%)',
    tipBorder: 'hsl(135, 41%, 48%)',
    warningBackground: 'hsl(0, 60%, 96%)',
    warningBorder: 'hsl(8, 52%, 50%)'
  },
  // TODOxVM: Colours are getting a proper revisit soon. This is temporary. 
  utilitySupremacy: {
    errorPrimary: 'hsl(0, 93%, 41%)',
    errorSecondary: 'hsl(0, 96%, 77%)',
    errorTertiary: 'hsl(0, 60%, 96%)',
    guidancePrimary: 'hsl(210, 97%, 87%)',
    guidanceSecondary: 'hsl(210, 100%, 95%)',
    rememberPrimary: 'hsl(55, 92%, 69%)',
    rememberSecondary: 'hsl(55, 100%, 88%)',
    successPrimary: 'hsl(144, 83%, 25%)',
    successSecondary: 'hsl(90, 91%, 88%)',
    tipPrimary: 'hsl(90, 53%, 70%)',
    tipSecondary: 'hsl(90, 61%, 88%)'
  }
};

var _extends$1 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var CheckboxIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends$1({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M36.136 59.588L73.4 21l8.1 7.823-44.935 46.532-.157-.15-.15.155L14.5 54.35l7.823-8.1 13.813 13.338z" }));
});

// Note this is a copy paste of the String Utils within the library.

var addFullStop = function addFullStop(value) {
	return value.charAt(value.length - 1) === '.' ? value : value.replace(/([^.])$/, '$1.');
};

var capitaliseFirstLetter = function capitaliseFirstLetter(value) {
	return value.trim().charAt(0).toUpperCase() + value.trim().slice(1);
};

var pascalCaseString = function pascalCaseString(value) {
	return value.split(" ").map(function (word) {
		return capitaliseFirstLetter(word);
	}).join(" ");
};

var lowercaseFirstLetter = function lowercaseFirstLetter(value) {
	return value.charAt(0).toLowerCase() + value.slice(1);
};

var stringHelpers = { addFullStop: addFullStop, capitaliseFirstLetter: capitaliseFirstLetter, lowercaseFirstLetter: lowercaseFirstLetter, pascalCaseString: pascalCaseString };
var stringHelpers_2 = stringHelpers.capitaliseFirstLetter;

var styleGuideTheme = {
	borderRadius: spacing.HALF,
	boxShadow: '0 0 4px 1px hsla(0, 0%, 0%, 0.3)',
	internalPaddingRegular: '\n\t\tpadding-left: ' + spacing.DOUBLE + ';\n\t\tpadding-top: ' + spacing.DOUBLE + ';\n\n\t\t@media (max-width: ' + breakpoints.md1 + ') {\n\t\t\tpadding-left: ' + spacing.SINGLE + ';\n\t\t\tpadding-top: ' + spacing.SINGLE + ';\n\t\t}\n\t',
	internalPaddingFull: '\n\tpadding: ' + spacing.DOUBLE + ';\n\n\t@media (max-width: ' + breakpoints.md1 + ') {\n\t\tpadding: ' + spacing.SINGLE + ';\n\t}\n',
	externalMarginRegular: '\n\t\tmargin-right: ' + spacing.DOUBLE + ';\n\t\tmargin-bottom: ' + spacing.DOUBLE + ';\n\n\t\t@media (max-width: ' + breakpoints.md1 + ') {\n\t\t\tmargin-right: ' + spacing.SINGLE + ';\n\t\t\tmargin-bottom: ' + spacing.SINGLE + ';\n\t\t}\n\t',
	focus: '\n\t\t:focus {\n\t\t\tbox-shadow: 0 0 0 2px hsl(208, 59%, 60%);\n\t\t\toutline: 0;\n\t\t}\n\t',
	focusInset: '\n\t\t:focus {\n\t\t\tbox-shadow: inset 0 0 0 2px hsl(208, 59%, 60%);\n\t\t\toutline: 0;\n\t\t}\n',
	colours: {
		backgrounds: {
			alternative: 'hsl(0, 0%, 20%)',
			button: {
				active: 'linear-gradient(to top, hsl(0, 0%, 0%), hsl(0, 0%, 5%))',
				hover: 'hsl(0, 0%, 30%)',
				primary: 'linear-gradient(to top, hsl(0, 0%, 5%), hsl(0, 0%, 10%))'
			},
			deprecated: 'repeating-linear-gradient(45deg, hsl(45, 100%, 51%), ' + 'hsl(45, 100%, 51%) 28px, hsl(46, 100%, 64%) 28px, hsl(46, 100%, 64%) 56px)',
			main: 'hsl(0, 0%, 0%)',
			notes: 'hsl(194, 61%, 97%)',
			outdated: 'repeating-linear-gradient(45deg, hsl(269, 69%, 69%), ' + 'hsl(269, 69%, 69%) 28px, hsl(270, 69%, 79%) 28px, hsl(270, 69%, 79%) 56px)',
			page: 'hsl(0, 0%, 25%)'
		},
		body: {
			disabled: 'hsl(0, 0%, 70%)',
			light: 'hsl(0, 0%, 100%)',
			notes: 'hsl(194, 61%, 40%)',
			placeholder: 'hsl(0, 0%, 50%)'
		},
		code: {
			blue: 'hsl(198, 95%, 47%)',
			blueLight: 'hsl(199, 98%, 71%)',
			green: 'hsl(103, 64%, 55%)',
			orange: 'hsl(22, 80%, 55%)',
			pink: 'hsl(312, 84%, 66%)',
			purple: 'hsl(279, 75%, 35%)',
			red: 'hsl(0, 100%, 50%)',
			white: 'hsl(0, 0%, 100%)',
			yellow: 'hsl(46, 100%, 64%)'
		},
		active: 'hsl(46, 100%, 64%)',
		border: 'hsl(0, 0%, 0%)',
		bounding: 'hsl(332, 55%, 46%)',
		boundingLight: 'hsla(332, 55%, 46%, 25%)',
		deprecated: 'hsl(45, 100%, 51%)',
		interaction: 'hsl(204, 66%, 56%)',
		interactionHover: 'hsl(187, 52%, 80%)',
		label: 'hsl(0, 0%, 100%)',
		new: 'hsl(181, 100%, 50%)',
		outdated: 'hsl(269, 69%, 69%)',
		seperator: 'hsl(0, 0%, 33%)',
		settings: 'hsl(0, 0%, 42%)'
	},
	fontFamily: {
		code: 'Consolas, "Liberation Mono", Menlo, monospace',
		notes: 'Lato, sans-serif'
	},
	name: 'style-guide'
};

var metadata = [{
	name: "ActionAnchor",
	path: "src/actions/anchors/ActionAnchor/package.json",
	variants: ["Download", "Upload"],
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": false,
		"dev-format": true,
		"tech-format": true
	}
}, {
	name: "ActionButton",
	path: "src/actions/buttons/ActionButton/package.json",
	variants: ["Primary", "Secondary", "Add", "Download", "Edit", "Find", "Print", "Remove", "Search", "Upload"],
	"component-id": 1014,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": false,
		"dev-format": true,
		"tech-format": true
	}
}, {
	name: "EmailLink",
	path: "src/actions/links/EmailLink/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": false,
		"dev-format": true,
		"tech-format": true
	}
}, {
	name: "PhoneLink",
	path: "src/actions/links/PhoneLink/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": false,
		"dev-format": true,
		"tech-format": true
	}
}, {
	name: "WebsiteLink",
	path: "src/actions/links/WebsiteLink/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": false,
		"dev-format": true,
		"tech-format": true
	}
}, {
	name: "InputRadio",
	path: "src/actions/radios/InputRadio/package.json",
	variants: ["Default", "Grid", "List"],
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "GenericRadio",
			path: "Data/Capture/Radios"
		}
	}]
}, {
	name: "InputRadioGroup",
	path: "src/actions/radios/InputRadioGroup/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "GenericRadio",
			path: "Data/Capture/Radios"
		}
	}]
}, {
	name: "TallRadioCard",
	path: "src/actions/radios/TallRadioCard/package.json",
	"component-id": null,
	"component-life-cycle": "outdated",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "WideRadioCard",
	path: "src/actions/radios/WideRadioCard/package.json",
	"component-id": null,
	"component-life-cycle": "outdated",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "NewWindowAction",
	path: "src/advisor/actions/NewWindowAction/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": true,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "CustomerAlert",
	path: "src/advisor/alerts/CustomerAlert/package.json",
	variants: ["FraudLocked", "LockedServices"],
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": true,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "ClickableContentFrame",
	path: "src/advisor/layout/ClickableContentFrame/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": true,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "DashboardGrid",
	path: "src/advisor/layout/DashboardGrid/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": true,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "WideModal",
	path: "src/advisor/layout/WideModal/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": true,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "WindowFrame",
	path: "src/advisor/layout/WindowFrame/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": true,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "ProductRadioCard",
	path: "src/advisor/radios/ProductRadioCard/package.json",
	variants: ["CreditCard", "DebitCard"],
	"component-id": 1037,
	"component-life-cycle": "active",
	"is-bespoke": true,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: true,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": false,
		"dev-format": true,
		"tech-format": true
	}
}, {
	name: "AccountSelect",
	path: "src/advisor/selects/AccountSelect/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": true,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "SessionTimeoutTakeover",
	path: "src/advisor/takeovers/SessionTimeoutTakeover/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": true,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "Anchor",
	path: "src/atoms/buttons/Anchor/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "WebsiteLink",
			path: "Actions/Links"
		}
	}]
}, {
	name: "Button",
	path: "src/atoms/buttons/Button/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: [{
			name: "ActionButton",
			path: "Actions/Buttons"
		}, {
			name: "NavigationButton",
			path: "Navigation/Buttons"
		}]
	}]
}, {
	name: "ButtonTitle",
	path: "src/atoms/buttons/ButtonTitle/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "Calendar",
	path: "src/atoms/forms/Calendar/package.json",
	"component-id": null,
	"component-life-cycle": "outdated",
	"is-bespoke": false
}, {
	name: "Checkbox",
	path: "src/atoms/forms/Checkbox/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "GenericCheckbox",
			path: "Data/Capture/Checkboxes"
		}
	}]
}, {
	name: "CheckboxToggle",
	path: "src/atoms/forms/CheckboxToggle/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "Datepicker",
	path: "src/atoms/forms/Datepicker/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "Calendar",
			path: "Atoms/Forms"
		}
	}]
}, {
	name: "FieldDescription",
	path: "src/atoms/forms/FieldDescription/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "Input",
	path: "src/atoms/forms/Input/Input/package.json",
	"component-id": null,
	"component-life-cycle": "outdated",
	"is-bespoke": false
}, {
	name: "Prefix",
	path: "src/atoms/forms/Input/Prefix/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "Suffix",
	path: "src/atoms/forms/Input/Suffix/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "TextPrompt",
	path: "src/atoms/forms/Input/TextPrompt/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "InputClickable",
	path: "src/atoms/forms/InputClickable/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "InputRange",
	path: "src/atoms/forms/InputRange/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "LabelTitle",
	path: "src/atoms/forms/Label/LabelTitle/package.json",
	"component-id": "null",
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "GenericFieldWrapper",
			path: "Layout/FieldWrappers"
		}
	}]
}, {
	name: "Label",
	path: "src/atoms/forms/Label/package.json",
	"component-id": "null",
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "GenericFieldWrapper",
			path: "Layout/FieldWrappers"
		}
	}]
}, {
	name: "MediaCheckbox",
	path: "src/atoms/forms/MediaCheckbox/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "MediaRadio",
	path: "src/atoms/forms/MediaRadio/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "MultiSelect",
	path: "src/atoms/forms/MultiSelect/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "Radio",
	path: "src/atoms/forms/Radio/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "GenericRadio",
			path: "Data/Capture/Radios"
		}
	}]
}, {
	name: "RadioCard",
	path: "src/atoms/forms/RadioCard/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "GenericRadio",
			path: "Data/Capture/Radios"
		}
	}]
}, {
	name: "Select",
	path: "src/atoms/forms/Select/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "GenericSelect",
			path: "Data/Capture/Selects"
		}
	}]
}, {
	name: "Textarea",
	path: "src/atoms/forms/Textarea/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "GenericTextArea",
			path: "Data/Capture/TextAreas"
		}
	}]
}, {
	name: "TextAreaCharacterCount",
	path: "src/atoms/forms/TextAreaCharacterCount/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "GenericTextArea",
			path: "Data/Capture/TextAreas"
		}
	}]
}, {
	name: "TimeEstimationIcon",
	path: "src/atoms/forms/TimeEstimationIcon/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "AnimatedIcon",
	path: "src/atoms/iconography/AnimatedIcon/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "DistinctiveGeneratedSymbol",
	path: "src/atoms/iconography/DistinctiveGeneratedSymbol/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "Icon",
	path: "src/atoms/iconography/Icon/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "ChevronLeftSmall",
			replacement: "ChevronLeftSolidSmall",
			path: "Atoms/Iconography"
		}
	}, {
		replacements: {
			name: "crossOutlineLarge",
			replacement: "CrossOutlineLarge",
			path: "Atoms/Iconography"
		}
	}, {
		replacements: {
			name: "crossOutlineSmall",
			replacement: "CrossOutlineSmall",
			path: "Atoms/Iconography"
		}
	}, {
		replacements: {
			name: "crossOutlineSmall",
			replacement: "CrossOutlineSmall",
			path: "Atoms/Iconography"
		}
	}, {
		replacements: {
			name: "CrossRoundedSolidLarge",
			replacement: "CrossSolidLarge",
			path: "Atoms/Iconography"
		}
	}, {
		replacements: {
			name: "CrossRoundedSolidSmall",
			replacement: "CrossSolidSmall",
			path: "Atoms/Iconography"
		}
	}, {
		replacements: {
			name: "CycleSolidLarge",
			replacement: "CycleLarge",
			path: "Atoms/Iconography"
		}
	}, {
		replacements: {
			name: "CycleSolidSmall",
			replacement: "CycleSmall",
			path: "Atoms/Iconography"
		}
	}]
}, {
	name: "Divider",
	path: "src/atoms/layout/Divider/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "GenericDivider",
			path: "Layout/Content/Breaks"
		}
	}]
}, {
	name: "UploadPreviewContainer",
	path: "src/atoms/layout/UploadPreviewContainer/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "AndroidStoreLogo",
	path: "src/atoms/logo/AndroidStoreLogo/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "AppleStoreLogo",
	path: "src/atoms/logo/AppleStoreLogo/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "BankHeader",
	path: "src/atoms/logo/BankHeader/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "ContainedHeader",
			path: "Layout/Headers"
		}
	}]
}, {
	name: "BLogo",
	path: "src/atoms/logo/BLogo/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "BLogoCircular",
	path: "src/atoms/logo/BLogoCircular/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "CBLogo",
	path: "src/atoms/logo/CBLogo/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "CBLogoCircular",
	path: "src/atoms/logo/CBLogoCircular/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "Header",
	path: "src/atoms/logo/Header/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "ContainedHeader",
			path: "Layout/Headers"
		}
	}]
}, {
	name: "SwitchGuaranteeLogo",
	path: "src/atoms/logo/SwitchGuaranteeLogo/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "VMSecondaryRedLogo",
	path: "src/atoms/logo/VMSecondaryRedLogo/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "YBLogo",
	path: "src/atoms/logo/YBLogo/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "YBLogoCircular",
	path: "src/atoms/logo/YBLogoCircular/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "Popover",
	path: "src/atoms/popovers/Popover/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "IdentityProcessingSignal",
	path: "src/atoms/signals/IdentityProcessingSignal/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "UploadProcessingSignal",
	path: "src/atoms/signals/UploadProcessingSignal/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "BadgeLabel",
	path: "src/atoms/text/BadgeLabel/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "BulletedList",
	path: "src/atoms/text/BulletedList/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "BulletList",
			path: "Typography/Lists"
		}
	}]
}, {
	name: "Callout",
	path: "src/atoms/text/Callout/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "ConditionalPanel",
			path: "Layout/Content/Panels"
		}
	}]
}, {
	name: "List",
	path: "src/atoms/text/List/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "NumberedList",
	path: "src/atoms/text/NumberedList/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "NumberList",
			path: "Typography/Lists"
		}
	}]
}, {
	name: "StatusBadge",
	path: "src/atoms/text/StatusBadge/package.json",
	variants: ["Active", "Archived", "Inactive"],
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "TextBody",
	path: "src/atoms/text/TextBody/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "StandardBody",
			path: "Typography/Body"
		}
	}]
}, {
	name: "TextStyled",
	path: "src/atoms/text/TextStyled/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "Typography",
			path: "Typography"
		}
	}]
}, {
	name: "TheSmallPrint",
	path: "src/atoms/text/TheSmallPrint/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "SmallestBody",
			path: "Typography/Body"
		}
	}]
}, {
	name: "Title",
	path: "src/atoms/text/Title/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "Headings",
			path: "Typography"
		}
	}]
}, {
	name: "TransitionBlock",
	path: "src/atoms/transitions/TransitionBlock/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "EmailInput",
	path: "src/communication/email/text-inputs/EmailInput/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "Mail",
	path: "src/communication/messaging/Mail/package.json",
	variants: ["List", "Item", "ToolBar", "Header", "Body", "Empty"],
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "Webchat",
	path: "src/communication/support/Webchat/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "GenericCheckbox",
	path: "src/data/capture/checkboxes/GenericCheckbox/package.json",
	variants: ["InlineSet", "StackedSet"],
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": false,
		"dev-format": true,
		"tech-format": false
	}
}, {
	name: "StandaloneCheckbox",
	path: "src/data/capture/checkboxes/StandaloneCheckbox/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "AccountNumberInput",
	path: "src/data/capture/inputs/AccountNumberInput/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": false,
		"dev-format": true,
		"tech-format": false
	}
}, {
	name: "DateOfBirthInput",
	path: "src/data/capture/inputs/DateOfBirthInput/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": false,
		"dev-format": true,
		"tech-format": false
	}
}, {
	name: "FileUploadInput",
	path: "src/data/capture/inputs/FileUploadInput/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: true
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: true
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": true,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": false,
		"dev-format": true,
		"tech-format": true
	}
}, {
	name: "GenericAlphaNumericInput",
	path: "src/data/capture/inputs/GenericAlphaNumericInput/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": false,
		"dev-format": true,
		"tech-format": false
	}
}, {
	name: "GenericTextInput",
	path: "src/data/capture/inputs/GenericTextInput/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "GenericAlphaNumericInput",
			path: "Data/Capture/Inputs"
		}
	}]
}, {
	name: "LandlineNumberInput",
	path: "src/data/capture/inputs/LandlineNumberInput/package.json",
	"component-id": 1004,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": true,
			"firefox-desktop": true,
			"ie11-desktop": true
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": true,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "MoneyInput",
	path: "src/data/capture/inputs/MoneyInput/package.json",
	variants: ["PoundsOnly", "WithPence"],
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": false,
		"dev-format": true,
		"tech-format": false
	}
}, {
	name: "MonthAndYearDateInput",
	path: "src/data/capture/inputs/MonthAndYearDateInput/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": false,
		"dev-format": true,
		"tech-format": false
	}
}, {
	name: "SortcodeInput",
	path: "src/data/capture/inputs/SortcodeInput/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "UKOnlyMobileNumberInput",
	path: "src/data/capture/inputs/UKOnlyMobileNumberInput/package.json",
	"component-id": 1013,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": true,
			"firefox-desktop": true,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": true,
		"dev-format": true,
		"tech-format": false
	}
}, {
	name: "UKOnlyPostcodeInput",
	path: "src/data/capture/inputs/UKOnlyPostcodeInput/package.json",
	"component-id": 1006,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": false,
		"dev-format": true,
		"tech-format": false
	}
}, {
	name: "WorldwideMobileNumberInput",
	path: "src/data/capture/inputs/WorldwideMobileNumberInput/package.json",
	"component-id": 1011,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: true,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": true,
			"firefox-desktop": true,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": true,
		"dev-format": true,
		"tech-format": false
	}
}, {
	name: "YearsAndMonthsCountInput",
	path: "src/data/capture/inputs/YearsAndMonthsCountInput/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "DayOfMonthPicker",
	path: "src/data/capture/pickers/DayOfMonthPicker/package.json",
	"component-id": 949,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": true,
		"tech-format": false
	}
}, {
	name: "FileProgressTakeover",
	path: "src/data/capture/progress/FileProgressTakeover/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "GenericRadio",
	path: "src/data/capture/radios/GenericRadio/package.json",
	variants: ["InlineSet", "StackedSet"],
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": false,
		"dev-format": true,
		"tech-format": false
	}
}, {
	name: "GenericSelect",
	path: "src/data/capture/selects/GenericSelect/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": true,
			"firefox-desktop": true,
			"ie11-desktop": true
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": false,
		"dev-format": true,
		"tech-format": false
	}
}, {
	name: "GenericTextArea",
	path: "src/data/capture/text-areas/GenericTextArea/package.json",
	"component-id": 1001,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": true
	}
}, {
	name: "GenericPaginator",
	path: "src/data/filter-and-search/paginators/GenericPaginator/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "SearchTextInput",
	path: "src/data/filter-and-search/text-inputs/SearchTextInput/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "CompactDescriptionList",
	path: "src/data/lists/description-lists/CompactDescriptionList/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "GenericDescriptionList",
	path: "src/data/lists/description-lists/GenericDescriptionList/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": false,
		"dev-format": true,
		"tech-format": false
	}
}, {
	name: "NoResultsTile",
	path: "src/data/results/tiles/NoResultsTile/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "DocumentLink",
	path: "src/documents/navigation/links/DocumentLink/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": true,
	deprecations: [{
		replacements: {
			name: "ActionButton",
			path: "Actions/Buttons"
		}
	}]
}, {
	name: "DocumentLinkPlate",
	path: "src/documents/navigation/plates/DocumentLinkPlate/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": true,
	deprecations: [{
		replacements: {
			name: "Inline",
			path: "Layout/Grids"
		}
	}]
}, {
	name: "PrintButton",
	path: "src/documents/printing/buttons/PrintButton/package.json",
	variants: ["Bottom", "Inline", "Top"],
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": true,
	deprecations: [{
		replacements: {
			name: "ActionButton",
			path: "Actions/Buttons/ActionButton"
		}
	}]
}, {
	name: "DocumentStatusBandCard",
	path: "src/documents/statuses/cards/DocumentStatusBandCard/package.json",
	variants: ["Approved", "NotStarted", "Pending", "Rejected"],
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": true
}, {
	name: "FileInput",
	path: "src/documents/upload/FileInput/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": true,
	deprecations: [{
		replacements: {
			name: "FileUploadInput",
			path: "Data/Capture/Inputs"
		}
	}]
}, {
	name: "AccountCheckboxCard",
	path: "src/finance/accounts/cards/AccountCheckboxCard/package.json",
	variants: ["BankAccount", "CreditCard", "International"],
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "AccountLegacyUpdateCard",
	path: "src/finance/accounts/cards/AccountLegacyUpdateCard/package.json",
	"component-id": null,
	"component-life-cycle": "outdated",
	"is-bespoke": false
}, {
	name: "AccountLinkCard",
	path: "src/finance/accounts/cards/AccountLinkCard/package.json",
	variants: ["BankAccount", "CreditCard", "DebitCard", "International"],
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "AccountPoolCard",
	path: "src/finance/accounts/cards/AccountPoolCard/package.json",
	"component-id": 1058,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": false,
		"dev-format": true,
		"tech-format": false
	}
}, {
	name: "AccountSelectCard",
	path: "src/finance/accounts/cards/AccountSelectCard/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "AccountAuthorisationPanel",
	path: "src/finance/accounts/panels/AccountAuthorisationPanel/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "AccountBalancesSelectPanel",
	path: "src/finance/accounts/panels/AccountBalancesSelectPanel/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "AccountLegacyPanel",
	path: "src/finance/accounts/panels/AccountLegacyPanel/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "AccountBalancesSelectPanel",
			path: "Finance/Accounts/Panels"
		}
	}]
}, {
	name: "AccountPoolTablePanel",
	path: "src/finance/accounts/panels/AccountPoolTablePanel/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "AccountRadioCard",
	path: "src/finance/accounts/radios/AccountRadioCard/package.json",
	variants: ["BankAccount", "CreditCard", "Group"],
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "AccountPaymentReviewTable",
	path: "src/finance/accounts/tables/AccountPaymentReviewTable/package.json",
	variants: ["Authorisation", "Default", "Failed"],
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "AccountPaymentSubmittedTable",
	path: "src/finance/accounts/tables/AccountPaymentSubmittedTable/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "AccountPaymentTable",
	path: "src/finance/accounts/tables/AccountPaymentTable/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "AccountSummaryTile",
	path: "src/finance/accounts/tiles/AccountSummaryTile/package.json",
	variants: ["DebitCard"],
	"component-id": 1031,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": true,
		"dev-format": true,
		"tech-format": false
	}
}, {
	name: "CurrencySelect",
	path: "src/finance/currency/selects/CurrencySelect/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "FormInput",
	path: "src/forms/FormInput/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "BlockField",
	path: "src/global/layout/BlockField/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "BlockFieldColumn",
	path: "src/global/layout/BlockFieldColumn/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "CenterImageContainer",
	path: "src/global/layout/CenterImageContainer/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "Column",
	path: "src/global/layout/Column/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "Inline",
			path: "Layout/Grids"
		}
	}]
}, {
	name: "Container",
	path: "src/global/layout/Container/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "ContentContainer",
			path: "Layout/Sections"
		}
	}]
}, {
	name: "FlexColumn",
	path: "src/global/layout/FlexColumn/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "Inline",
			path: "Layout/Grids"
		}
	}]
}, {
	name: "FlexRow",
	path: "src/global/layout/FlexRow/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "Inline",
			path: "Layout/Grids"
		}
	}]
}, {
	name: "Frame",
	path: "src/global/layout/Frame/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "ApplicationFormShell",
			path: "Layout/Shells"
		}
	}]
}, {
	name: "InternalSlot",
	path: "src/global/layout/InternalSlot/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "LeftAndRightAlignment",
	path: "src/global/layout/LeftAndRightAlignment/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "Inline",
			path: "Layout/Grids"
		}
	}]
}, {
	name: "PageLayout",
	path: "src/global/layout/PageLayout/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "ApplicationFormShell",
			path: "Layout/Shells"
		}
	}]
}, {
	name: "HeaderSection",
	path: "src/global/layout/Pages/HeaderSection/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "ContainedHeader",
			path: "Layout/Headers"
		}
	}]
}, {
	name: "ServicingSection",
	path: "src/global/layout/Pages/ServicingSection/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "DataManagementShell",
			path: "Layout/Shells"
		}
	}]
}, {
	name: "WorkflowSection",
	path: "src/global/layout/Pages/WorkflowSection/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "ApplicationFormShell",
			path: "Layout/Shells"
		}
	}]
}, {
	name: "ResponsiveLayoutPair",
	path: "src/global/layout/ResponsiveLayoutPair/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "Inline",
			path: "Layout/Grids"
		}
	}]
}, {
	name: "Row",
	path: "src/global/layout/Row/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "Inline",
			path: "Layout/Grids"
		}
	}]
}, {
	name: "ContentContainer",
	path: "src/layout/containers/ContentContainer/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "ApplicationFormShell",
			path: "Layout/Shells"
		}
	}]
}, {
	name: "Main",
	path: "src/layout/containers/Main/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "ApplicationFormShell",
			path: "Layout/Shells/ApplicationFormShell"
		}
	}]
}, {
	name: "GenericAccordion",
	path: "src/layout/content/accordions/GenericAccordion/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: true
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": false,
		"dev-format": true,
		"tech-format": false
	}
}, {
	name: "StatusBanner",
	path: "src/layout/content/banners/StatusBanner/package.json",
	variants: ["Success", "Information", "Warning"],
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "GenericDivider",
	path: "src/layout/content/breaks/GenericDivider/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "GenericModal",
	path: "src/layout/content/modals/GenericModal/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": true,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": true,
		"dev-format": true,
		"tech-format": true
	}
}, {
	name: "InformationModal",
	path: "src/layout/content/modals/InformationModal/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": true,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": true,
		"dev-format": true,
		"tech-format": true
	}
}, {
	name: "MultiButtonModal",
	path: "src/layout/content/modals/MultiButtonModal/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": true,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": true,
		"dev-format": true,
		"tech-format": true
	}
}, {
	name: "BrandedPanel",
	path: "src/layout/content/panels/BrandedPanel/package.json",
	"component-id": 978,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": true,
		"dev-format": true,
		"tech-format": false
	}
}, {
	name: "ConditionalPanel",
	path: "src/layout/content/panels/ConditionalPanel/package.json",
	"component-id": 981,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": true,
		"dev-format": true,
		"tech-format": false
	}
}, {
	name: "ContentRevealPanel",
	path: "src/layout/content/panels/ContentRevealPanel/package.json",
	"component-id": 1005,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "SubformRevealPanel",
			path: "Layout/Content/Panels"
		}
	}]
}, {
	name: "InformationRevealPanel",
	path: "src/layout/content/panels/InformationRevealPanel/package.json",
	"component-id": 596,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": false,
		"dev-format": true,
		"tech-format": false
	}
}, {
	name: "ShellSidebarPanel",
	path: "src/layout/content/panels/ShellSidebarPanel/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": false,
		"dev-format": true,
		"tech-format": false
	}
}, {
	name: "SimplePanel",
	path: "src/layout/content/panels/SimplePanel/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": false,
		"dev-format": true,
		"tech-format": false
	}
}, {
	name: "StatusPanel",
	path: "src/layout/content/panels/StatusPanel/package.json",
	variants: ["Error", "Rejected", "Success", "Warning"],
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": false,
		"dev-format": true,
		"tech-format": false
	}
}, {
	name: "SubformRevealPanel",
	path: "src/layout/content/panels/SubformRevealPanel/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": true,
		"dev-format": true,
		"tech-format": false
	}
}, {
	name: "ToggleButtonPanel",
	path: "src/layout/content/panels/ToggleButtonPanel/package.json",
	"component-id": 823,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": false,
		"dev-format": true,
		"tech-format": false
	}
}, {
	name: "ProcessingScreenTakeover",
	path: "src/layout/content/takeovers/ProcessingScreenTakeover/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "AttentionTile",
	path: "src/layout/content/tiles/AttentionTile/package.json",
	variants: ["Blocker", "Empty", "FraudAwareness", "Warning"],
	"component-id": null,
	"component-life-cycle": "outdated",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "GuidanceTile",
	path: "src/layout/content/tiles/GuidanceTile/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "StandoutTile",
			path: "Layout/Content/Tiles"
		}
	}]
}, {
	name: "OutcomeTile",
	path: "src/layout/content/tiles/OutcomeTile/package.json",
	variants: ["Success"],
	"component-id": 1049,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: true
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": true,
			"firefox-desktop": true,
			"ie11-desktop": true
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": false,
		"dev-format": true,
		"tech-format": true
	}
}, {
	name: "RecapTile",
	path: "src/layout/content/tiles/RecapTile/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "StandoutTile",
			path: "Layout/Content/Tiles"
		}
	}]
}, {
	name: "StandoutTile",
	path: "src/layout/content/tiles/StandoutTile/package.json",
	variants: ["Important", "Guidance", "Remember", "Tip"],
	"component-id": 1048,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: true
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": false,
		"dev-format": true,
		"tech-format": false
	}
}, {
	name: "ValidationMessageTile",
	path: "src/layout/content/tiles/ValidationMessageTile/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "GridViewToggle",
	path: "src/layout/content/views/GridViewToggle/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "GenericFieldWrapper",
	path: "src/layout/fieldWrappers/GenericFieldWrapper/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "MainFixedFooter",
	path: "src/layout/footers/MainFixedFooter/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "Grid",
	path: "src/layout/grids/Grid/package.json",
	variants: ["FullWidth", "TwoThirds"],
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "Inline",
	path: "src/layout/grids/Inline/package.json",
	variants: ["Centered", "Justified", "LeftAligned", "RightAligned"],
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: true
		},
		auditory: {
			voiceover: true
		},
		"motor-skills": {
			autocomplete: true,
			keyboard: true
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": true,
			"function-set": true
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": false,
		"dev-format": true,
		"tech-format": false
	}
}, {
	name: "ContainedHeader",
	path: "src/layout/headers/ContainedHeader/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "FixedFooter",
	path: "src/layout/sections/footers/FixedFooter/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "MainFixedFooter",
			path: "Layout/Footers"
		}
	}]
}, {
	name: "ApplicationFormShell",
	path: "src/layout/shells/ApplicationFormShell/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "DataManagementShell",
	path: "src/layout/shells/DataManagementShell/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "ShellInnerSpacer",
	path: "src/layout/shells/ShellInnerSpacer/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "VerticalReviewTable",
	path: "src/layout/tables/VerticalReviewTable/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "NonUKAddressFieldset",
	path: "src/location/addresses/fieldsets/NonUKAddressFieldset/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "UKAddressFieldset",
	path: "src/location/addresses/fieldsets/UKAddressFieldset/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "UKAddressCaptureModule",
	path: "src/location/addresses/modules/UKAddressCaptureModule/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "UKAddressCaptureModule2",
	path: "src/location/addresses/modules/UKAddressCaptureModule2/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "BaseSelect",
	path: "src/location/places/selects/BaseSelect/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "CountrySelect",
	path: "src/location/places/selects/CountrySelect/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "UKCitySelect",
	path: "src/location/places/selects/UKCitySelect/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "AccordionItem",
	path: "src/molecules/accordions/Accordion/AccordionItem/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "GenericAccordion",
			path: "Layout/Content/Accordions"
		}
	}]
}, {
	name: "Accordion",
	path: "src/molecules/accordions/Accordion/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "GenericAccordion",
			path: "Layout/Content/Accordions"
		}
	}]
}, {
	name: "AccordionTable",
	path: "src/molecules/accordions/AccordionTable/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "GenericAccordion",
			path: "Layout/Content/Accordions"
		}
	}]
}, {
	name: "ContentReveal",
	path: "src/molecules/accordions/ContentReveal/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "ContentRevealPanel",
			path: "Layout/Content/Panels"
		}
	}]
}, {
	name: "ExpansionPanel",
	path: "src/molecules/accordions/ExpansionPanel/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "ContentRevealPanel",
			path: "Layout/Content/Panels"
		}
	}]
}, {
	name: "ExpansionTable",
	path: "src/molecules/accordions/ExpansionTable/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "ContentRevealPanel",
			path: "Layout/Content/Panels"
		}
	}]
}, {
	name: "ButtonGroup",
	path: "src/molecules/buttons/ButtonGroup/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: [{
			name: "NavigationButtonGroup",
			path: "Navigation/Buttons"
		}, {
			name: "Inline",
			path: "Layout/Grids"
		}]
	}]
}, {
	name: "SortingCardGroup",
	path: "src/molecules/card-groups/SortingCardGroup/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "AccountCard",
	path: "src/molecules/cards/AccountCard/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "AccountSummaryLinkCard",
	path: "src/molecules/cards/AccountSummaryLinkCard/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "DateCard",
	path: "src/molecules/cards/DateCard/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "PromoCard",
	path: "src/molecules/cards/PromoCard/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "StackingCard",
	path: "src/molecules/cards/StackingCard/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "Autocomplete",
	path: "src/molecules/forms/Autocomplete/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "ConfirmationCheckbox",
	path: "src/molecules/forms/ConfirmationCheckbox/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "StandaloneCheckbox",
			path: "Data/Capture/Checkboxes"
		}
	}]
}, {
	name: "DaySelector",
	path: "src/molecules/forms/DaySelector/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "GenericRadio",
			path: "Data/Capture/Radios"
		}
	}]
}, {
	name: "FieldBody",
	path: "src/molecules/forms/Field/FieldBody/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "GenericFieldWrapper",
			path: "Layout/FieldWrappers"
		}
	}]
}, {
	name: "FieldHeader",
	path: "src/molecules/forms/Field/FieldHeader/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "GenericFieldWrapper",
			path: "Layout/FieldWrappers"
		}
	}]
}, {
	name: "FormField",
	path: "src/molecules/forms/Field/FormField/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "Field",
	path: "src/molecules/forms/Field/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "GenericFieldWrapper",
			path: "Layout/FieldWrappers"
		}
	}]
}, {
	name: "PasswordReveal",
	path: "src/molecules/forms/PasswordReveal/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "RadioCardGroup",
	path: "src/molecules/forms/RadioCardGroup/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "GenericRadio",
			path: "Data/Capture/Radios"
		}
	}]
}, {
	name: "Search",
	path: "src/molecules/forms/Search/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "SearchForm",
	path: "src/molecules/forms/SearchForm/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "SegmentedControl",
	path: "src/molecules/forms/SegmentedControl/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "SegmentedControlItem",
	path: "src/molecules/forms/SegmentedControl/SegmentedControlItem/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "SegmentedSlider",
	path: "src/molecules/forms/SegmentedSlider/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "TickMarks",
	path: "src/molecules/forms/SegmentedSlider/TickMarks/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "ValidationMessage",
	path: "src/molecules/forms/ValidationMessage/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "ValidationMessageTile",
			path: "Layout/Tiles"
		}
	}]
}, {
	name: "IconTextDynamic",
	path: "src/molecules/icon-text-dynamic/IconTextDynamic/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "IconText",
	path: "src/molecules/icon-text/IconText/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "IconTextDynamic",
			path: "Molecules/IconTextDynamic"
		}
	}]
}, {
	name: "BackAnchor",
	path: "src/molecules/navigation/BackAnchor/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "WebsiteLink",
			path: "Actions/Links"
		}
	}]
}, {
	name: "BackButton",
	path: "src/molecules/navigation/BackButton/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "UtilityNavButton",
			path: "Navigation/Site-navs"
		}
	}]
}, {
	name: "Utility",
	path: "src/molecules/navigation/Utility/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "UtilityNav",
			path: "Navigation/Site-Navs/UtilityNav"
		}
	}]
}, {
	name: "Alert",
	path: "src/molecules/nbas/Alert/package.json",
	"component-id": null,
	"component-life-cycle": "outdated",
	"is-bespoke": false
}, {
	name: "Promo",
	path: "src/molecules/nbas/Promo/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "ContrastingFormPanel",
	path: "src/molecules/panels/ContrastingFormPanel/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "DocumentAction",
	path: "src/molecules/panels/DocumentAction/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "IconifiedBulletPoint",
	path: "src/molecules/panels/IconifiedBulletPoint/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "Panel",
	path: "src/molecules/panels/Panel/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "PanelBody",
	path: "src/molecules/panels/Panel/PanelBody/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "PanelFooter",
	path: "src/molecules/panels/Panel/PanelFooter/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "PanelHeader",
	path: "src/molecules/panels/Panel/PanelHeader/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "PanelSector",
	path: "src/molecules/panels/Panel/PanelSector/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "SettingLink",
	path: "src/molecules/panels/SettingLink/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "SubordinatePanel",
	path: "src/molecules/panels/SubordinatePanel/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "ConditionalPanel",
			path: "Layout/Content/Panels"
		}
	}]
}, {
	name: "TogglePanel",
	path: "src/molecules/panels/TogglePanel/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "PayeeCard",
	path: "src/molecules/payee-cards/PayeeCard/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "PaymentReview",
	path: "src/molecules/payments/PaymentReview/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "ProgressIndicator",
	path: "src/molecules/progress/ProgressIndicator/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "ProgressStepper",
			path: "Navigation/Indicators"
		}
	}]
}, {
	name: "ProgressIndicatorItem",
	path: "src/molecules/progress/ProgressIndicator/ProgressIndicatorItem/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "ProgressStepper",
			path: "Navigation/Indicators"
		}
	}]
}, {
	name: "ComparisonTable",
	path: "src/molecules/tables/ComparisonTable/package.json",
	"component-id": null,
	"component-life-cycle": "outdated",
	"is-bespoke": false
}, {
	name: "DataTable",
	path: "src/molecules/tables/Table/DataTable/package.json",
	"component-id": null,
	"component-life-cycle": "outdated",
	"is-bespoke": false
}, {
	name: "Table",
	path: "src/molecules/tables/Table/Table/package.json",
	"component-id": null,
	"component-life-cycle": "outdated",
	"is-bespoke": false
}, {
	name: "TableBody",
	path: "src/molecules/tables/Table/TableBody/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "TableBodyData",
	path: "src/molecules/tables/Table/TableBodyData/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "TableHead",
	path: "src/molecules/tables/Table/TableHead/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "TableHeadData",
	path: "src/molecules/tables/Table/TableHeadData/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "TableRow",
	path: "src/molecules/tables/Table/TableRow/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "SectionHeading",
	path: "src/molecules/text/SectionHeading/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "SectionHeading",
			path: "Typography/Headings"
		}
	}]
}, {
	name: "ConfirmationTile",
	path: "src/molecules/tile/ConfirmationTile/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "OutcomeTile",
			path: "Layout/Content/Tiles"
		}
	}]
}, {
	name: "ExclamationTile",
	path: "src/molecules/tile/ExclamationTile/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "HighlightTile",
	path: "src/molecules/tile/HighlightTile/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "StandoutTile",
			path: "Layout/Content/Tiles"
		}
	}]
}, {
	name: "IconTile",
	path: "src/molecules/tile/IconTile/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "OutcomeTile",
			path: "Layout/Content/Tiles"
		}
	}]
}, {
	name: "NumberedTile",
	path: "src/molecules/tile/NumberedTile/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "Tile",
	path: "src/molecules/tile/Tile/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "TileSector",
	path: "src/molecules/tile/Tile/TileSector/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "TileSegment",
	path: "src/molecules/tile/Tile/TileSegment/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "ToggleOption",
	path: "src/molecules/toggle/ToggleOption/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "NavigationButton",
	path: "src/navigation/buttons/NavigationButton/package.json",
	variants: ["Back", "Cancel", "Confirm", "Continue", "Next", "Primary", "Secondary", "Submit", "Tertiary"],
	"component-id": 812,
	"component-life-cycle": "active",
	"is-bespoke": false,
	deprecations: [{
		variants: ["Confirm", "Continue", "Next", "Submit"],
		replacements: {
			name: "NavigationButton",
			path: "Navigation/Buttons",
			variant: "Primary"
		}
	}, {
		variants: ["Back"],
		replacements: {
			name: "NavigationButton",
			path: "Navigation/Buttons",
			variant: "Secondary"
		}
	}, {
		variants: ["Cancel"],
		replacements: {
			name: "NavigationButton",
			path: "Navigation/Buttons",
			variant: "Tertiary"
		}
	}],
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: true
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "NavigationButtonGroup",
	path: "src/navigation/buttons/NavigationButtonGroup/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "ProgressStepper",
	path: "src/navigation/indicators/ProgressStepper/package.json",
	"component-id": 893,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: true
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": true,
		"dev-format": true,
		"tech-format": true
	}
}, {
	name: "MainNavLink",
	path: "src/navigation/nav-links/MainNavLink/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "Paginator",
	path: "src/navigation/pagination/Paginator/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "PaginatorNextButton",
	path: "src/navigation/pagination/Paginator/PaginatorNextButton/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "PaginatorPageButton",
	path: "src/navigation/pagination/Paginator/PaginatorPageButton/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "PaginatorPreviousButton",
	path: "src/navigation/pagination/Paginator/PaginatorPreviousButton/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "MainSiteNav",
	path: "src/navigation/site-navs/MainSiteNav/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "MobileMainSiteNav",
	path: "src/navigation/site-navs/MobileMainSiteNav/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "UtilityNav",
	path: "src/navigation/site-navs/UtilityNav/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "UtilityNavButton",
	path: "src/navigation/site-navs/UtilityNavButton/package.json",
	variants: ["Back", "Help"],
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: true
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": false,
		"dev-format": true,
		"tech-format": true
	}
}, {
	name: "TabCard",
	path: "src/navigation/tab-cards/TabCard/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "TabCardBlock",
	path: "src/navigation/tab-cards/TabCardBlock/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "TabCardSmall",
	path: "src/navigation/tab-cards/TabCardSmall/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "TabGroup",
	path: "src/navigation/tab-group/TabGroup/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "TabButton",
	path: "src/navigation/tab-group/TabGroup/TabButton/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "TransferTakeover",
	path: "src/navigation/takeovers/TransferTakeover/package.json",
	variants: ["Incoming", "Outgoing"],
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "Card",
	path: "src/organisms/cards/Card/package.json",
	"component-id": null,
	"component-life-cycle": "outdated",
	"is-bespoke": false
}, {
	name: "DistinctiveLinkCard",
	path: "src/organisms/cards/DistinctiveLinkCard/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "FilterAction",
	path: "src/organisms/filters/Filter/FilterActionGroup/FilterAction/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "FilterActionGroup",
	path: "src/organisms/filters/Filter/FilterActionGroup/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "FilterSector",
	path: "src/organisms/filters/Filter/FilterSector/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "FilterSegment",
	path: "src/organisms/filters/Filter/FilterSegmentGroup/FilterSegment/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "FilterSegmentGroup",
	path: "src/organisms/filters/Filter/FilterSegmentGroup/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "FilterSubSegment",
	path: "src/organisms/filters/Filter/FilterSubSegmentGroup/FilterSubSegment/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "FilterSubSegmentGroup",
	path: "src/organisms/filters/Filter/FilterSubSegmentGroup/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "Filter",
	path: "src/organisms/filters/Filter/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "GlobalHeader",
	path: "src/organisms/global/GlobalHeader/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "ContainedHeader",
			path: "Layout/Headers"
		}
	}]
}, {
	name: "HeroHeader",
	path: "src/organisms/global/HeroHeader/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "CentredModal",
	path: "src/organisms/modals/CentredModal/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "ConfirmationModal",
			path: "Organisms/Modals"
		}
	}]
}, {
	name: "ConfirmationModal",
	path: "src/organisms/modals/ConfirmationModal/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "GenericModal",
			path: "Layout/Content/Modals"
		}
	}]
}, {
	name: "Loader",
	path: "src/organisms/modals/Loader/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "ModalBody",
	path: "src/organisms/modals/Modal/ModalBody/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "ModalContainer",
	path: "src/organisms/modals/Modal/ModalContainer/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "ModalHeader",
	path: "src/organisms/modals/Modal/ModalHeader/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "Modal",
	path: "src/organisms/modals/Modal/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "ConfirmationModal",
			path: "Organisms/Modals"
		}
	}]
}, {
	name: "UnfinishedWorkModal",
	path: "src/organisms/modals/UnfinishedWorkModal/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "DisableTakeover",
	path: "src/organisms/takeovers/DisableTakeover/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "LoadingLocalTakeover",
	path: "src/organisms/takeovers/LoadingLocalTakeover/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "Timeline",
	path: "src/organisms/timelines/Timeline/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "LoanReasonSelector",
	path: "src/products/selection/LoanReasonSelector/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": true,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": false,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": true,
			"firefox-desktop": true,
			"ie11-desktop": true
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "ProductSelector",
	path: "src/products/selection/ProductSelector/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": true
}, {
	name: "EmailCreationInput",
	path: "src/security/authentication/inputs/EmailCreationInput/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "PasswordCreationInput",
	path: "src/security/authentication/inputs/PasswordCreationInput/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "CallButton",
	path: "src/telephony/Buttons/CallButton/package.json",
	variants: ["Answer", "Close", "Conference", "Dial", "End", "Hold", "Resume", "Retrieve", "Transfer"],
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": true
}, {
	name: "CallStatus",
	path: "src/telephony/Statuses/CallStatus/package.json",
	variants: ["AnswerCall", "ConferenceCall", "ConferenceMaskCall", "DialingCall", "HoldCall", "MakeCall", "OnCall"],
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": true
}, {
	name: "Footer",
	path: "src/typography/ancillary/Footer/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "LargeBody",
	path: "src/typography/body/LargeBody/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "SecondaryBody",
	path: "src/typography/body/SecondaryBody/package.json",
	"component-id": 1070,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": true,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": true,
		"dev-format": true,
		"tech-format": false
	}
}, {
	name: "SmallestBody",
	path: "src/typography/body/SmallestBody/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "StandardBody",
	path: "src/typography/body/StandardBody/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": true,
		"dev-format": true,
		"tech-format": true
	}
}, {
	name: "SubBody",
	path: "src/typography/body/SubBody/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "PageHeading",
	path: "src/typography/headings/PageHeading/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "SectionHeading",
	path: "src/typography/headings/SectionHeading/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "SubHeading",
	path: "src/typography/headings/SubHeading/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "SubsectionHeading",
	path: "src/typography/headings/SubsectionHeading/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "LargeHero",
	path: "src/typography/heros/LargeHero/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "Typography",
			path: "Typography"
		}
	}]
}, {
	name: "StandardHero",
	path: "src/typography/heros/StandardHero/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "Typography",
			path: "Typography"
		}
	}]
}, {
	name: "IndicativeHighlight",
	path: "src/typography/highlights/IndicativeHighlight/package.json",
	variants: ["Value", "Description"],
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "StateIndicator",
	path: "src/typography/indicators/StateIndicator/package.json",
	variants: ["Active", "Editing", "Inactive", "Incomplete", "Locked", "Pending", "Spacer", "Unedited"],
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "FieldLabel",
	path: "src/typography/labels/FieldLabel/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "ProminentLabel",
	path: "src/typography/labels/ProminentLabel/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "StandardLabel",
	path: "src/typography/labels/StandardLabel/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "SubLabel",
	path: "src/typography/labels/SubLabel/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "BulletList",
	path: "src/typography/lists/BulletList/package.json",
	"component-id": 980,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "NegativeList",
	path: "src/typography/lists/NegativeList/package.json",
	"component-id": 1065,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "NumberList",
	path: "src/typography/lists/NumberList/package.json",
	"component-id": 1003,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": false,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "PositiveList",
	path: "src/typography/lists/PositiveList/package.json",
	"component-id": 1064,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "TickList",
	path: "src/typography/lists/TickList/package.json",
	"component-id": 1047,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "Identifier",
	path: "src/typography/modifiers/Identifier/package.json",
	variants: ["Breaking", "NonWrapping", "Truncated"],
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "AbbreviatedTag",
	path: "src/typography/tags/AbbreviatedTag/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "StatusTag",
	path: "src/typography/tags/StatusTag/package.json",
	variants: ["ErrorMajor", "ErrorMinor", "NotStarted", "Ongoing", "Paused", "Success", "WarningMajor", "WarningMinor"],
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "ValueTag",
	path: "src/typography/tags/ValueTag/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "ProminentValue",
	path: "src/typography/values/ProminentValue/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"'style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "StandardValue",
	path: "src/typography/values/StandardValue/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "UserStatusBandCard",
	path: "src/users/business-users/cards/UserStatusBandCard/package.json",
	variants: ["Active", "Group", "Pending"],
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": true
}, {
	name: "Banking",
	path: "src/utilities/Banking/package.json"
}, {
	name: "VMLoader",
	path: "src/utilities/components/VMLoader/package.json"
}, {
	name: "String",
	path: "src/utilities/String/package.json"
}, {
	name: "component-with-theme",
	path: "src/utilities/themes/component-with-theme/package.json"
}, {
	name: "WebUIThemeProvider",
	path: "src/utilities/themes/WebUIThemeProvider/package.json"
}];

var deprecated = [{
	name: "InputRadio",
	path: "src/actions/radios/InputRadio/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericRadio",
			path: "Data/Capture/Radios"
		}
	}],
	deprecationVersion: "23.4.0",
	deprecationDate: "February 17 2020"
}, {
	name: "InputRadioGroup",
	path: "src/actions/radios/InputRadioGroup/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericRadio",
			path: "Data/Capture/Radios"
		}
	}],
	deprecationVersion: "23.4.0",
	deprecationDate: "February 17 2020"
}, {
	name: "Anchor",
	path: "src/atoms/buttons/Anchor/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "WebsiteLink",
			path: "Actions/Links"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "Button",
	path: "src/atoms/buttons/Button/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: [{
			name: "ActionButton",
			path: "Actions/Buttons"
		}, {
			name: "NavigationButton",
			path: "Navigation/Buttons"
		}]
	}],
	deprecationVersion: "27.4.1",
	deprecationDate: "September 10 2020"
}, {
	name: "Checkbox",
	path: "src/atoms/forms/Checkbox/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericCheckbox",
			path: "Data/Capture/Checkboxes"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "Datepicker",
	path: "src/atoms/forms/Datepicker/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Calendar",
			path: "Atoms/Forms"
		}
	}],
	deprecationVersion: "7.3.0",
	deprecationDate: "August 30 2018"
}, {
	name: "LabelTitle",
	path: "src/atoms/forms/Label/LabelTitle/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericFieldWrapper",
			path: "Layout/FieldWrappers"
		}
	}],
	deprecationVersion: "27.6.0",
	deprecationDate: "November 20 2020"
}, {
	name: "Label",
	path: "src/atoms/forms/Label/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericFieldWrapper",
			path: "Layout/FieldWrappers"
		}
	}],
	deprecationVersion: "27.6.0",
	deprecationDate: "November 20 2020"
}, {
	name: "Radio",
	path: "src/atoms/forms/Radio/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericRadio",
			path: "Data/Capture/Radios"
		}
	}],
	deprecationVersion: "23.2.0",
	deprecationDate: "February 06 2020"
}, {
	name: "RadioCard",
	path: "src/atoms/forms/RadioCard/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericRadio",
			path: "Data/Capture/Radios"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "Select",
	path: "src/atoms/forms/Select/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericSelect",
			path: "Data/Capture/Selects"
		}
	}],
	deprecationVersion: "24.0.0",
	deprecationDate: "February 27 2020"
}, {
	name: "Textarea",
	path: "src/atoms/forms/Textarea/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericTextArea",
			path: "Data/Capture/TextAreas"
		}
	}],
	deprecationVersion: "19.0.0",
	deprecationDate: "May 03 2019"
}, {
	name: "TextAreaCharacterCount",
	path: "src/atoms/forms/TextAreaCharacterCount/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericTextArea",
			path: "Data/Capture/TextAreas"
		}
	}],
	deprecationVersion: "20.0.0",
	deprecationDate: "May 15 2019"
}, {
	name: "Icon",
	path: "src/atoms/iconography/Icon/package.json",
	"component-life-cycle": "active",
	deprecations: [{
		replacements: {
			name: "ChevronLeftSmall",
			replacement: "ChevronLeftSolidSmall",
			path: "Atoms/Iconography"
		}
	}, {
		replacements: {
			name: "crossOutlineLarge",
			replacement: "CrossOutlineLarge",
			path: "Atoms/Iconography"
		}
	}, {
		replacements: {
			name: "crossOutlineSmall",
			replacement: "CrossOutlineSmall",
			path: "Atoms/Iconography"
		}
	}, {
		replacements: {
			name: "crossOutlineSmall",
			replacement: "CrossOutlineSmall",
			path: "Atoms/Iconography"
		}
	}, {
		replacements: {
			name: "CrossRoundedSolidLarge",
			replacement: "CrossSolidLarge",
			path: "Atoms/Iconography"
		}
	}, {
		replacements: {
			name: "CrossRoundedSolidSmall",
			replacement: "CrossSolidSmall",
			path: "Atoms/Iconography"
		}
	}, {
		replacements: {
			name: "CycleSolidLarge",
			replacement: "CycleLarge",
			path: "Atoms/Iconography"
		}
	}, {
		replacements: {
			name: "CycleSolidSmall",
			replacement: "CycleSmall",
			path: "Atoms/Iconography"
		}
	}]
}, {
	name: "Divider",
	path: "src/atoms/layout/Divider/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericDivider",
			path: "Layout/Content/Breaks"
		}
	}],
	deprecationVersion: "23.1.0",
	deprecationDate: "January 31 2020"
}, {
	name: "BankHeader",
	path: "src/atoms/logo/BankHeader/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ContainedHeader",
			path: "Layout/Headers"
		}
	}],
	deprecationVersion: "23.1.0",
	deprecationDate: "January 31 2020"
}, {
	name: "Header",
	path: "src/atoms/logo/Header/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ContainedHeader",
			path: "Layout/Headers"
		}
	}],
	deprecationVersion: "23.1.0",
	deprecationDate: "January 31 2020"
}, {
	name: "BulletedList",
	path: "src/atoms/text/BulletedList/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "BulletList",
			path: "Typography/Lists"
		}
	}],
	deprecationVersion: "23.1.0",
	deprecationDate: "January 31 2020"
}, {
	name: "Callout",
	path: "src/atoms/text/Callout/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ConditionalPanel",
			path: "Layout/Content/Panels"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "NumberedList",
	path: "src/atoms/text/NumberedList/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "NumberList",
			path: "Typography/Lists"
		}
	}],
	deprecationVersion: "24.0.0",
	deprecationDate: "February 27 2020"
}, {
	name: "TextBody",
	path: "src/atoms/text/TextBody/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "StandardBody",
			path: "Typography/Body"
		}
	}],
	deprecationVersion: "22.3.0",
	deprecationDate: "August 05 2019"
}, {
	name: "TextStyled",
	path: "src/atoms/text/TextStyled/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Typography",
			path: "Typography"
		}
	}],
	deprecationVersion: "22.3.0",
	deprecationDate: "August 05 2019"
}, {
	name: "TheSmallPrint",
	path: "src/atoms/text/TheSmallPrint/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "SmallestBody",
			path: "Typography/Body"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "Title",
	path: "src/atoms/text/Title/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Headings",
			path: "Typography"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "GenericTextInput",
	path: "src/data/capture/inputs/GenericTextInput/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericAlphaNumericInput",
			path: "Data/Capture/Inputs"
		}
	}],
	deprecationVersion: "25.1.0",
	deprecationDate: "March 23 2020"
}, {
	name: "DocumentLink",
	path: "src/documents/navigation/links/DocumentLink/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ActionButton",
			path: "Actions/Buttons"
		}
	}],
	deprecationVersion: "27.3.0",
	deprecationDate: "September 01 2020"
}, {
	name: "DocumentLinkPlate",
	path: "src/documents/navigation/plates/DocumentLinkPlate/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Inline",
			path: "Layout/Grids"
		}
	}],
	deprecationVersion: "27.3.0",
	deprecationDate: "September 01 2020"
}, {
	name: "PrintButton",
	path: "src/documents/printing/buttons/PrintButton/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ActionButton",
			path: "Actions/Buttons/ActionButton"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "FileInput",
	path: "src/documents/upload/FileInput/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "FileUploadInput",
			path: "Data/Capture/Inputs"
		}
	}],
	deprecationVersion: "27.6.0",
	deprecationDate: "November 20 2020"
}, {
	name: "AccountLegacyPanel",
	path: "src/finance/accounts/panels/AccountLegacyPanel/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "AccountBalancesSelectPanel",
			path: "Finance/Accounts/Panels"
		}
	}],
	deprecationVersion: "22.1.0",
	deprecationDate: "July 17 2019"
}, {
	name: "Column",
	path: "src/global/layout/Column/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Inline",
			path: "Layout/Grids"
		}
	}],
	deprecationVersion: "27.5.0",
	deprecationDate: "October 30 2020"
}, {
	name: "Container",
	path: "src/global/layout/Container/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ContentContainer",
			path: "Layout/Sections"
		}
	}],
	deprecationVersion: "23.1.0",
	deprecationDate: "January 31 2020"
}, {
	name: "FlexColumn",
	path: "src/global/layout/FlexColumn/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Inline",
			path: "Layout/Grids"
		}
	}],
	deprecationVersion: "27.5.0",
	deprecationDate: "October 30 2020"
}, {
	name: "FlexRow",
	path: "src/global/layout/FlexRow/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Inline",
			path: "Layout/Grids"
		}
	}],
	deprecationVersion: "27.5.0",
	deprecationDate: "October 30 2020"
}, {
	name: "Frame",
	path: "src/global/layout/Frame/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ApplicationFormShell",
			path: "Layout/Shells"
		}
	}],
	deprecationVersion: "27.4.0",
	deprecationDate: "September 07 2020"
}, {
	name: "LeftAndRightAlignment",
	path: "src/global/layout/LeftAndRightAlignment/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Inline",
			path: "Layout/Grids"
		}
	}],
	deprecationVersion: "27.4.0",
	deprecationDate: "September 07 2020"
}, {
	name: "PageLayout",
	path: "src/global/layout/PageLayout/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ApplicationFormShell",
			path: "Layout/Shells"
		}
	}],
	deprecationVersion: "27.4.0",
	deprecationDate: "September 07 2020"
}, {
	name: "HeaderSection",
	path: "src/global/layout/Pages/HeaderSection/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ContainedHeader",
			path: "Layout/Headers"
		}
	}],
	deprecationVersion: "23.1.0",
	deprecationDate: "January 31 2020"
}, {
	name: "ServicingSection",
	path: "src/global/layout/Pages/ServicingSection/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "DataManagementShell",
			path: "Layout/Shells"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "WorkflowSection",
	path: "src/global/layout/Pages/WorkflowSection/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ApplicationFormShell",
			path: "Layout/Shells"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "ResponsiveLayoutPair",
	path: "src/global/layout/ResponsiveLayoutPair/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Inline",
			path: "Layout/Grids"
		}
	}],
	deprecationVersion: "27.2.2",
	deprecationDate: "July 31 2020"
}, {
	name: "Row",
	path: "src/global/layout/Row/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Inline",
			path: "Layout/Grids"
		}
	}],
	deprecationVersion: "27.5.0",
	deprecationDate: "October 30 2020"
}, {
	name: "ContentContainer",
	path: "src/layout/containers/ContentContainer/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ApplicationFormShell",
			path: "Layout/Shells"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "Main",
	path: "src/layout/containers/Main/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ApplicationFormShell",
			path: "Layout/Shells/ApplicationFormShell"
		}
	}],
	deprecationVersion: "23.1.0",
	deprecationDate: "January 31 2020"
}, {
	name: "ContentRevealPanel",
	path: "src/layout/content/panels/ContentRevealPanel/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "SubformRevealPanel",
			path: "Layout/Content/Panels"
		}
	}],
	deprecationVersion: "27.7.0",
	deprecationDate: "December 16 2020"
}, {
	name: "GuidanceTile",
	path: "src/layout/content/tiles/GuidanceTile/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "StandoutTile",
			path: "Layout/Content/Tiles"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "RecapTile",
	path: "src/layout/content/tiles/RecapTile/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "StandoutTile",
			path: "Layout/Content/Tiles"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "FixedFooter",
	path: "src/layout/sections/footers/FixedFooter/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "MainFixedFooter",
			path: "Layout/Footers"
		}
	}],
	deprecationVersion: "23.1.0",
	deprecationDate: "January 31 2020"
}, {
	name: "AccordionItem",
	path: "src/molecules/accordions/Accordion/AccordionItem/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericAccordion",
			path: "Layout/Content/Accordions"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "Accordion",
	path: "src/molecules/accordions/Accordion/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericAccordion",
			path: "Layout/Content/Accordions"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "AccordionTable",
	path: "src/molecules/accordions/AccordionTable/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericAccordion",
			path: "Layout/Content/Accordions"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "ContentReveal",
	path: "src/molecules/accordions/ContentReveal/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ContentRevealPanel",
			path: "Layout/Content/Panels"
		}
	}],
	deprecationVersion: "24.1.0",
	deprecationDate: "March 05 2020"
}, {
	name: "ExpansionPanel",
	path: "src/molecules/accordions/ExpansionPanel/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ContentRevealPanel",
			path: "Layout/Content/Panels"
		}
	}],
	deprecationVersion: "27.3.0",
	deprecationDate: "September 01 2020"
}, {
	name: "ExpansionTable",
	path: "src/molecules/accordions/ExpansionTable/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ContentRevealPanel",
			path: "Layout/Content/Panels"
		}
	}],
	deprecationVersion: "27.3.0",
	deprecationDate: "September 01 2020"
}, {
	name: "ButtonGroup",
	path: "src/molecules/buttons/ButtonGroup/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: [{
			name: "NavigationButtonGroup",
			path: "Navigation/Buttons"
		}, {
			name: "Inline",
			path: "Layout/Grids"
		}]
	}],
	deprecationVersion: "27.4.1",
	deprecationDate: "September 10 2020"
}, {
	name: "ConfirmationCheckbox",
	path: "src/molecules/forms/ConfirmationCheckbox/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "StandaloneCheckbox",
			path: "Data/Capture/Checkboxes"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "DaySelector",
	path: "src/molecules/forms/DaySelector/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericRadio",
			path: "Data/Capture/Radios"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "FieldBody",
	path: "src/molecules/forms/Field/FieldBody/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericFieldWrapper",
			path: "Layout/FieldWrappers"
		}
	}],
	deprecationVersion: "27.4.0",
	deprecationDate: "September 07 2020"
}, {
	name: "FieldHeader",
	path: "src/molecules/forms/Field/FieldHeader/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericFieldWrapper",
			path: "Layout/FieldWrappers"
		}
	}],
	deprecationVersion: "27.4.0",
	deprecationDate: "September 07 2020"
}, {
	name: "Field",
	path: "src/molecules/forms/Field/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericFieldWrapper",
			path: "Layout/FieldWrappers"
		}
	}],
	deprecationVersion: "27.4.0",
	deprecationDate: "September 07 2020"
}, {
	name: "RadioCardGroup",
	path: "src/molecules/forms/RadioCardGroup/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericRadio",
			path: "Data/Capture/Radios"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "ValidationMessage",
	path: "src/molecules/forms/ValidationMessage/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ValidationMessageTile",
			path: "Layout/Tiles"
		}
	}],
	deprecationVersion: "22.22.0",
	deprecationDate: "January 20 2020"
}, {
	name: "IconText",
	path: "src/molecules/icon-text/IconText/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "IconTextDynamic",
			path: "Molecules/IconTextDynamic"
		}
	}],
	deprecationVersion: "6.4.0",
	deprecationDate: "August 03 2018"
}, {
	name: "BackAnchor",
	path: "src/molecules/navigation/BackAnchor/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "WebsiteLink",
			path: "Actions/Links"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "BackButton",
	path: "src/molecules/navigation/BackButton/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "UtilityNavButton",
			path: "Navigation/Site-navs"
		}
	}],
	deprecationVersion: "25.5.0",
	deprecationDate: "May 13 2020"
}, {
	name: "Utility",
	path: "src/molecules/navigation/Utility/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "UtilityNav",
			path: "Navigation/Site-Navs/UtilityNav"
		}
	}],
	deprecationVersion: "22.12.0",
	deprecationDate: "September 27 2019"
}, {
	name: "SubordinatePanel",
	path: "src/molecules/panels/SubordinatePanel/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ConditionalPanel",
			path: "Layout/Content/Panels"
		}
	}],
	deprecationVersion: "23.1.0",
	deprecationDate: "January 31 2020"
}, {
	name: "ProgressIndicator",
	path: "src/molecules/progress/ProgressIndicator/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ProgressStepper",
			path: "Navigation/Indicators"
		}
	}],
	deprecationVersion: "26.0.0",
	deprecationDate: "May 22 2020"
}, {
	name: "ProgressIndicatorItem",
	path: "src/molecules/progress/ProgressIndicator/ProgressIndicatorItem/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ProgressStepper",
			path: "Navigation/Indicators"
		}
	}],
	deprecationVersion: "26.0.0",
	deprecationDate: "May 22 2020"
}, {
	name: "SectionHeading",
	path: "src/molecules/text/SectionHeading/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "SectionHeading",
			path: "Typography/Headings"
		}
	}],
	deprecationVersion: "23.2.0",
	deprecationDate: "February 06 2020"
}, {
	name: "ConfirmationTile",
	path: "src/molecules/tile/ConfirmationTile/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "OutcomeTile",
			path: "Layout/Content/Tiles"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "HighlightTile",
	path: "src/molecules/tile/HighlightTile/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "StandoutTile",
			path: "Layout/Content/Tiles"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "IconTile",
	path: "src/molecules/tile/IconTile/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "OutcomeTile",
			path: "Layout/Content/Tiles"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "NavigationButton",
	path: "src/navigation/buttons/NavigationButton/package.json",
	"component-life-cycle": "active",
	deprecations: [{
		variants: ["Confirm", "Continue", "Next", "Submit"],
		replacements: {
			name: "NavigationButton",
			path: "Navigation/Buttons",
			variant: "Primary"
		}
	}, {
		variants: ["Back"],
		replacements: {
			name: "NavigationButton",
			path: "Navigation/Buttons",
			variant: "Secondary"
		}
	}, {
		variants: ["Cancel"],
		replacements: {
			name: "NavigationButton",
			path: "Navigation/Buttons",
			variant: "Tertiary"
		}
	}],
	deprecationVersion: "NO RELEASE VERSION FOUND",
	deprecationDate: "NO RELEASE DATE FOUND"
}, {
	name: "GlobalHeader",
	path: "src/organisms/global/GlobalHeader/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ContainedHeader",
			path: "Layout/Headers"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "CentredModal",
	path: "src/organisms/modals/CentredModal/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ConfirmationModal",
			path: "Organisms/Modals"
		}
	}],
	deprecationVersion: "22.0.0",
	deprecationDate: "July 04 2019"
}, {
	name: "ConfirmationModal",
	path: "src/organisms/modals/ConfirmationModal/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericModal",
			path: "Layout/Content/Modals"
		}
	}],
	deprecationVersion: "27.8.0",
	deprecationDate: "January 29 2021"
}, {
	name: "Modal",
	path: "src/organisms/modals/Modal/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ConfirmationModal",
			path: "Organisms/Modals"
		}
	}],
	deprecationVersion: "22.0.0",
	deprecationDate: "July 04 2019"
}, {
	name: "LargeHero",
	path: "src/typography/heros/LargeHero/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Typography",
			path: "Typography"
		}
	}],
	deprecationVersion: "24.0.0",
	deprecationDate: "February 27 2020"
}, {
	name: "StandardHero",
	path: "src/typography/heros/StandardHero/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Typography",
			path: "Typography"
		}
	}],
	deprecationVersion: "24.0.0",
	deprecationDate: "February 27 2020"
}];

var checkComponentHasDeprecations = function checkComponentHasDeprecations(componentName) {
	return !!deprecated.find(function (obj) {
		return obj.name === componentName;
	});
};

var getDeprecations = function getDeprecations(componentName) {
	return deprecated.find(function (obj) {
		return obj.name === componentName;
	}).deprecations;
};

var getVariantDeprecations = function getVariantDeprecations(componentName) {
	var deprecatedVariants = [];
	if (!checkComponentHasDeprecations(componentName)) {
		return deprecatedVariants;
	}

	getDeprecations(componentName).map(function (deprecationObj) {
		return deprecationObj.variants.map(function (variant) {
			return deprecatedVariants.push(variant);
		});
	});
	return deprecatedVariants;
};

var checkIsComponentDeprecated = function checkIsComponentDeprecated(componentName, variant) {
	return getComponentLifeCycleStatus(componentName) === 'deprecated' || (variant ? getVariantDeprecations(componentName).includes(variant) : false);
};

var getComponentMetadata = function getComponentMetadata(componentName) {
	return metadata.find(function (_ref3) {
		var name = _ref3.name;
		return name === componentName;
	});
};

var getComponentLifeCycleStatus = function getComponentLifeCycleStatus(componentName) {
	var metadata = getComponentMetadata(componentName);
	return !metadata ? null : metadata['component-life-cycle'];
};

var isComponentBespoke = function isComponentBespoke(componentName) {
	return getComponentMetadata(componentName)['is-bespoke'];
};

var getComponentProminentStatus = function getComponentProminentStatus(componentName, variant) {
	if (checkIsComponentDeprecated(componentName, variant)) {
		return 'deprecated';
	}

	return isComponentBespoke(componentName) ? 'bespoke' : getComponentLifeCycleStatus(componentName);
};

var _templateObject$1 = taggedTemplateLiteral(['\n\t', ' ', ';\n\t', ';\n'], ['\n\t', ' ', ';\n\t', ';\n']);

var getFontProperties = function getFontProperties(props) {
	var fontProperties = 'font-size: 16px; line-height: 1.5;';
	// TODOxCYBG To be revisited with responsive VM typography.
	// if (props.theme.name !== 'vm') {
	fontProperties = props.theme.isCompact ? fontSize('bute') : fontSize('jura');
	// }
	return fontProperties;
};

var StyledInternalStandardBody = styled('div')(_templateObject$1, getFontProperties, function (props) {
	return !props.isFlush && 'margin-bottom: ' + spacing.DOUBLE;
}, function (props) {
	return !props.isFlush && 'margin-right: ' + spacing.DOUBLE;
});

var InternalStandardBody = function InternalStandardBody(_ref) {
	var isFlush = _ref.isFlush,
	    children = _ref.children;
	return React.createElement(
		StyledInternalStandardBody,
		{ isFlush: isFlush },
		children
	);
};

InternalStandardBody.propTypes = {
	/** Child content as node. Should be used to wrap bodies of textual content. This textual content
  * should contain appropriate HTML tagging and passing in orphan text child content should
  * be avoided. */
	children: PropTypes.node.isRequired,
	/** Removed margins. */
	isFlush: PropTypes.bool
};

InternalStandardBody.defaultProps = {
	isFlush: false
};

var _templateObject$2 = taggedTemplateLiteral(['\n\tcolor: ', ';\n\tlist-style: none;\n\tmargin-left: ', ';\n\tmargin-bottom: 0;\n\tmargin-top: 0;\n\tpadding-left: ', ';\n\n\tul {\n\t\tpadding-left: ', ';\n\t}\n'], ['\n\tcolor: ', ';\n\tlist-style: none;\n\tmargin-left: ', ';\n\tmargin-bottom: 0;\n\tmargin-top: 0;\n\tpadding-left: ', ';\n\n\tul {\n\t\tpadding-left: ', ';\n\t}\n']),
    _templateObject2$1 = taggedTemplateLiteral(['\n\tmargin-bottom: ', ';\n\tposition: relative;\n\n\t:before {\n\t\tcontent: \'\';\n\t\tposition: absolute;\n\t\tleft: -26px;\n\t\ttop: 10px;\n\t\twidth: 8px;\n\t\theight: 8px;\n\t\tborder: 1px solid ', ';\n\t\tbackground-color: ', ';\n\t\tborder-radius: ', ';\n\t}\n'], ['\n\tmargin-bottom: ', ';\n\tposition: relative;\n\n\t:before {\n\t\tcontent: \'\';\n\t\tposition: absolute;\n\t\tleft: -26px;\n\t\ttop: 10px;\n\t\twidth: 8px;\n\t\theight: 8px;\n\t\tborder: 1px solid ', ';\n\t\tbackground-color: ', ';\n\t\tborder-radius: ', ';\n\t}\n']);

var StyledUL = styled('ul')(_templateObject$2, function (props) {
	return props.theme.colours.bodyText;
}, spacing.DOUBLE, spacing.TRIPLE, spacing.DOUBLE);

var BORDER_RADIUS_DIVIDER = 4;
var BORDER_RADIUS_REMAINDER = 3;

var StyledListItem = styled('li')(_templateObject2$1, spacing.SINGLE, colours.neutral.black, function (props) {
	return props.level % 2 > 0 ? colours.neutral.black : 'transparent';
}, function (props) {
	return props.level % BORDER_RADIUS_DIVIDER === BORDER_RADIUS_REMAINDER || props.level % BORDER_RADIUS_DIVIDER === 0 ? '0' : '100%';
});

var processItems = function processItems(items, level) {
	return items.map(function (item, index) {
		return Array.isArray(item) ? React.createElement(
			StyledUL,
			{ key: level + '.' + [index] },
			processItems(item, level + 1)
		) : React.createElement(
			StyledListItem,
			{ key: level + '.' + [index], level: level },
			React.createElement(
				InternalStandardBody,
				{ isFlush: true },
				React.createElement(
					'span',
					null,
					item
				)
			)
		);
	});
};

var InternalBulletList = function InternalBulletList(_ref) {
	var items = _ref.items;
	return items !== ( undefined) && React.createElement(
		StyledUL,
		null,
		processItems(items, 1)
	);
};

InternalBulletList.propTypes = {
	/** An array of strings for each item. Can include other arrays for sub items. */
	items: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.node, PropTypes.string])).isRequired
};

var getThemeIcon = function getThemeIcon(vmIcon, generalIcon) {
  return function (themeName) {
    return themeName === 'vm' ? vmIcon : generalIcon;
  };
};

var _extends$2 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$1(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1(_ref, ["styles"]);

  return React.createElement("svg", _extends$2({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("title", null, "icon-triangleright-large"), React.createElement("path", { d: "M16 8L0 16V0" }));
});

var _extends$3 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$2(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$2(_ref, ["styles"]);

  return React.createElement("svg", _extends$3({ height: "16", viewBox: "0 0 96 96", width: "16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M13.75 1.849l68.847 45.515-67.217 47.89" }));
});

var getTriangleRightLarge = getThemeIcon(VMIcon, GenericIcon);

var _templateObject$3 = taggedTemplateLiteral(['\n\tbox-sizing: border-box;\n\tmargin-left: 6px;\n\tmax-height: 0;\n\toverflow: hidden;\n\tpadding-left: ', ';\n\tposition: relative;\n\ttransition: all 0.15s;\n\t', ';\n\n\t', ' p:last-child {\n\t\tmargin-bottom: 0;\n\t}\n\n\t:after {\n\t\tbackground-color: ', ';\n\t\tborder-radius: 4px;\n\t\tcontent: \'\';\n\t\tdisplay: block;\n\t\theight: 100%;\n\t\tleft: 0;\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\twidth: 4px;\n\t}\n'], ['\n\tbox-sizing: border-box;\n\tmargin-left: 6px;\n\tmax-height: 0;\n\toverflow: hidden;\n\tpadding-left: ', ';\n\tposition: relative;\n\ttransition: all 0.15s;\n\t', ';\n\n\t', ' p:last-child {\n\t\tmargin-bottom: 0;\n\t}\n\n\t:after {\n\t\tbackground-color: ', ';\n\t\tborder-radius: 4px;\n\t\tcontent: \'\';\n\t\tdisplay: block;\n\t\theight: 100%;\n\t\tleft: 0;\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\twidth: 4px;\n\t}\n']),
    _templateObject2$2 = taggedTemplateLiteral(['\n\talign-items: center;\n\tbackground: none;\n\tborder: none;\n\tcolor: ', ';\n\tdisplay: flex;\n\t', ';\n\tpadding: 0;\n\ttext-decoration: underline;\n\ttransition: margin 0.15s;\n\twidth: 100%;\n\n\t> svg {\n\t\tfill: ', ';\n\t\ttransition: transform 0.15s;\n\t}\n\n\t', ';\n\n\t.buttonLabel {\n\t\tdisplay: flex;\n\t\tmargin-left: ', 'px;\n\t\t', ';\n\n\t\t@media (max-width: ', ') {\n\t\t\twidth: 100%;\n\t\t}\n\t}\n\n\t:focus {\n\t\tbox-shadow: none;\n\n\t\t.buttonLabel {\n\t\t\tborder-radius: ', ';\n\t\t\tbox-shadow: 0 0 0 2px ', ';\n\t\t\toutline: 0;\n\t\t}\n\t}\n'], ['\n\talign-items: center;\n\tbackground: none;\n\tborder: none;\n\tcolor: ', ';\n\tdisplay: flex;\n\t', ';\n\tpadding: 0;\n\ttext-decoration: underline;\n\ttransition: margin 0.15s;\n\twidth: 100%;\n\n\t> svg {\n\t\tfill: ', ';\n\t\ttransition: transform 0.15s;\n\t}\n\n\t', ';\n\n\t.buttonLabel {\n\t\tdisplay: flex;\n\t\tmargin-left: ', 'px;\n\t\t', ';\n\n\t\t@media (max-width: ', ') {\n\t\t\twidth: 100%;\n\t\t}\n\t}\n\n\t:focus {\n\t\tbox-shadow: none;\n\n\t\t.buttonLabel {\n\t\t\tborder-radius: ', ';\n\t\t\tbox-shadow: 0 0 0 2px ', ';\n\t\t\toutline: 0;\n\t\t}\n\t}\n']),
    _templateObject3$1 = taggedTemplateLiteral(['\n\t', ';\n'], ['\n\t', ';\n']);

var StyledBodyContent = styled('div')(_templateObject$3, spacing.DOUBLE, function (props) {
	return props.isOpen ? '\n\t\t\t\tanimation: ' + animations.fadeIn + ' 0.7s linear;\n\t\t\t  ' : '\n\t\t\t\tanimation: ' + animations.fadeOut + ' 0.5s linear;\n\t\t\t  ';
}, function (props) {
	return props.isOpen && '\n\t\tmax-height: 4000px;\n\t\toverflow: visible;\n\t\tpadding-bottom: ' + spacing.SINGLE + ';\n\t\tpadding-left: ' + spacing.DOUBLE + ';\n\n\t';
}, function (props) {
	return props.panelColour;
});

var StyledButton = styled('button')(_templateObject2$2, function (props) {
	return props.panelColour;
}, useFontSize.of.jura, function (props) {
	return props.panelColour;
}, function (props) {
	return props.isOpen && !props.hasIconOverride && '\n\t\tmargin-bottom: ' + spacing.DOUBLE + ';\n\n\t\t> svg {\n\t\t\ttransform: rotate(90deg) !important;\n\t\t}\n\t';
}, function (props) {
	return props.isHeadingString ? '6' : '8';
}, function (props) {
	return props.isHeadingString && 'padding: 0 2px;';
}, breakpoints.md1, function (props) {
	return props.theme.borderRadius;
}, colours.component.focusOutline);

var StyledWrapper = styled('div')(_templateObject3$1, function (props) {
	return props.hasAdditionalMarginBottom && 'margin-bottom: ' + spacing.TRIPLE;
});

var InternalContentRevealPanel = function InternalContentRevealPanel(_ref) {
	var children = _ref.children,
	    hasAdditionalMarginBottom = _ref.hasAdditionalMarginBottom,
	    titleText = _ref.titleText,
	    icon = _ref.icon,
	    isOpen = _ref.isOpen,
	    onClick = _ref.onClick,
	    panelColour = _ref.panelColour,
	    theme = _ref.theme;

	var isHeadingString = typeof titleText === 'string';
	var ariaLabel = isHeadingString ? titleText.toLowerCase().replace(/\s+/g, '-') : 'content-reveal-panel';
	var TriangleRightLargeIcon = getTriangleRightLarge(theme.name);
	var hasIconOverride = icon !== undefined;
	return React.createElement(
		StyledWrapper,
		{ hasAdditionalMarginBottom: hasAdditionalMarginBottom },
		React.createElement(
			StyledButton,
			{
				'aria-labelledby': ariaLabel,
				isOpen: isOpen,
				hasIconOverride: hasIconOverride,
				onClick: onClick,
				panelColour: panelColour,
				type: 'button'
			},
			icon ? icon : React.createElement(TriangleRightLargeIcon, null),
			React.createElement(
				'div',
				{ className: 'buttonLabel' },
				isHeadingString ? React.createElement(
					InternalStandardBody,
					{ isFlush: true },
					React.createElement(
						'span',
						{ id: ariaLabel },
						titleText
					)
				) : titleText
			)
		),
		React.createElement(
			StyledBodyContent,
			{ isOpen: isOpen, panelColour: panelColour },
			children
		)
	);
};

InternalContentRevealPanel.propTypes = {
	/** Content of the panel. */
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
	/** Adds additional margin bottom. */
	hasAdditionalMarginBottom: PropTypes.bool,
	/** Set to true to open panel. */
	isOpen: PropTypes.bool,
	/** Callback function triggered on click. */
	onClick: PropTypes.func.isRequired,
	/** Sets panel colour. */
	panelColour: PropTypes.string.isRequired,
	/** Title text. */
	titleText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired
};

InternalContentRevealPanel.defaultProps = {
	hasAdditionalMarginBottom: false,
	isOpen: false
};

var WrappedInternalContentRevealPanel = withTheme(InternalContentRevealPanel);

var _templateObject$4 = taggedTemplateLiteral(['\n\t', ';\n'], ['\n\t', ';\n']),
    _templateObject2$3 = taggedTemplateLiteral(['\n\t', ';\n\tdisplay: inline-block;\n'], ['\n\t', ';\n\tdisplay: inline-block;\n']),
    _templateObject3$2 = taggedTemplateLiteral(['\n\tbackground-color: ', ';\n\tborder-radius: ', ';\n\tcolor: ', ';\n\theight: min-content;\n\tdisplay: block;\n\tpadding: 0 ', ';\n\tfont-size: 14px;\n'], ['\n\tbackground-color: ', ';\n\tborder-radius: ', ';\n\tcolor: ', ';\n\theight: min-content;\n\tdisplay: block;\n\tpadding: 0 ', ';\n\tfont-size: 14px;\n']),
    _templateObject4$1 = taggedTemplateLiteral(['\n\talign-items: flex-end;\n\tbackground: ', ';\n\tdisplay: flex;\n\tpadding: ', ';\n\tmargin-bottom: ', ';\n\n\t& > div {\n\t\tmargin-bottom: 0;\n\t}\n\n\tbutton {\n\t\ttext-decoration: none;\n\t}\n\n\tul {\n\t\tmargin-bottom: ', ';\n\t\tmargin-right: ', ';\n\t\tpadding-left: 0;\n\t\tpadding-top: ', ';\n\n\t\tli {\n\t\t\tcolor: ', ';\n\t\t\ttransform: scale(0.8);\n\t\t}\n\t}\n'], ['\n\talign-items: flex-end;\n\tbackground: ', ';\n\tdisplay: flex;\n\tpadding: ', ';\n\tmargin-bottom: ', ';\n\n\t& > div {\n\t\tmargin-bottom: 0;\n\t}\n\n\tbutton {\n\t\ttext-decoration: none;\n\t}\n\n\tul {\n\t\tmargin-bottom: ', ';\n\t\tmargin-right: ', ';\n\t\tpadding-left: 0;\n\t\tpadding-top: ', ';\n\n\t\tli {\n\t\t\tcolor: ', ';\n\t\t\ttransform: scale(0.8);\n\t\t}\n\t}\n']),
    _templateObject5$1 = taggedTemplateLiteral(['\n\tpadding-top: ', ';\n\n\tp {\n\t\tcolor: ', ';\n\t\tmargin-bottom: ', ';\n\t}\n'], ['\n\tpadding-top: ', ';\n\n\tp {\n\t\tcolor: ', ';\n\t\tmargin-bottom: ', ';\n\t}\n']),
    _templateObject6$1 = taggedTemplateLiteral(['\n\tbackground: ', ';\n\toverflow: auto;\n\tpadding: ', ';\n'], ['\n\tbackground: ', ';\n\toverflow: auto;\n\tpadding: ', ';\n']);

var BasicBlockWrapper = styled('div')(_templateObject$4, function (props) {
	return !props.removeFrameMargins && externalMarginRegular;
});

var BasicInlineWrapper = styled('span')(_templateObject2$3, function (props) {
	return !props.removeFrameMargins && externalMarginRegular;
});

var BasicDetails = styled('span')(_templateObject3$2, function (props) {
	return props.content;
}, styleGuideTheme.borderRadius, colours.neutral.black, spacing.QUARTER);

var InfoContainer = styled('div')(_templateObject4$1, function (props) {
	return props.content;
}, spacing.SINGLE, spacing.SINGLE, spacing.DOUBLE, spacing.DOUBLE, spacing.SINGLE, colours.neutral.black);

var InfoContentWrapper = styled('div')(_templateObject5$1, spacing.SINGLE, colours.neutral.black, spacing.SINGLE);

var InnerComponentWrapper = styled('div')(_templateObject$4, function (props) {
	return props.isContainer && '\n\t\tbackground-color: hsla(0, 100%, 100%, 60%);\n\t\tpadding: ' + spacing.DOUBLE + ' ' + spacing.DOUBLE + ' ' + spacing.SINGLE + ';\n\t';
});

var XRayComponentWrapper = styled('div')(_templateObject6$1, function (props) {
	return props.background;
}, function (props) {
	return props.isContainer ? '0' : spacing.SINGLE + ' ' + spacing.DOUBLE + ' ' + spacing.DOUBLE + ' ' + spacing.SINGLE;
});

var revealContent = {
	active: React.createElement(
		'span',
		null,
		'Details on this component can be found in the Web UI Components the style guide.'
	),
	bespoke: React.createElement(
		'span',
		null,
		React.createElement(
			'p',
			null,
			'This component was built for a certainuse case and should not be used outside of that.'
		),
		React.createElement(
			'p',
			null,
			'Further details can be found in the Web UI Components style guide.'
		)
	),
	deprecated: React.createElement(
		'span',
		null,
		React.createElement(
			'p',
			null,
			'Deprecated components are no longer tested via:'
		),
		React.createElement(InternalBulletList, {
			items: ['Visual regression & brand testing.', 'Integration testing.', 'Manual input testing.', 'Accessibility testing.']
		}),
		React.createElement(
			'p',
			null,
			'Further details can be found in the Web UI Components style guide.'
		),
		React.createElement(
			'p',
			null,
			React.createElement(
				'b',
				null,
				React.createElement(
					'u',
					null,
					'Upgrade as soon as possible.'
				)
			)
		)
	),
	draft: React.createElement(
		'span',
		null,
		React.createElement(
			'p',
			null,
			'Do not log defects for:'
		),
		React.createElement(InternalBulletList, {
			items: ['Appearance or styles.', 'Keyboard or mouse behaviours.', 'Missing input validations.'],
			isFlush: true
		}),
		React.createElement(
			'p',
			null,
			'Upgrade before using in production.'
		)
	),
	outdated: React.createElement(
		'span',
		null,
		React.createElement(
			'p',
			null,
			'This component is outdated. Therefore, should not be used in newer project work.'
		),
		React.createElement(
			'p',
			null,
			'It may have issues with:'
		),
		React.createElement(InternalBulletList, { items: ['Accessibility.', 'Consistency.', 'Optimisation.'], isFlush: true }),
		React.createElement(
			'p',
			null,
			'Before adding to a new codebase, contact the UI team about seeking a replacement.'
		)
	)
};

var getComponentName = function getComponentName(packageJson) {
	return packageJson.main.split('.')[0];
};

var InternalComponentFrame = function (_Component) {
	inherits(InternalComponentFrame, _Component);

	function InternalComponentFrame(props) {
		classCallCheck(this, InternalComponentFrame);

		var _this = possibleConstructorReturn(this, (InternalComponentFrame.__proto__ || Object.getPrototypeOf(InternalComponentFrame)).call(this, props));

		_this.state = {
			isOpen: false
		};
		return _this;
	}

	createClass(InternalComponentFrame, [{
		key: 'render',
		value: function render() {
			var _this2 = this;

			// eslint-disable-next-line react/prop-types
			var _props = this.props,
			    children = _props.children,
			    hasCustomMargins = _props.hasCustomMargins,
			    layout = _props.layout,
			    isFlush = _props.isFlush,
			    packageJson = _props.packageJson,
			    variant = _props.variant,
			    xraySuppressed = _props.xraySuppressed;
			var isOpen = this.state.isOpen;
			var _window = window,
			    XrayHelper = _window.XrayHelper;


			var componentName = getComponentName(packageJson);
			var status = getComponentProminentStatus(componentName, variant);
			var formattedStatus = stringHelpers_2(status);
			var variantSuffix = variant ? '.' + variant : '';

			var isContainer = layout === 'container';
			var isInline = layout === 'inline';
			var isTypography = layout === 'typography';
			var isCompactLayout = isInline || isTypography;
			var _colours$component$fr = colours.component.frame[status],
			    background = _colours$component$fr.background,
			    content = _colours$component$fr.content;


			if (xraySuppressed || XrayHelper && XrayHelper.checkIsXrayMode() === false) {
				return isInline ? React.createElement(
					BasicInlineWrapper,
					{ removeFrameMargins: hasCustomMargins || isFlush },
					children
				) : React.createElement(
					BasicBlockWrapper,
					{ removeFrameMargins: hasCustomMargins || isFlush },
					children
				);
			}

			return isCompactLayout ? React.createElement(
				'div',
				null,
				children,
				React.createElement(
					BasicDetails,
					{ content: content },
					React.createElement(
						'b',
						null,
						formattedStatus,
						' component:'
					),
					' ',
					componentName,
					variantSuffix
				)
			) : React.createElement(
				'div',
				null,
				React.createElement(
					XRayComponentWrapper,
					{ background: background, isContainer: isContainer },
					React.createElement(
						InnerComponentWrapper,
						{ isContainer: isContainer },
						children
					)
				),
				React.createElement(
					InfoContainer,
					{ content: content },
					React.createElement(
						WrappedInternalContentRevealPanel,
						{
							panelColour: 'black',
							titleText: formattedStatus + ' component: ' + getComponentName(packageJson) + variantSuffix,
							isOpen: isOpen,
							onClick: function onClick() {
								return _this2.setState(function (prevState) {
									return { isOpen: !prevState.isOpen };
								});
							}
						},
						React.createElement(
							InfoContentWrapper,
							null,
							revealContent[status]
						)
					)
				)
			);
		}
	}]);
	return InternalComponentFrame;
}(Component);

InternalComponentFrame.propTypes = {
	children: PropTypes.node.isRequired,
	hasCustomMargins: PropTypes.bool,
	isFlush: PropTypes.bool,
	layout: PropTypes.oneOf(['block', 'inline', 'container', 'typography']),
	packageJson: PropTypes.object.isRequired,
	variant: PropTypes.string,
	xraySuppressed: PropTypes.bool
};

InternalComponentFrame.defaultProps = {
	hasCustomMargins: false,
	isFlush: false,
	layout: 'block',
	xraySuppressed: false
};

var main = "StandardBody.js";
var packageJson = {
	main: main,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

/**
 * @example ./Design.md
 */
var StandardBody = function StandardBody(_ref) {
	var isFlush = _ref.isFlush,
	    children = _ref.children;
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson, hasCustomMargins: true, layout: 'typography' },
		React.createElement(
			InternalStandardBody,
			{ isFlush: isFlush },
			children
		)
	);
};

StandardBody.propTypes = {
	/** Child content as node. Should be used to wrap bodies of textual content. This textual content
  * should contain appropriate HTML tagging and passing in orphan text child content should
  * be avoided. */
	children: PropTypes.node.isRequired,
	/** Removed margins. */
	isFlush: PropTypes.bool
};

StandardBody.defaultProps = {
	isFlush: false
};

StandardBody.defaultExample = function () {
	return React.createElement(
		StandardBody,
		null,
		React.createElement(
			'span',
			null,
			'StandardBody'
		)
	);
};

var inputStyles = 'input {\n\t\tclip: rect(0, 0, 0, 0);\n\t\theight: 0;\n\t\twidth: 0;\n\t\toverflow: hidden;\n\t\tposition: absolute;\n\n\t\t:focus {\n\t\t\t~ label {\n\t\t\t\toutline-color: ' + colours.component.focusOutline + ';\n\t\t\t\toutline-offset: 2px;\n\t\t\t\toutline-style: auto;\n\t\t\t\toutline-width: 5px;\n\t\t\t}\n\t\t}\n\t}';

var _templateObject$5 = taggedTemplateLiteral(['\n\tdisplay: inline-flex;\n\tposition: relative;\n\n\t@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n\t\ttable & {\n\t\t\tflex: 1;\n\t\t}\n\t}\n\n\t', ';\n\n\tlabel {\n\t\talign-items: flex-start;\n\t\tbox-sizing: border-box;\n\t\tcolor: ', ';\n\t\tcursor: ', ';\n\t\tdisplay: inline-flex;\n\t\tmin-width: 98px;\n\n\t\t// IE11 Solution to content stress test\n\t\t&:after {\n\t\t\tdisplay: block;\n\t\t\tcontent: \'\';\n\t\t\tmin-height: inherit;\n\t\t\tfont-size: 0;\n\t\t}\n\t}\n\n\tsvg {\n\t\tbackground: ', ';\n\t\tborder: 2px solid\n\t\t\t', ';\n\t\tborder-radius: 2px;\n\t\theight: 24px;\n\t\tmargin-right: ', ';\n\t\tmargin-top: 1px;\n\t\twidth: 24px;\n\t\t', ' flex-shrink: 0;\n\t}\n'], ['\n\tdisplay: inline-flex;\n\tposition: relative;\n\n\t@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n\t\ttable & {\n\t\t\tflex: 1;\n\t\t}\n\t}\n\n\t', ';\n\n\tlabel {\n\t\talign-items: flex-start;\n\t\tbox-sizing: border-box;\n\t\tcolor: ', ';\n\t\tcursor: ', ';\n\t\tdisplay: inline-flex;\n\t\tmin-width: 98px;\n\n\t\t// IE11 Solution to content stress test\n\t\t&:after {\n\t\t\tdisplay: block;\n\t\t\tcontent: \'\';\n\t\t\tmin-height: inherit;\n\t\t\tfont-size: 0;\n\t\t}\n\t}\n\n\tsvg {\n\t\tbackground: ', ';\n\t\tborder: 2px solid\n\t\t\t', ';\n\t\tborder-radius: 2px;\n\t\theight: 24px;\n\t\tmargin-right: ', ';\n\t\tmargin-top: 1px;\n\t\twidth: 24px;\n\t\t', ' flex-shrink: 0;\n\t}\n']);

var StyledWrapper$1 = styled('div')(_templateObject$5, inputStyles, function (props) {
	return props.theme.colours.bodyText;
}, function (props) {
	return props.isDisabled ? 'not-allowed' : 'pointer';
}, function (props) {
	return props.isDisabled ? colours.disabled.background : colours.backgrounds.component;
}, function (props) {
	return props.hasError ? colours.utilitySupremacy.errorPrimary : props.theme.colours.interaction;
}, spacing.SINGLE, function (props) {
	return props.isDisabled && 'border-color: ' + colours.disabled.border + ';';
});

var getIconFillColour = function getIconFillColour(isChecked, isDisabled, hasError, theme) {
	if (isChecked && isDisabled) {
		return colours.disabled.border;
	}
	if (isDisabled) {
		return colours.disabled.background;
	}
	if (isChecked) {
		return hasError ? colours.utilitySupremacy.errorPrimary : theme.colours.interaction;
	}
	return 'transparent';
};

var BaseInputCheckbox = function (_Component) {
	inherits(BaseInputCheckbox, _Component);

	function BaseInputCheckbox(props) {
		classCallCheck(this, BaseInputCheckbox);

		var _this = possibleConstructorReturn(this, (BaseInputCheckbox.__proto__ || Object.getPrototypeOf(BaseInputCheckbox)).call(this, props));

		_this.refInput = null;
		return _this;
	}

	createClass(BaseInputCheckbox, [{
		key: 'focus',
		value: function focus() {
			if (this.refInput) {
				this.refInput.focus();
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    hasError = _props.hasError,
			    id = _props.id,
			    isChecked = _props.isChecked,
			    isDisabled = _props.isDisabled,
			    innerRef = _props.innerRef,
			    label = _props.label,
			    name = _props.name,
			    onBlur = _props.onBlur,
			    onChange = _props.onChange,
			    onFocus = _props.onFocus,
			    theme = _props.theme;


			if (innerRef) {
				innerRef(this);
			}

			return React.createElement(
				StyledWrapper$1,
				{ hasError: hasError, isChecked: isChecked, isDisabled: isDisabled },
				React.createElement('input', {
					checked: isChecked,
					disabled: isDisabled,
					id: id,
					name: name,
					onBlur: onBlur,
					onChange: onChange,
					onFocus: onFocus,
					ref: function ref(element) {
						_this2.refInput = element;
					},
					type: 'checkbox',
					value: label
				}),
				React.createElement(
					'label',
					{ htmlFor: id },
					React.createElement(CheckboxIcon, { fill: getIconFillColour(isChecked, isDisabled, hasError, theme) }),
					React.createElement(
						StandardBody,
						{ isFlush: true },
						React.createElement(
							'span',
							null,
							label
						)
					)
				)
			);
		}
	}]);
	return BaseInputCheckbox;
}(Component);

var basePropTypes = {
	/** Changes radio colour when set to true. */
	hasError: PropTypes.bool,
	/** An ID HTML attribute for the checkbox element. Must be unique on any individual page. */
	id: PropTypes.string.isRequired,
	/** Boolean controlling whether checkbox input is checked. */
	isChecked: PropTypes.bool.isRequired,
	/** Boolean controlling whether checkbox input is disabled. */
	isDisabled: PropTypes.bool,
	/** Used to access the internal input inside the theme wrapper. */
	innerRef: PropTypes.func,
	/** The checkbox input label. */
	label: PropTypes.string.isRequired,
	/** HTML name attribute value that this checkbox option belongs to. */
	name: PropTypes.string.isRequired,
	/** Callback function triggered on blur. */
	onBlur: PropTypes.func,
	/** Callback function triggered on change. */
	onChange: PropTypes.func.isRequired,
	/** Callback function triggered on focus. */
	onFocus: PropTypes.func
};

var baseDefaultProps = {
	hasError: false,
	isDisabled: false
};

BaseInputCheckbox.propTypes = basePropTypes;
BaseInputCheckbox.defaultProps = baseDefaultProps;

var InternalCheckbox = {
	Default: withTheme(BaseInputCheckbox)
};

var main$1 = "GenericCheckbox.js";
var variants = ["InlineSet", "StackedSet"];
var packageJson$1 = {
	main: main$1,
	variants: variants,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$6 = taggedTemplateLiteral(['\n\tdisplay: ', ';\n\t', ';\n\n\t@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n\t\ttable & {\n\t\t\twidth: 100%;\n\t\t}\n\t}\n'], ['\n\tdisplay: ', ';\n\t', ';\n\n\t@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n\t\ttable & {\n\t\t\twidth: 100%;\n\t\t}\n\t}\n']);

var StyledInputWrapper = styled('div')(_templateObject$6, function (props) {
	return props.isStacked ? 'flex' : 'inline-flex';
}, externalMarginRegular);

var checkIsSelected = function checkIsSelected(selectedIds, id) {
	return selectedIds.some(function (item) {
		return item === id;
	});
};

var Base = function (_Component) {
	inherits(Base, _Component);

	function Base(props) {
		classCallCheck(this, Base);

		var _this = possibleConstructorReturn(this, (Base.__proto__ || Object.getPrototypeOf(Base)).call(this, props));

		_this.inputRef = null;

		_this.handleOnChange = _this.handleOnChange.bind(_this);
		return _this;
	}

	createClass(Base, [{
		key: 'handleOnChange',
		value: function handleOnChange(selectedIds, id) {
			var onChange = this.props.onChange;


			var isPreviouslySelected = checkIsSelected(selectedIds, id);

			var newIds = isPreviouslySelected ? selectedIds.filter(function (item) {
				return item !== id;
			}) : [].concat(toConsumableArray(selectedIds), [id]);

			onChange(newIds);
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    hasError = _props.hasError,
			    groupName = _props.groupName,
			    innerRef = _props.innerRef,
			    isStacked = _props.isStacked,
			    items = _props.items,
			    onBlur = _props.onBlur,
			    onFocus = _props.onFocus,
			    selectedIds = _props.selectedIds;


			return React.createElement(
				'div',
				null,
				items.map(function (_ref, index) {
					var id = _ref.id,
					    labelText = _ref.labelText;

					var blur = index === items.length - 1 ? onBlur : undefined;
					var focus = index === 0 ? onFocus : undefined;
					var ref = index === 0 ? innerRef : undefined;
					return React.createElement(
						StyledInputWrapper,
						{ key: groupName + id, isStacked: isStacked },
						React.createElement(InternalCheckbox.Default, {
							hasError: hasError,
							id: groupName + id,
							innerRef: ref,
							isChecked: checkIsSelected(selectedIds, id),
							label: labelText,
							name: groupName,
							onBlur: blur,
							onChange: function onChange() {
								return _this2.handleOnChange(selectedIds, id);
							},
							onFocus: focus
						})
					);
				})
			);
		}
	}]);
	return Base;
}(Component);

var InlineSet = function InlineSet(_ref2) {
	var groupName = _ref2.groupName,
	    hasError = _ref2.hasError,
	    innerRef = _ref2.innerRef,
	    items = _ref2.items,
	    onBlur = _ref2.onBlur,
	    onChange = _ref2.onChange,
	    onFocus = _ref2.onFocus,
	    selectedIds = _ref2.selectedIds;
	return React.createElement(
		InternalComponentFrame,
		{ variant: 'InlineSet', packageJson: packageJson$1, hasCustomMargins: true },
		React.createElement(Base, {
			hasError: hasError,
			innerRef: innerRef,
			groupName: groupName,
			onBlur: onBlur,
			onChange: onChange,
			onFocus: onFocus,
			selectedIds: selectedIds,
			items: items
		})
	);
};

var StackedSet = function StackedSet(_ref3) {
	var groupName = _ref3.groupName,
	    hasError = _ref3.hasError,
	    innerRef = _ref3.innerRef,
	    items = _ref3.items,
	    onBlur = _ref3.onBlur,
	    onChange = _ref3.onChange,
	    onFocus = _ref3.onFocus,
	    selectedIds = _ref3.selectedIds;
	return React.createElement(
		InternalComponentFrame,
		{ variant: 'StackedSet', packageJson: packageJson$1, hasCustomMargins: true },
		React.createElement(Base, {
			groupName: groupName,
			hasError: hasError,
			innerRef: innerRef,
			items: items,
			isStacked: true,
			onBlur: onBlur,
			onChange: onChange,
			onFocus: onFocus,
			selectedIds: selectedIds
		})
	);
};

var baseProps = {
	/** String added to the html name attribute of each checkbox. */
	groupName: PropTypes.string.isRequired,
	/** Changes radio colour when set to true. */
	hasError: PropTypes.bool,
	/** Used to access the internal input inside the theme wrapper. */
	innerRef: PropTypes.func,
	/** Array of checkbox objects data. */
	items: PropTypes.arrayOf(shape({
		id: PropTypes.string.isRequired,
		labelText: PropTypes.string.isRequired
	})),
	/** Callback function triggered on blur of the last checkbox. */
	onBlur: PropTypes.func,
	/** Callback function triggered on change. */
	onChange: PropTypes.func.isRequired,
	/** Callback function triggered on focus of the first checkbox. */
	onFocus: PropTypes.func,
	/** Array of ids to be highlighted. */
	selectedIds: PropTypes.arrayOf(PropTypes.string).isRequired
};

Base.propTypes = _extends({}, baseProps);
InlineSet.propTypes = _extends({}, baseProps);
StackedSet.propTypes = _extends({}, baseProps, { isStacked: PropTypes.bool });

Base.defaultProps = {
	hasError: false
};

InlineSet.defaultExample = function () {
	var items = [{ id: '1', labelText: 'item 1' }, { id: '2', labelText: 'item 2' }, { id: '3', labelText: 'item 3' }];
	return React.createElement(GenericCheckbox.InlineSet, {
		items: items,
		groupName: 'checkboxes-1',
		onChange: function onChange(selectedIds) {
			return selectedIds;
		},
		selectedIds: ['1']
	});
};

StackedSet.defaultExample = function () {
	var items = [{ id: '1a', labelText: 'item 1' }, { id: '2a', labelText: 'item 2' }, { id: '3a', labelText: 'item 3' }];
	return React.createElement(GenericCheckbox.StackedSet, {
		items: items,
		groupName: 'checkboxes-2',
		onChange: function onChange(selectedIds) {
			return selectedIds;
		},
		selectedIds: ['3a']
	});
};

var GenericCheckbox = {
	InlineSet: InlineSet,
	StackedSet: StackedSet
};

var main$2 = "StandaloneCheckbox.js";
var packageJson$2 = {
	main: main$2,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var StandaloneCheckbox = function StandaloneCheckbox(_ref) {
	var hasError = _ref.hasError,
	    id = _ref.id,
	    isChecked = _ref.isChecked,
	    innerRef = _ref.innerRef,
	    labelText = _ref.labelText,
	    onBlur = _ref.onBlur,
	    onChange = _ref.onChange,
	    onFocus = _ref.onFocus;

	var onChangeHandler = function onChangeHandler(selectedIds) {
		var isChecked = selectedIds.length === 1;
		onChange({ isChecked: isChecked });
	};

	var items = [{ id: id, labelText: labelText }];
	var selectedIds = isChecked ? [id] : [];

	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$2, hasCustomMargins: true },
		React.createElement(GenericCheckbox.InlineSet, {
			groupName: id,
			hasError: hasError,
			innerRef: innerRef,
			items: items,
			onBlur: onBlur,
			onChange: function onChange(selectedIds) {
				return onChangeHandler(selectedIds);
			},
			onFocus: onFocus,
			selectedIds: selectedIds
		})
	);
};

StandaloneCheckbox.propTypes = {
	/** Changes radio colour when set to true. */
	hasError: PropTypes.bool,
	/** String id passed to underlying html element. */
	id: PropTypes.string.isRequired,
	/** Boolean for native html checked attribute of checkbox element. */
	isChecked: PropTypes.bool.isRequired,
	/** Used to access the internal input inside the theme wrapper. */
	innerRef: PropTypes.func,
	/** String label text. */
	labelText: PropTypes.string.isRequired,
	/** Callback function triggered on blur. */
	onBlur: PropTypes.func,
	/** Callback function triggered on change */
	onChange: PropTypes.func.isRequired,
	/** Callback function triggered on focus. */
	onFocus: PropTypes.func
};

StandaloneCheckbox.defaultProps = {
	hasError: false
};

StandaloneCheckbox.defaultExample = function () {
	return React.createElement(StandaloneCheckbox, { id: 'StandaloneCheckbox-1-example', labelText: 'Example text', isChecked: true, onChange: function onChange() {} });
};

var main$3 = "AccountNumberInput.js";
var packageJson$3 = {
	main: main$3,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$7 = taggedTemplateLiteral(['\n\tinput[type=\'number\'] {\n\t\t-moz-appearance: textfield;\n\t}\n\tinput[type=\'number\']::-webkit-inner-spin-button,\n\tinput[type=\'number\']::-webkit-outer-spin-button {\n\t\t-webkit-appearance: none;\n\t\tmargin: 0;\n\t}\n'], ['\n\tinput[type=\'number\'] {\n\t\t-moz-appearance: textfield;\n\t}\n\tinput[type=\'number\']::-webkit-inner-spin-button,\n\tinput[type=\'number\']::-webkit-outer-spin-button {\n\t\t-webkit-appearance: none;\n\t\tmargin: 0;\n\t}\n']),
    _templateObject2$4 = taggedTemplateLiteral(['\n\tborder: ', ';\n\tborder-radius: ', ';\n\tbox-sizing: border-box;\n\tfont-size: ', ';\n\tmin-height: ', ';\n\tpadding: ', ';\n\twidth: 9rem;\n\ttext-align: left;\n\n\t', '};\n'], ['\n\tborder: ', ';\n\tborder-radius: ', ';\n\tbox-sizing: border-box;\n\tfont-size: ', ';\n\tmin-height: ', ';\n\tpadding: ', ';\n\twidth: 9rem;\n\ttext-align: left;\n\n\t', '};\n']);

var StyledAccountInput = styled('div')(_templateObject$7);

var StyledInput = styled('input')(_templateObject2$4, function (props) {
	return props.theme.borderWidth + ' solid ' + props.theme.colours.borderInteraction;
}, function (props) {
	return props.theme.borderRadius;
}, function (props) {
	return props.theme.isCompact ? '12px' : '16px';
}, spacing.SEXTUPLE, spacing.SINGLE, function (props) {
	return props.hasError && 'border: ' + props.theme.borderWidth + ' solid ' + colours.utility.error;
});

var validationReasons = {
	INVALID: 'INVALID',
	BELOW_MIN: 'BELOW_MIN',
	ABOVE_MAX: 'ABOVE_MAX'
};

var AccountNumberInput = function (_Component) {
	inherits(AccountNumberInput, _Component);

	function AccountNumberInput(props) {
		classCallCheck(this, AccountNumberInput);

		var _this = possibleConstructorReturn(this, (AccountNumberInput.__proto__ || Object.getPrototypeOf(AccountNumberInput)).call(this, props));

		var value = _this.props.value;


		_this.state = {
			value: value,
			hasValidationError: false
		};

		_this.setAccountNumber = _this.setAccountNumber.bind(_this);
		_this.validateInputLength = _this.validateInputLength.bind(_this);
		return _this;
	}

	createClass(AccountNumberInput, [{
		key: 'focus',
		value: function focus() {
			if (this.refInput) {
				this.refInput.focus();
			}
		}
	}, {
		key: 'setAccountNumber',
		value: function setAccountNumber(_ref) {
			var target = _ref.target;
			var value = target.value;
			var onChange = this.props.onChange;


			var numbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

			for (var i = 0; i < value.length; i += 1) {
				if (!numbers.includes(value.charAt(i))) {
					return;
				}
			}

			var _validateInputLength = this.validateInputLength(value),
			    hasValidationError = _validateInputLength.hasValidationError,
			    validationErrorReason = _validateInputLength.validationErrorReason;

			this.setState({
				value: value,
				hasValidationError: hasValidationError
			}, function () {
				onChange({
					value: value,
					validationErrorReason: validationErrorReason
				});
			});
		}
	}, {
		key: 'validateInputLength',
		value: function validateInputLength(inputValue) {
			var length = inputValue.length;
			var _props = this.props,
			    minLength = _props.minLength,
			    maxLength = _props.maxLength;


			if (length < minLength) {
				return {
					hasValidationError: true,
					validationErrorReason: validationReasons.BELOW_MIN
				};
			}

			if (length > maxLength) {
				return {
					hasValidationError: true,
					validationErrorReason: validationReasons.ABOVE_MAX
				};
			}

			return {
				hasValidationError: false,
				validationErrorReason: null
			};
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props2 = this.props,
			    hasValidationEnabled = _props2.hasValidationEnabled,
			    id = _props2.id,
			    innerRef = _props2.innerRef,
			    maxLength = _props2.maxLength,
			    onBlur = _props2.onBlur,
			    onFocus = _props2.onFocus;
			var _state = this.state,
			    value = _state.value,
			    hasValidationError = _state.hasValidationError;


			if (innerRef) {
				innerRef(this);
			}

			return React.createElement(
				InternalComponentFrame,
				{ packageJson: packageJson$3 },
				React.createElement(
					StyledAccountInput,
					null,
					React.createElement(StyledInput, {
						id: id,
						innerRef: function innerRef(element) {
							_this2.refInput = element;
						},
						inputMode: 'numeric',
						maxLength: maxLength,
						name: id,
						onBlur: onBlur,
						onChange: function onChange(event) {
							return _this2.setAccountNumber(event);
						},
						onFocus: onFocus,
						pattern: '[0-9]*',
						type: 'text',
						value: value,
						hasError: hasValidationError && hasValidationEnabled
					})
				)
			);
		}
	}]);
	return AccountNumberInput;
}(Component);

AccountNumberInput.propTypes = {
	/** The id of the component. */
	id: PropTypes.string.isRequired,
	/** Used to access the internal input inside the theme wrapper. */
	innerRef: PropTypes.func,
	/** Sets if validation highlighting is shown. */
	hasValidationEnabled: PropTypes.bool,
	/** Maximum account number length. */
	maxLength: PropTypes.number,
	/** Minimum account number length. */
	minLength: PropTypes.number,
	/** Callback function triggered on blur. */
	onBlur: PropTypes.func,
	/** Callback function triggered on change.
  *
  * Returns object:
  *
  * value [number],
  *
  * validationErrorReason [string]
  */
	onChange: PropTypes.func.isRequired,
	/** Callback function triggered on focus. */
	onFocus: PropTypes.func,
	/** Account number string value. */
	value: PropTypes.string
};

AccountNumberInput.defaultProps = {
	hasValidationEnabled: false,
	maxLength: 11,
	minLength: 6
};

AccountNumberInput.defaultExample = function () {
	return React.createElement(AccountNumberInput, { id: 'example-account-number', onChange: function onChange() {}, value: '12345678' });
};

var _templateObject$8 = taggedTemplateLiteral(['\n\t', ' display: inline-block;\n\tfont-family: ', ';\n\tmargin-bottom: ', ';\n'], ['\n\t', ' display: inline-block;\n\tfont-family: ', ';\n\tmargin-bottom: ', ';\n']);

var getFontProperties$1 = function getFontProperties(props) {
	var fontProperties = 'font-size: 14px; line-height: 1.4286;';
	// TODOxCYBG To be revisited with responsive VM typography.
	// if (props.theme.name !== 'vm') {
	fontProperties = props.theme.isCompact ? fontSize('bute') : fontSize('uist');
	// }
	return fontProperties;
};

var StyledControlLabel = styled('label')(_templateObject$8, getFontProperties$1, function (props) {
	return props.theme.fonts.subLabel;
}, spacing.HALF);

/**
 * @example ./Design.md
 */
var InternalControlLabel = function InternalControlLabel(_ref) {
	var children = _ref.children,
	    htmlFor = _ref.htmlFor;
	return React.createElement(
		StyledControlLabel,
		{ htmlFor: htmlFor },
		children
	);
};

InternalControlLabel.propTypes = {
	/** Child content. */
	children: PropTypes.node.isRequired,
	/** For attribute to connect with input. */
	htmlFor: PropTypes.string.isRequired
};

InternalControlLabel.defaultProps = {
	isFlush: false
};

var main$4 = "DateOfBirthInput.js";
var packageJson$4 = {
	main: main$4,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$9 = taggedTemplateLiteral(['\n\tdisplay: flex;\n\n\tinput[type=\'number\'] {\n\t\t-moz-appearance: textfield;\n\t}\n\tinput[type=\'number\']::-webkit-inner-spin-button,\n\tinput[type=\'number\']::-webkit-outer-spin-button {\n\t\t-webkit-appearance: none;\n\t\tmargin: 0;\n\t}\n'], ['\n\tdisplay: flex;\n\n\tinput[type=\'number\'] {\n\t\t-moz-appearance: textfield;\n\t}\n\tinput[type=\'number\']::-webkit-inner-spin-button,\n\tinput[type=\'number\']::-webkit-outer-spin-button {\n\t\t-webkit-appearance: none;\n\t\tmargin: 0;\n\t}\n']),
    _templateObject2$5 = taggedTemplateLiteral(['\n\tborder: ', ';\n\tborder-radius: ', ';\n\tbox-sizing: border-box;\n\tfont-size: ', ';\n\tmin-height: ', ';\n\tpadding: ', ';\n\twidth: 100%;\n\ttext-align: center;\n\n\t&.error {\n\t\tborder: ', ';\n\t}\n'], ['\n\tborder: ', ';\n\tborder-radius: ', ';\n\tbox-sizing: border-box;\n\tfont-size: ', ';\n\tmin-height: ', ';\n\tpadding: ', ';\n\twidth: 100%;\n\ttext-align: center;\n\n\t&.error {\n\t\tborder: ', ';\n\t}\n']),
    _templateObject3$3 = taggedTemplateLiteral(['\n\twidth: 50px;\n\tmargin-right: 16px;\n'], ['\n\twidth: 50px;\n\tmargin-right: 16px;\n']),
    _templateObject4$2 = taggedTemplateLiteral(['\n\twidth: 80px;\n'], ['\n\twidth: 80px;\n']);

var StyledDOBInput = styled('div')(_templateObject$9);

var StyledInput$1 = styled('input')(_templateObject2$5, function (props) {
	return props.theme.borderWidth + ' solid ' + props.theme.colours.borderInteraction;
}, function (props) {
	return props.theme.borderRadius;
}, function (props) {
	return props.theme.isCompact ? '12px' : '16px';
}, spacing.SEXTUPLE, spacing.SINGLE, function (props) {
	return props.theme.borderWidth + ' solid ' + colours.utility.error;
});

var StyledDayInput = styled('div')(_templateObject3$3);

var StyledMonthInput = styled('div')(_templateObject3$3);

var StyledYearInput = styled('div')(_templateObject4$2);

// Set defaults
var days = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
var minYear = 1900;
var maxYear = moment().year();
var validationReasons$1 = {
	INVALID_DATE: 'INVALID_DATE',
	BELOW_MIN: 'BELOW_MIN',
	ABOVE_MAX: 'ABOVE_MAX'
};

var isNumValid = function isNumValid(val, type) {
	var numToCheck = null;
	var validDays = [];

	var DAYS_SLICE_END = 3;
	var DAYS_SLICE_YEAR = 9;

	// first number
	if (val.length === 1) {
		numToCheck = val;
		validDays = type === 'year' ? days.slice(1, DAYS_SLICE_END) : days;
	}

	// second number
	if (val.length === 2) {
		var numbers = val.split('');

		// if day
		var _numbers = slicedToArray(numbers, 2);

		numToCheck = _numbers[1];
		if (type === 'day') {
			switch (numbers[0]) {
				case '0':
					validDays = days;
					break;
				case '2':
					validDays = days;
					break;
				case '1':
					validDays = days;
					break;
				case '3':
					validDays = days.slice(0, 2);
					break;
				default:
					validDays = [];
					break;
			}
		}

		// if month
		if (type === 'month') {
			switch (numbers[0]) {
				case '0':
					validDays = days.slice(1);
					break;
				case '1':
					validDays = days.slice(0, DAYS_SLICE_END);
					break;
				default:
					validDays = [];
					break;
			}
		}

		// if year
		if (type === 'year') {
			switch (numbers[0]) {
				case '1':
					validDays = days.slice(DAYS_SLICE_YEAR);
					break;
				case '2':
					validDays = days.slice(0, 1);
					break;
				default:
					validDays = [];
					break;
			}
		}
	}

	// third number
	var TEST_LENGTH = 3;
	if (val.length === TEST_LENGTH) {
		var _numbers2 = val.split('');

		// If day or month return false (2 char max)
		var _numbers3 = slicedToArray(_numbers2, 3);

		numToCheck = _numbers3[2];
		if (type === 'day' || type === 'month') {
			return false;
		}
		// year - check previous number
		switch (_numbers2[1]) {
			case '9':
				validDays = days;
				break;
			case '0':
				validDays = days.slice(0, DAYS_SLICE_END);
				break;
			default:
				validDays = [];
				break;
		}
	}

	// fourth number
	var TEST_FOURTH_LENGTH = 4;
	if (val.length === TEST_FOURTH_LENGTH) {
		// If day or month return false (2 char max)
		if (type === 'day' || type === 'month') {
			return false;
		}
		// year - check if its within the valid range
		var yearNumber = parseInt(val, 10);
		if (yearNumber < minYear || yearNumber > maxYear) {
			return false;
		}
		return true;
	}

	// Check the number
	if (validDays.includes(numToCheck)) {
		return true;
	}

	// default
	return false;
};

// Limit the character input to a maximum length
// and stop invalid days, months and years
var limitInput = function limitInput(e, type) {
	var v = e.target.value;

	if (!isNumValid(v, type)) {
		// bin last character
		e.target.value = v.slice(0, v.length - 1);
	}
};

var checkAgeRange = function checkAgeRange(dateObj, minAge, maxAge) {
	// Make moment date (accounting for 0 indexed month)
	var dob = moment({ year: dateObj.year, month: dateObj.month - 1, day: dateObj.day });
	// valid return object
	var returnObj = {
		validationErrorReason: null,
		value: dob.toDate()
	};

	// Calc min / max dates
	var minDate = moment().subtract(minAge, 'years');
	var maxDate = dob.clone().add(maxAge + 1, 'years');

	// Check if dob is below minimum
	if (dob.isAfter(minDate)) {
		returnObj = {
			validationErrorReason: validationReasons$1.BELOW_MIN,
			value: dob.toDate()
		};
	}

	// Check if todays date is after dob + maxAge (+ 1) -- takes into account next birthday
	if (moment().isAfter(maxDate)) {
		returnObj = {
			validationErrorReason: validationReasons$1.ABOVE_MAX,
			value: dob.toDate()
		};
	}

	return returnObj;
};

var DateOfBirthInput = function (_Component) {
	inherits(DateOfBirthInput, _Component);

	function DateOfBirthInput(props) {
		classCallCheck(this, DateOfBirthInput);

		var _this = possibleConstructorReturn(this, (DateOfBirthInput.__proto__ || Object.getPrototypeOf(DateOfBirthInput)).call(this, props));

		if (_this.props.value === null) {
			_this.state = {
				day: '',
				month: '',
				year: '',
				hasError: false
			};
		} else {
			var date = _this.props.value;
			_this.state = {
				day: date.getDate(),
				month: date.getMonth() + 1,
				year: date.getFullYear(),
				hasError: false
			};
		}

		_this.setDay = _this.setDay.bind(_this);
		_this.setMonth = _this.setMonth.bind(_this);
		_this.setYear = _this.setYear.bind(_this);
		return _this;
	}

	createClass(DateOfBirthInput, [{
		key: 'focus',
		value: function focus() {
			if (this.refInput) {
				this.refInput.focus();
			}
		}
	}, {
		key: 'setDay',
		value: function setDay(event) {
			var value = event.target.value;
			var _state = this.state,
			    month = _state.month,
			    year = _state.year;


			var dateObj = {
				day: value,
				month: month,
				year: year
			};

			this.updateDate(dateObj);
		}
	}, {
		key: 'setMonth',
		value: function setMonth(event) {
			var value = event.target.value;
			var _state2 = this.state,
			    day = _state2.day,
			    year = _state2.year;


			var dateObj = {
				day: day,
				month: value,
				year: year
			};

			this.updateDate(dateObj);
		}
	}, {
		key: 'setYear',
		value: function setYear(event) {
			var value = event.target.value;
			var _state3 = this.state,
			    day = _state3.day,
			    month = _state3.month;


			var dateObj = {
				day: day,
				month: month,
				year: value
			};

			this.updateDate(dateObj);
		}
	}, {
		key: 'updateDate',
		value: function updateDate(dateObj) {
			var returnObj = {};
			var dateIsValid = true;
			var hasError = this.state.hasError;

			var checkDate = moment({ year: dateObj.year, month: dateObj.month - 1, day: dateObj.day });

			// Check day/month are not emtpy and year is the correct length
			var MAX_YEAR_LENGTH = 4;
			if (dateObj.day === '' || dateObj.month === '' || dateObj.year.length < MAX_YEAR_LENGTH) {
				dateIsValid = false;
				hasError = true;
			}

			// Check the date can be a valid JS Date
			if (!moment(checkDate).isValid()) {
				dateIsValid = false;
				hasError = true;
			}

			if (dateIsValid) {
				returnObj = checkAgeRange(dateObj, this.props.minAge, this.props.maxAge);
				if (returnObj.validationErrorReason === null) {
					hasError = false;
				}
			} else {
				returnObj = {
					validationErrorReason: validationReasons$1.INVALID_DATE,
					value: null
				};
			}

			this.props.onChange(returnObj);
			this.setState(_extends({}, dateObj, {
				hasError: hasError
			}));
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    hasValidationEnabled = _props.hasValidationEnabled,
			    id = _props.id,
			    innerRef = _props.innerRef,
			    onBlur = _props.onBlur,
			    onFocus = _props.onFocus;


			if (innerRef) {
				innerRef(this);
			}

			return React.createElement(
				InternalComponentFrame,
				{ packageJson: packageJson$4 },
				React.createElement(
					StyledDOBInput,
					null,
					React.createElement(
						StyledDayInput,
						null,
						React.createElement(
							InternalControlLabel,
							{ htmlFor: id + '-day' },
							'Day'
						),
						React.createElement(StyledInput$1, {
							autoComplete: 'bday-day',
							className: this.state.hasError && hasValidationEnabled ? 'error' : '',
							id: id + '-day',
							innerRef: function innerRef(element) {
								_this2.refInput = element;
							},
							inputMode: 'numeric',
							max: 31,
							maxLength: 2,
							min: 1,
							name: id + '-day',
							onChange: this.setDay,
							onFocus: onFocus,
							onInput: function onInput(e) {
								return limitInput(e, 'day');
							},
							size: 2,
							pattern: '[0-9]*',
							type: 'number',
							value: this.state.day
						})
					),
					React.createElement(
						StyledMonthInput,
						null,
						React.createElement(
							InternalControlLabel,
							{ htmlFor: id + '-month' },
							'Month'
						),
						React.createElement(StyledInput$1, {
							autoComplete: 'bday-month',
							className: this.state.hasError && hasValidationEnabled ? 'error' : '',
							id: id + '-month',
							inputMode: 'numeric',
							max: 12,
							maxLength: 2,
							min: 1,
							name: id + '-month',
							onChange: this.setMonth,
							onInput: function onInput(e) {
								return limitInput(e, 'month');
							},
							pattern: '[0-9]*',
							size: 2,
							type: 'number',
							value: this.state.month
						})
					),
					React.createElement(
						StyledYearInput,
						null,
						React.createElement(
							InternalControlLabel,
							{ htmlFor: id + '-year' },
							'Year'
						),
						React.createElement(StyledInput$1, {
							autoComplete: 'bday-year',
							className: this.state.hasError && hasValidationEnabled ? 'error' : '',
							id: id + '-year',
							inputMode: 'numeric',
							maxLength: 4,
							min: 1900,
							name: id + '-year',
							onBlur: onBlur,
							onChange: this.setYear,
							onInput: function onInput(e) {
								return limitInput(e, 'year');
							},
							pattern: '[0-9]*',
							size: 4,
							type: 'number',
							value: this.state.year
						})
					)
				)
			);
		}
	}]);
	return DateOfBirthInput;
}(Component);

DateOfBirthInput.propTypes = {
	/** Sets if validation highlighting is shown. */
	hasValidationEnabled: PropTypes.bool,
	/** The id of the component. */
	id: PropTypes.string.isRequired,
	/** Used to access the internal input inside the theme wrapper. */
	innerRef: PropTypes.func,
	/** Sets the maximum age used in validation. */
	maxAge: PropTypes.number,
	/** Sets the minimim age used in validation. */
	minAge: PropTypes.number,
	/** Callback function triggered on blur of the 'Year' input. */
	onBlur: PropTypes.func,
	/** Callback function triggered on change.
  *
  * Returns object:
  *
  * value [number],
  *
  * validationErrorReason [string]
  */
	onChange: PropTypes.func.isRequired,
	/** Callback function triggered on focus of the 'Day' input. */
	onFocus: PropTypes.func,
	/** Sets the date (JS date object). */
	value: PropTypes.instanceOf(Date)
};

DateOfBirthInput.defaultProps = {
	hasValidationEnabled: false,
	maxAge: 120,
	minAge: 18
};

DateOfBirthInput.defaultExample = function () {
	return React.createElement(DateOfBirthInput, { id: 'default-dob', value: null, onChange: function onChange() {} });
};

var main$5 = "SubBody.js";
var packageJson$5 = {
	main: main$5,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$a = taggedTemplateLiteral(['\n\t', ' ', ';\n\t', ';\n'], ['\n\t', ' ', ';\n\t', ';\n']);

var getFontProperties$2 = function getFontProperties(props) {
	var fontProperties = 'font-size: 14px; line-height: 1.4286;';
	// TODOxCYBG To be revisited with responsive VM typography.
	// if (props.theme.name !== 'vm') {
	fontProperties = props.theme.isCompact ? fontSize('bute') : fontSize('uist');
	// }
	return fontProperties;
};

var StyledSubBody = styled('div')(_templateObject$a, getFontProperties$2, function (props) {
	return !props.isFlush && 'margin-bottom: ' + spacing.DOUBLE;
}, function (props) {
	return !props.isFlush && 'margin-right: ' + spacing.DOUBLE;
});

/**
 * @example ./Design.md
 */
var SubBody = function SubBody(_ref) {
	var isFlush = _ref.isFlush,
	    children = _ref.children;
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$5, hasCustomMargins: true, layout: 'typography' },
		React.createElement(
			StyledSubBody,
			{ isFlush: isFlush },
			children
		)
	);
};

SubBody.propTypes = {
	/** Allows for content to be text or node (for example IconTextDynamic). */
	children: PropTypes.node.isRequired,
	/** Removed margins. */
	isFlush: PropTypes.bool
};

SubBody.defaultProps = {
	isFlush: false
};

SubBody.defaultExample = function () {
	return React.createElement(
		SubBody,
		null,
		React.createElement(
			'span',
			null,
			'SubBody'
		)
	);
};

var main$6 = "SubHeading.js";
var packageJson$6 = {
	main: main$6,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$b = taggedTemplateLiteral(['\n\tcolor: ', ';\n\t', '\n\tfont-family: ', ';\n\tmargin: 0;\n'], ['\n\tcolor: ', ';\n\t', '\n\tfont-family: ', ';\n\tmargin: 0;\n']),
    _templateObject2$6 = taggedTemplateLiteral(['\n\talign-items: center;\n\tdisplay: flex;\n\t', ';\n\n\t> svg {\n\t\tfill: ', ';\n\t\theight: ', ';\n\t\tmargin-right: ', ';\n\t\twidth: ', ';\n\t}\n'], ['\n\talign-items: center;\n\tdisplay: flex;\n\t', ';\n\n\t> svg {\n\t\tfill: ', ';\n\t\theight: ', ';\n\t\tmargin-right: ', ';\n\t\twidth: ', ';\n\t}\n']);

var getFontProperties$3 = function getFontProperties(props) {
	var fontProperties = 'font-size: 25px; line-height: 1.32;';
	// TODOxCYBG To be revisited with responsive VM typography.
	// if (props.theme.name !== 'vm') {
	fontProperties = props.theme.isCompact ? fontSize('arran') : fontSize('islay');
	// }
	return fontProperties;
};

var StyledSubHeading = styled('h2')(_templateObject$b, function (props) {
	return props.theme.colours.heading;
}, getFontProperties$3, function (props) {
	return props.theme.fonts.display.bold;
});

var StyledWrapper$2 = styled('div')(_templateObject2$6, function (props) {
	return props.isFlush && 'margin-bottom: 0;';
}, function (props) {
	return props.theme.colours.heading;
}, function (props) {
	return props.theme.isCompact ? '14px' : '28px';
}, function (props) {
	return props.theme.isCompact ? '8px' : '16px';
}, function (props) {
	return props.theme.isCompact ? '14px' : '28px';
});

/**
 * Uses `<h2>` tag internally.
 * @example ./Design.md
 */
var SubHeading = function SubHeading(_ref) {
	var children = _ref.children,
	    icon = _ref.icon,
	    isFlush = _ref.isFlush;
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$6, isFlush: isFlush, layout: 'typography' },
		React.createElement(
			StyledWrapper$2,
			{ isFlush: isFlush },
			icon,
			React.createElement(
				StyledSubHeading,
				null,
				children
			)
		)
	);
};

SubHeading.propTypes = {
	/** Allows for content to be text or node (for example IconTextDynamic). */
	children: PropTypes.node.isRequired,
	/** Optional Left aligned icon with SubHeading. */
	icon: PropTypes.node,
	/** Removed margins. */
	isFlush: PropTypes.bool
};

SubHeading.defaultProps = {
	isFlush: false
};

SubHeading.defaultExample = function () {
	return React.createElement(
		SubHeading,
		null,
		'SubHeading'
	);
};

var main$7 = "ProminentLabel.js";
var packageJson$7 = {
	main: main$7,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$c = taggedTemplateLiteral(['\n\t', '\n\tfont-family: ', ';\n\t', ';\n\t', ';\n'], ['\n\t', '\n\tfont-family: ', ';\n\t', ';\n\t', ';\n']);

var getFontProperties$4 = function getFontProperties(props) {
	var fontProperties = 'font-size: 20px; line-height: 1.3;';
	// TODOxCYBG To be revisited with responsive VM typography.
	// if (props.theme.name !== 'vm') {
	fontProperties = props.theme.isCompact ? fontSize('jura') : fontSize('arran');
	// }
	return fontProperties;
};

var StyledProminentLabel = styled('div')(_templateObject$c, getFontProperties$4, function (props) {
	return props.theme.fonts.display.bold;
}, function (props) {
	return !props.isFlush && 'margin-bottom: ' + spacing.DOUBLE;
}, function (props) {
	return !props.isFlush && 'margin-right: ' + spacing.DOUBLE;
});

var ProminentLabel = function ProminentLabel(_ref) {
	var isFlush = _ref.isFlush,
	    children = _ref.children;
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$7, hasCustomMargins: true, layout: 'typography' },
		React.createElement(
			StyledProminentLabel,
			{ isFlush: isFlush },
			children
		)
	);
};

ProminentLabel.propTypes = {
	/** Allows for content to be text or node (for example IconTextDynamic). */
	children: PropTypes.node.isRequired,
	/** Removed margins. */
	isFlush: PropTypes.bool
};

ProminentLabel.defaultProps = {
	isFlush: false
};

ProminentLabel.defaultExample = function () {
	return React.createElement(
		ProminentLabel,
		null,
		React.createElement(
			'span',
			null,
			'ProminentLabel'
		)
	);
};

var main$8 = "StandardLabel.js";
var packageJson$8 = {
	main: main$8,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$d = taggedTemplateLiteral(['\n\t', '\n\tfont-family: ', ';\n\t', ';\n\t', ';\n'], ['\n\t', '\n\tfont-family: ', ';\n\t', ';\n\t', ';\n']);

var getFontProperties$5 = function getFontProperties(props) {
	var fontProperties = 'font-size: 16px; line-height: 1.5;';
	// TODOxCYBG To be revisited with responsive VM typography.
	// if (props.theme.name !== 'vm') {
	fontProperties = props.theme.isCompact ? fontSize('uist') : fontSize('jura');
	// }
	return fontProperties;
};

var StyledStandardLabel = styled('div')(_templateObject$d, getFontProperties$5, function (props) {
	return props.theme.fonts.standardLabel;
}, function (props) {
	return !props.isFlush && 'margin-bottom: ' + spacing.DOUBLE;
}, function (props) {
	return !props.isFlush && 'margin-right: ' + spacing.DOUBLE;
});

var StandardLabel = function StandardLabel(_ref) {
	var isFlush = _ref.isFlush,
	    children = _ref.children;
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$8, hasCustomMargins: true, layout: 'typography' },
		React.createElement(
			StyledStandardLabel,
			{ isFlush: isFlush },
			children
		)
	);
};

StandardLabel.propTypes = {
	/** Allows for content to be text or node (for example IconTextDynamic). */
	children: PropTypes.node.isRequired,
	/** Removed margins. */
	isFlush: PropTypes.bool
};

StandardLabel.defaultProps = {
	isFlush: false
};

StandardLabel.defaultExample = function () {
	return React.createElement(
		StandardLabel,
		null,
		React.createElement(
			'span',
			null,
			'StandardLabel'
		)
	);
};

var main$9 = "FileUploadInput.js";
var packageJson$9 = {
	main: main$9,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$e = taggedTemplateLiteral(['\n\tbackground: ', ';\n\tdisplay: inline-flex;\n\tflex-basis: 100%;\n\n\tdiv {\n\t\twidth: 100%;\n\t}\n\n\t@media (min-width: ', ') {\n\t\tflex-wrap: nowrap;\n\t\theight: 48px;\n\t}\n\n\tlabel {\n\t\tposition: relative;\n\t\t\n\t\tspan {\n\t\t\talign-items: center;\n\t\t\tbackground: ', ';\n\t\t\t', '\n\t\t\tborder-radius: ', ';\n\t\t\tbox-sizing: border-box;\n\t\t\tcolor: ', ';\n\t\t\tcursor: pointer;\n\t\t\tdisplay: inline-flex;\n\t\t\tjustify-content: center;\n\t\t\theight: 48px;\n\t\t\tpadding: ', ' ', ';;\n\t\t\tposition: relative;\n\t\t\ttext-align: center;\n\t\t\ttext-decoration: none;\n\t\t\ttransition: background 0.3s;\n\t\t\tuser-select: none;\n\t\t\twhite-space: nowrap;\n\t\t\tvertical-align: middle;\n\n\t\t\t:hover {\n\t\t\t\tbackground-color: ', ';\n\t\t\t\tborder-color: ', ';\n\t\t\t\tcolor: ', ';\n\t\t\t}\n\t\t}\n\t}\n\n\tinput[type="file"] {\n\t\tborder-radius: ', ';\n\t\theight: 100%;\n\t\tleft: 0;\n\t\topacity: 0;\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\twidth: 100%;\n\n\t\t:focus {\n\t\t\t~ span {\n\t\t\t\toutline-color: ', ';\n\t\t\t\toutline-style: auto;\n\t\t\t\toutline-width: 5px;\n\t\t\t}\n\t\t}\n\t}\n\n\t> div {\n\t\talign-items: center;\n\t\tbox-sizing: border-box;\n\t\tcolor: ', ';\n\t\tdirection: rtl;\n\t\tdisplay: flex;\n\t\tflex-basis: 100%;\n\t\theight: 48px;\n\t\tmax-width: 100%;\n\t\tpadding: 0 ', ';\n\n\t\t@media (min-width: ', ') {\n\t\t\tflex-basis: auto;\n\t\t\tmax-width: 300px;\n\t\t}\n\n\t\tspan {\n\t\t\tdisplay: block;\n\t\t\tmargin-right: auto;\n\t\t\toverflow: hidden;\n\t\t\ttext-overflow: ellipsis;\n\t\t\twhite-space: nowrap;\n\t\t}\n\t}\n'], ['\n\tbackground: ', ';\n\tdisplay: inline-flex;\n\tflex-basis: 100%;\n\n\tdiv {\n\t\twidth: 100%;\n\t}\n\n\t@media (min-width: ', ') {\n\t\tflex-wrap: nowrap;\n\t\theight: 48px;\n\t}\n\n\tlabel {\n\t\tposition: relative;\n\t\t\n\t\tspan {\n\t\t\talign-items: center;\n\t\t\tbackground: ', ';\n\t\t\t', '\n\t\t\tborder-radius: ', ';\n\t\t\tbox-sizing: border-box;\n\t\t\tcolor: ', ';\n\t\t\tcursor: pointer;\n\t\t\tdisplay: inline-flex;\n\t\t\tjustify-content: center;\n\t\t\theight: 48px;\n\t\t\tpadding: ', ' ', ';;\n\t\t\tposition: relative;\n\t\t\ttext-align: center;\n\t\t\ttext-decoration: none;\n\t\t\ttransition: background 0.3s;\n\t\t\tuser-select: none;\n\t\t\twhite-space: nowrap;\n\t\t\tvertical-align: middle;\n\n\t\t\t:hover {\n\t\t\t\tbackground-color: ', ';\n\t\t\t\tborder-color: ', ';\n\t\t\t\tcolor: ', ';\n\t\t\t}\n\t\t}\n\t}\n\n\tinput[type="file"] {\n\t\tborder-radius: ', ';\n\t\theight: 100%;\n\t\tleft: 0;\n\t\topacity: 0;\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\twidth: 100%;\n\n\t\t:focus {\n\t\t\t~ span {\n\t\t\t\toutline-color: ', ';\n\t\t\t\toutline-style: auto;\n\t\t\t\toutline-width: 5px;\n\t\t\t}\n\t\t}\n\t}\n\n\t> div {\n\t\talign-items: center;\n\t\tbox-sizing: border-box;\n\t\tcolor: ', ';\n\t\tdirection: rtl;\n\t\tdisplay: flex;\n\t\tflex-basis: 100%;\n\t\theight: 48px;\n\t\tmax-width: 100%;\n\t\tpadding: 0 ', ';\n\n\t\t@media (min-width: ', ') {\n\t\t\tflex-basis: auto;\n\t\t\tmax-width: 300px;\n\t\t}\n\n\t\tspan {\n\t\t\tdisplay: block;\n\t\t\tmargin-right: auto;\n\t\t\toverflow: hidden;\n\t\t\ttext-overflow: ellipsis;\n\t\t\twhite-space: nowrap;\n\t\t}\n\t}\n']);

var StyledWrapper$3 = styled('div')(_templateObject$e, colours.backgrounds.component, breakpoints.sm1, function (props) {
	return props.hasFilename ? colours.neutral.white : props.theme.colours.interaction;
}, function (props) {
	return props.hasFilename && 'border: 2px solid ' + props.theme.colours.interaction + ';';
}, function (props) {
	return props.theme.borderRadius;
}, function (props) {
	return props.hasFilename ? props.theme.colours.interaction : colours.neutral.white;
}, spacing.HALF, spacing.DOUBLE, function (props) {
	return props.hasFilename ? props.theme.colours.interaction : props.theme.colours.interactionAccent;
}, function (props) {
	return props.hasFilename ? props.theme.colours.interaction : props.theme.colours.interactionAccent;
}, colours.neutral.white, function (props) {
	return props.theme.borderRadius;
}, colours.component.focusOutline, colours.neutral.black, spacing.DOUBLE, breakpoints.sm1);

var fileChangeHandler = function fileChangeHandler(event, onChange) {
	var _event$target = event.target,
	    files = _event$target.files,
	    value = _event$target.value;

	onChange(files, value);
	// eslint-disable-next-line no-param-reassign
	event.target.value = '';
};

var FileUploadInput = function FileUploadInput(_ref) {
	var acceptedFormats = _ref.acceptedFormats,
	    allowMultiple = _ref.allowMultiple,
	    filename = _ref.filename,
	    id = _ref.id,
	    labelText = _ref.labelText,
	    _onChange = _ref.onChange;

	var hasFilename = !!filename;
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$9 },
		React.createElement(
			StyledWrapper$3,
			{ hasFilename: hasFilename },
			React.createElement(
				'label',
				{ htmlFor: id },
				React.createElement('input', {
					accept: acceptedFormats,
					id: id,
					multiple: allowMultiple,
					onChange: function onChange(event) {
						return fileChangeHandler(event, _onChange);
					},
					type: 'file'
				}),
				React.createElement(
					'span',
					null,
					labelText
				)
			),
			hasFilename ? React.createElement(
				StandardLabel,
				{ isFlush: true },
				React.createElement(
					'span',
					null,
					filename
				)
			) : React.createElement(
				StandardBody,
				{ isFlush: true },
				React.createElement(
					'span',
					null,
					'No file chosen'
				)
			)
		)
	);
};

FileUploadInput.propTypes = {
	/** A comma-separated list of accepted file formats to permit for uploading (e.g. '.txt, .csv'). */
	acceptedFormats: PropTypes.string.isRequired,
	/** Set to true to allow the user to upload multiple files instad of a single file. */
	allowMultiple: PropTypes.bool,
	/** The displayed file name. Only shown when filename is not an empty string, null or undefined. */
	filename: PropTypes.string.isRequired,
	/** A unique ID used to identify the control within the DOM. */
	id: PropTypes.string.isRequired,
	/** File selection text displayed on the choose button. */
	labelText: PropTypes.string,
	/** Callback function triggered on change.
  * Called with two parameters: A file list of selected files and the filename of the first selected file.
  */
	onChange: PropTypes.func.isRequired
};

FileUploadInput.defaultProps = {
	allowMultiple: false,
	labelText: 'Choose file'
};

FileUploadInput.defaultExample = function () {
	return React.createElement(FileUploadInput, {
		acceptedFormats: '.pdf, .png',
		filename: 'Example file',
		id: 'file-upload-input',
		onChange: function onChange(filename) {
			return filename;
		}
	});
};

var MAX_CHAR_WIDTH = 0.6725;
var PADDING = 2;

var getInputWidth = function getInputWidth(characters, borderWidth) {
	if (!characters) {
		return '375px';
	}

	return parseInt(characters) * MAX_CHAR_WIDTH + PADDING + parseFloat(borderWidth) + 'rem';
};

var _templateObject$f = taggedTemplateLiteral(['\n\tborder: ', ';\n\tborder-radius: ', ';\n\tbox-sizing: border-box;\n\tfont-size: ', ';\n\theight: ', ';\n\tmax-width: 100%;\n\tpadding: ', ';\n\twidth: ', ';\n\t', '};\n'], ['\n\tborder: ', ';\n\tborder-radius: ', ';\n\tbox-sizing: border-box;\n\tfont-size: ', ';\n\theight: ', ';\n\tmax-width: 100%;\n\tpadding: ', ';\n\twidth: ', ';\n\t', '};\n']);

var StyledInput$2 = styled('input')(_templateObject$f, function (props) {
	return props.theme.borderWidth + ' solid ' + props.theme.colours.borderInteraction;
}, function (props) {
	return props.theme.borderRadius;
}, function (props) {
	return props.theme.isCompact ? '12px' : '16px';
}, spacing.SEXTUPLE, spacing.DOUBLE, function (props) {
	return getInputWidth(props.characterCount, props.theme.borderWidth);
}, function (props) {
	return props.hasValidationError && props.hasValidationEnabled && 'border: ' + props.theme.borderWidth + ' solid ' + colours.utility.error;
});

var validationErrorReasons = {
	BELOW_MIN: 'BELOW_MIN',
	ABOVE_MAX: 'ABOVE_MAX'
};

var validateMinMax = function validateMinMax(val, min, max) {
	var length = val.length;


	if (!!min && length < min) {
		return validationErrorReasons.BELOW_MIN;
	}

	if (!!max && length > max) {
		return validationErrorReasons.ABOVE_MAX;
	}

	return '';
};

var getNormalisedValue = function getNormalisedValue(value) {
	return value === null || value === undefined ? '' : value;
};

var onChangeHandler = function onChangeHandler(onChange, minLength, maxLength) {
	return function (_ref) {
		var target = _ref.target;

		var normaliseValue = getNormalisedValue(target.value);
		var validationErrorReason = validateMinMax(normaliseValue, minLength, maxLength);

		onChange({
			validationErrorReason: validationErrorReason,
			value: normaliseValue
		});
	};
};

var BaseTextInput = function (_Component) {
	inherits(BaseTextInput, _Component);

	function BaseTextInput(props) {
		classCallCheck(this, BaseTextInput);

		var _this = possibleConstructorReturn(this, (BaseTextInput.__proto__ || Object.getPrototypeOf(BaseTextInput)).call(this, props));

		_this.refInput = null;
		return _this;
	}

	createClass(BaseTextInput, [{
		key: 'focus',
		value: function focus() {
			if (this.refInput) {
				this.refInput.focus();
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    characterCount = _props.characterCount,
			    hasValidationEnabled = _props.hasValidationEnabled,
			    id = _props.id,
			    innerRef = _props.innerRef,
			    inputMode = _props.inputMode,
			    maxLength = _props.maxLength,
			    minLength = _props.minLength,
			    onBlur = _props.onBlur,
			    onChange = _props.onChange,
			    onFocus = _props.onFocus,
			    value = _props.value,
			    type = _props.type,
			    rest = objectWithoutProperties(_props, ['characterCount', 'hasValidationEnabled', 'id', 'innerRef', 'inputMode', 'maxLength', 'minLength', 'onBlur', 'onChange', 'onFocus', 'value', 'type']);


			var normaliseValue = getNormalisedValue(value);
			var validationErrorReason = validateMinMax(normaliseValue, minLength, maxLength);

			if (innerRef) {
				innerRef(this);
			}

			return React.createElement(StyledInput$2, _extends({
				characterCount: characterCount,
				hasValidationEnabled: hasValidationEnabled,
				hasValidationError: !!validationErrorReason,
				id: id,
				innerRef: function innerRef(element) {
					_this2.refInput = element;
				},
				inputMode: inputMode,
				onBlur: onBlur,
				onChange: onChangeHandler(onChange, minLength, maxLength),
				onFocus: onFocus,
				type: type,
				value: normaliseValue
			}, rest));
		}
	}]);
	return BaseTextInput;
}(Component);

BaseTextInput.propTypes = {
	/** Character count to be used for display width of the input. */
	characterCount: PropTypes.number,
	/** Sets if validation highlighting is shown. */
	hasValidationEnabled: PropTypes.bool,
	/** An is for the component. */
	id: PropTypes.string,
	/** Used to access the internal input inside the theme wrapper. */
	innerRef: PropTypes.func,
	/** The input mode - triggers a particular onscreen keyboard on mobile */
	inputMode: PropTypes.oneOf(['tel', 'url', 'email', 'search']),
	/** The maximum character length of the input. */
	maxLength: PropTypes.number,
	/** The minimum character length of the input. */
	minLength: PropTypes.number,
	/** Callback function triggered on blur. */
	onBlur: PropTypes.func,
	/** Callback function triggered on change.
  *
  * Returns object:
  *
  * value [number],
  *
  * validationErrorReason [string]
  */
	onChange: PropTypes.func.isRequired,
	/** Callback function triggered on focus. */
	onFocus: PropTypes.func,
	/** The value of the input */
	value: PropTypes.string,
	/** The input type */
	type: PropTypes.oneOf(['text', 'tel', 'search', 'password']).isRequired
};

BaseTextInput.defaultProps = {};

BaseTextInput.validationLiterals = _extends({ WHEN_VALID: '' }, validationErrorReasons);

var InternalStandardTextInput = function InternalStandardTextInput(_ref) {
	var characterCount = _ref.characterCount,
	    hasValidationEnabled = _ref.hasValidationEnabled,
	    id = _ref.id,
	    innerRef = _ref.innerRef,
	    onBlur = _ref.onBlur,
	    onChange = _ref.onChange,
	    onFocus = _ref.onFocus,
	    maxLength = _ref.maxLength,
	    minLength = _ref.minLength,
	    value = _ref.value;

	return React.createElement(BaseTextInput, {
		characterCount: characterCount,
		hasValidationEnabled: hasValidationEnabled,
		id: id,
		innerRef: innerRef,
		maxLength: maxLength,
		minLength: minLength,
		onBlur: onBlur,
		onChange: onChange,
		onFocus: onFocus,
		type: 'text',
		value: value
	});
};

InternalStandardTextInput.propTypes = {
	/** Character count to be used for display width of the input. */
	characterCount: PropTypes.number,
	/** Sets if validation highlighting is shown. */
	hasValidationEnabled: PropTypes.bool, // TODOxVMUI fix this to be required, because it is.
	/** An is for the component. */
	id: PropTypes.string,
	/** Used to access the internal input inside the theme wrapper. */
	innerRef: PropTypes.func,
	/** The maximum character length of the input. **/
	maxLength: PropTypes.number,
	/** The minimum character length of the input. */
	minLength: PropTypes.number,
	/** Callback function triggered on blur. */
	onBlur: PropTypes.func,
	/** Callback function triggered on change.
  *
  * Returns object:
  *
  * value [number],
  *
  * validationErrorReason [string]
  */
	onChange: PropTypes.func.isRequired,
	/** Callback function triggered on focus. */
	onFocus: PropTypes.func,
	/** The value of the input */
	value: PropTypes.string
};

InternalStandardTextInput.defaultProps = {
	hasValidationEnabled: false
};

InternalStandardTextInput.validationLiterals = BaseTextInput.validationLiterals;

var main$a = "GenericAlphaNumericInput.js";
var packageJson$a = {
	main: main$a,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var GenericAlphaNumericInput = function GenericAlphaNumericInput(_ref) {
	var characterCount = _ref.characterCount,
	    hasValidationEnabled = _ref.hasValidationEnabled,
	    innerRef = _ref.innerRef,
	    maxLength = _ref.maxLength,
	    minLength = _ref.minLength,
	    onBlur = _ref.onBlur,
	    onChange = _ref.onChange,
	    onFocus = _ref.onFocus,
	    id = _ref.id,
	    value = _ref.value;
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$a, layout: 'inline' },
		React.createElement(InternalStandardTextInput, {
			characterCount: characterCount,
			hasValidationEnabled: hasValidationEnabled,
			id: id,
			innerRef: innerRef,
			maxLength: maxLength,
			minLength: minLength,
			onBlur: onBlur,
			onChange: onChange,
			onFocus: onFocus,
			type: 'text',
			value: value
		})
	);
};

GenericAlphaNumericInput.propTypes = {
	/** Character count as number, controls the input width. */
	characterCount: PropTypes.number,
	/** Sets if validation highlighting is shown. */
	hasValidationEnabled: PropTypes.bool,
	/** The maximum character length of the input. **/
	maxLength: PropTypes.number,
	/** The minimum character length of the input. */
	minLength: PropTypes.number,
	/** Sets the ID attribute on the component, needed to attach it to an associated label in the DOM. */
	id: PropTypes.string.isRequired,
	/** Used to access the internal input inside the theme wrapper. */
	innerRef: PropTypes.func,
	/** Callback function triggered on blur. */
	onBlur: PropTypes.func,
	/** Callback function triggered on change.
  *
  * Returns object:
  *
  * value [number],
  *
  * validationErrorReason [string]
  */
	onChange: PropTypes.func.isRequired,
	/** Callback function triggered on focus. */
	onFocus: PropTypes.func,
	/** The value of the input. */
	value: PropTypes.string
};

GenericAlphaNumericInput.defaultProps = {
	hasValidationEnabled: false
};

GenericAlphaNumericInput.defaultExample = function () {
	return React.createElement(GenericAlphaNumericInput, { id: 'example-generic-alpha-numeric', onChange: function onChange() {}, value: '' });
};

GenericAlphaNumericInput.validationLiterals = InternalStandardTextInput.validationLiterals;

var main$b = "GenericTextInput.js";
var deprecations = [{
	replacements: {
		name: "GenericAlphaNumericInput",
		path: "Data/Capture/Inputs"
	}
}];
var packageJson$b = {
	main: main$b,
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: deprecations
};

var _templateObject$g = taggedTemplateLiteral(['\n\t> input {\n\t\twidth: 100% !important;\n\t}\n'], ['\n\t> input {\n\t\twidth: 100% !important;\n\t}\n']);

var StyledWrapper$4 = styled('div')(_templateObject$g);

var onChangeHandler$1 = function onChangeHandler(onChange) {
	return function (containedValue) {
		var value = containedValue.value;

		onChange(value);
	};
};

var GenericTextInput = function GenericTextInput(_ref) {
	var id = _ref.id,
	    onChange = _ref.onChange,
	    value = _ref.value;
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$b },
		React.createElement(
			StyledWrapper$4,
			null,
			React.createElement(InternalStandardTextInput, { id: id, onChange: onChangeHandler$1(onChange), value: value })
		)
	);
};

GenericTextInput.propTypes = {
	/** Sets the ID attribute on the component, needed to attach it to an associated label in the DOM. */
	id: PropTypes.string.isRequired,
	/** Callback function triggered on change. */
	onChange: PropTypes.func.isRequired,
	/** The value of the input */
	value: PropTypes.string.isRequired
};

GenericTextInput.defaultProps = {};

GenericTextInput.defaultExample = function () {
	return React.createElement(GenericTextInput, { id: 'example-generic-text', onChange: function onChange() {}, value: '' });
};

var onChangeHandler$2 = function onChangeHandler(onChange) {
	return function (output) {
		var validationErrorReason = output.validationErrorReason,
		    value = output.value;


		var isNumberOrSpace = /^[0-9\s]*$/.test(value);

		if (isNumberOrSpace === false && value !== '') {
			return;
		}

		onChange({
			validationErrorReason: validationErrorReason,
			value: value
		});
	};
};

var InternalTelephoneInput = function InternalTelephoneInput(_ref) {
	var onChange = _ref.onChange,
	    value = _ref.value,
	    rest = objectWithoutProperties(_ref, ['onChange', 'value']);
	return React.createElement(BaseTextInput, _extends({
		autoComplete: 'tel',
		type: 'tel',
		inputMode: 'tel',
		onChange: onChangeHandler$2(onChange),
		value: value
	}, rest));
};

InternalTelephoneInput.propTypes = {
	/** Callback function triggered on change. */
	onChange: PropTypes.func.isRequired,
	/** The value of the input */
	value: PropTypes.string.isRequired
};

InternalTelephoneInput.defaultProps = {};

var main$c = "LandlineNumberInput.js";
var packageJson$c = {
	main: main$c,
	"component-id": 1004,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$h = taggedTemplateLiteral(['\n\twidth: 12rem;\n'], ['\n\twidth: 12rem;\n']);

var StyledWrapper$5 = styled('div')(_templateObject$h);

var validationReasons$2 = {
	BELOW_MIN: 'BELOW_MIN',
	ABOVE_MAX: 'ABOVE_MAX'
};

var getValidationErrorReason = function getValidationErrorReason(maxLength, minLength, valueToCheck) {
	var valueLength = valueToCheck.replace(/\s+/g, '').length;

	if (valueLength > maxLength) {
		return validationReasons$2.ABOVE_MAX;
	}

	if (valueLength < minLength) {
		return validationReasons$2.BELOW_MIN;
	}

	return '';
};

var onChangeHandler$3 = function onChangeHandler(maxLength, minLength, onChange) {
	return function (output) {
		var value = output.value;


		onChange({
			value: value,
			validationErrorReason: getValidationErrorReason(maxLength, minLength, value)
		});
	};
};

/**
 * @example ./Design.md
 */

var LandlineNumberInput = function (_Component) {
	inherits(LandlineNumberInput, _Component);

	function LandlineNumberInput(props) {
		classCallCheck(this, LandlineNumberInput);

		var _this = possibleConstructorReturn(this, (LandlineNumberInput.__proto__ || Object.getPrototypeOf(LandlineNumberInput)).call(this, props));

		_this.refInput = null;
		return _this;
	}

	createClass(LandlineNumberInput, [{
		key: 'focus',
		value: function focus() {
			if (this.refInput) {
				this.refInput.focus();
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    hasValidationEnabled = _props.hasValidationEnabled,
			    id = _props.id,
			    innerRef = _props.innerRef,
			    maxLength = _props.maxLength,
			    minLength = _props.minLength,
			    onBlur = _props.onBlur,
			    onChange = _props.onChange,
			    onFocus = _props.onFocus,
			    value = _props.value;


			var hasValidationError = getValidationErrorReason(maxLength, minLength, value) !== '';

			if (innerRef) {
				innerRef(this);
			}

			return React.createElement(
				InternalComponentFrame,
				{ packageJson: packageJson$c },
				React.createElement(
					StyledWrapper$5,
					null,
					React.createElement(InternalTelephoneInput, {
						characterCount: 16,
						hasValidationError: hasValidationError && hasValidationEnabled,
						id: id,
						innerRef: function innerRef(element) {
							_this2.refInput = element;
						},
						onBlur: onBlur,
						onChange: onChangeHandler$3(maxLength, minLength, onChange),
						onFocus: onFocus,
						value: value
					})
				)
			);
		}
	}]);
	return LandlineNumberInput;
}(Component);

LandlineNumberInput.propTypes = {
	/** Sets if validation highlighting is shown. */
	hasValidationEnabled: PropTypes.bool,
	/** Sets the ID attribute on the component, needed to attach it to an associated label in the DOM. */
	id: PropTypes.string.isRequired,
	/** Used to access the internal input inside the theme wrapper. */
	innerRef: PropTypes.func,
	/** The maximum character length of the input after space removal. */
	maxLength: PropTypes.number,
	/** The minimum character length of the input after space removal. */
	minLength: PropTypes.number,
	/** Callback function triggered on blur. */
	onBlur: PropTypes.func,
	/** Callback function triggered on change.
  *
  * Returns object:
  *
  * value [number],
  *
  * validationErrorReason [string]
  */
	onChange: PropTypes.func.isRequired,
	/** Callback function triggered on focus. */
	onFocus: PropTypes.func,
	/** The value of the input. */
	value: PropTypes.string.isRequired
};

LandlineNumberInput.defaultProps = {
	maxLength: 11,
	minLength: 6
};

LandlineNumberInput.defaultExample = function () {
	return React.createElement(LandlineNumberInput, { id: 'default-ex-home-phone-number', onChange: function onChange() {}, value: '1234 567 8901' });
};

var _templateObject$i = taggedTemplateLiteral(['\n\tdisplay: flex;\n\talign-items: stretch;\n'], ['\n\tdisplay: flex;\n\talign-items: stretch;\n']),
    _templateObject2$7 = taggedTemplateLiteral(['\n\tbackground-color: ', ';\n\tborder: ', ';\n\tcolor: ', ';\n\t', ' text-align: center;\n\tjustify-content: center;\n\tmin-width: 48px;\n\tdisplay: flex;\n\n\tspan {\n\t\talign-self: center;\n\t}\n'], ['\n\tbackground-color: ', ';\n\tborder: ', ';\n\tcolor: ', ';\n\t', ' text-align: center;\n\tjustify-content: center;\n\tmin-width: 48px;\n\tdisplay: flex;\n\n\tspan {\n\t\talign-self: center;\n\t}\n']),
    _templateObject3$4 = taggedTemplateLiteral(['\n\tborder-radius: ', ' 0 0 ', ';\n\tborder-right-width: 0;\n'], ['\n\tborder-radius: ', ' 0 0 ', ';\n\tborder-right-width: 0;\n']),
    _templateObject4$3 = taggedTemplateLiteral(['\n\tborder-radius: 0 ', ' ', ' 0;\n\tborder-left-width: 0;\n'], ['\n\tborder-radius: 0 ', ' ', ' 0;\n\tborder-left-width: 0;\n']),
    _templateObject5$2 = taggedTemplateLiteral(['\n\tborder: ', ';\n\t', ';\n\tbox-sizing: border-box;\n\tfont-size: ', ';\n\theight: ', ';\n\tpadding: ', ';\n\tposition: relative;\n\twidth: ', ';\n\n\t-moz-appearance: textfield;\n\n\t&::-webkit-outer-spin-button, &::-webkit-inner-spin-button {\n    \t-webkit-appearance: none;\n    \tmargin: 0;\n\t}\n}\n'], ['\n\tborder: ', ';\n\t', ';\n\tbox-sizing: border-box;\n\tfont-size: ', ';\n\theight: ', ';\n\tpadding: ', ';\n\tposition: relative;\n\twidth: ', ';\n\n\t-moz-appearance: textfield;\n\n\t&::-webkit-outer-spin-button, &::-webkit-inner-spin-button {\n    \t-webkit-appearance: none;\n    \tmargin: 0;\n\t}\n}\n']);

var StyledWrapper$6 = styled('div')(_templateObject$i);

var StyledAnnotation = styled('div')(_templateObject2$7, colours.backgrounds.component, function (props) {
	return props.theme.borderWidth + ' solid ' + props.theme.colours.borderInteraction;
}, function (props) {
	return props.theme.colours.interaction;
}, function (props) {
	return props.theme.isCompact ? fontSize('jura') : fontSize('arran');
});

var StyledPrefix = styled(StyledAnnotation)(_templateObject3$4, function (props) {
	return props.theme.borderRadius;
}, function (props) {
	return props.theme.borderRadius;
});

var StyledSuffix = styled(StyledAnnotation)(_templateObject4$3, function (props) {
	return props.theme.borderRadius;
}, function (props) {
	return props.theme.borderRadius;
});

var getRadius = function getRadius(hasPrefix, hasSuffix, borderRadius) {
	if (!hasPrefix && !hasSuffix) {
		return 'border-radius: ' + borderRadius;
	}

	var leftCorners = hasPrefix ? 'border-top-left-radius: 0; border-bottom-left-radius: 0;' : 'border-top-left-radius: ' + borderRadius + '; border-bottom-left-radius: ' + borderRadius + ';';

	var rightCorners = hasSuffix ? 'border-top-right-radius: 0; border-bottom-right-radius: 0;' : 'border-top-right-radius: ' + borderRadius + '; border-bottom-right-radius: ' + borderRadius + ';';

	return leftCorners + rightCorners;
};

var StyledInput$3 = styled('input')(_templateObject5$2, function (props) {
	return props.theme.borderWidth + ' solid ' + props.theme.colours.borderInteraction;
}, function (_ref) {
	var hasPrefix = _ref.hasPrefix,
	    hasSuffix = _ref.hasSuffix,
	    theme = _ref.theme;
	return getRadius(hasPrefix, hasSuffix, theme.borderRadius);
}, function (props) {
	return props.theme.isCompact ? '12px' : '16px';
}, spacing.SEXTUPLE, spacing.DOUBLE, function (props) {
	return getInputWidth(props.characterCount, props.theme.borderWidth);
});

var E = 69;
var NUMPAD_PERIOD = 110;
var PERIOD = 190;
var NUMPAD_PLUS = 107;
var PLUS = 187;
// const NUMPAD_MINUS = 109, MINUS = 189;

var keyHandler = function keyHandler(allowDecimal) {
	return function (event) {
		var keyCode = event.keyCode;


		var isUndesiredNumericKey = [E, NUMPAD_PLUS, PLUS].some(function (x) {
			return x === keyCode;
		});

		if (isUndesiredNumericKey) {
			event.preventDefault();
			event.stopPropagation();
		}

		if (allowDecimal) {
			return;
		}

		var isPeriodKey = [NUMPAD_PERIOD, PERIOD].some(function (x) {
			return x === keyCode;
		});

		if (isPeriodKey) {
			event.preventDefault();
			event.stopPropagation();
		}
	};
};

var onChangeHandler$4 = function onChangeHandler(_ref2, onChange) {
	var target = _ref2.target;
	var value = target.value;

	onChange({
		value: value
	});
};

var BaseNumberInput = function (_Component) {
	inherits(BaseNumberInput, _Component);

	function BaseNumberInput(props) {
		classCallCheck(this, BaseNumberInput);

		var _this = possibleConstructorReturn(this, (BaseNumberInput.__proto__ || Object.getPrototypeOf(BaseNumberInput)).call(this, props));

		_this.refInput = null;
		return _this;
	}

	createClass(BaseNumberInput, [{
		key: 'focus',
		value: function focus() {
			if (this.refInput) {
				this.refInput.focus();
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    characterCount = _props.characterCount,
			    id = _props.id,
			    innerRef = _props.innerRef,
			    inputMode = _props.inputMode,
			    onBlur = _props.onBlur,
			    _onChange = _props.onChange,
			    onFocus = _props.onFocus,
			    symbolPrefix = _props.symbolPrefix,
			    symbolSuffix = _props.symbolSuffix,
			    value = _props.value;


			var hasPrefix = !!symbolPrefix;
			var hasSuffix = !!symbolSuffix;

			var normalisedValue = value === null || undefined ? '' : value; //TODOxVM: Extract normaliser functions.
			var allowDecimal = inputMode === 'decimal';

			if (innerRef) {
				innerRef(this);
			}

			return React.createElement(
				StyledWrapper$6,
				null,
				hasPrefix && React.createElement(
					StyledPrefix,
					null,
					React.createElement(
						'span',
						null,
						symbolPrefix
					)
				),
				React.createElement(StyledInput$3, {
					characterCount: characterCount,
					hasPrefix: hasPrefix,
					hasSuffix: hasSuffix,
					id: id,
					innerRef: function innerRef(element) {
						_this2.refInput = element;
					},
					inputMode: inputMode,
					onBlur: onBlur,
					onChange: function onChange(event) {
						return onChangeHandler$4(event, _onChange);
					},
					onFocus: onFocus,
					onKeyDown: keyHandler(allowDecimal),
					type: 'number',
					value: normalisedValue
				}),
				hasSuffix && React.createElement(
					StyledSuffix,
					null,
					React.createElement(
						'span',
						null,
						symbolSuffix
					)
				)
			);
		}
	}]);
	return BaseNumberInput;
}(Component);

BaseNumberInput.propTypes = {
	/** Character count as number. */
	characterCount: PropTypes.number,
	/** The id of the component. */
	id: PropTypes.string,
	/** Used to access the internal input inside the theme wrapper. */
	innerRef: PropTypes.func,
	/** The input mode - triggers a particular onscreen keyboard on mobile. */
	inputMode: PropTypes.oneOf(['decimal', 'numeric']).isRequired,
	/** Callback function triggered on blur. */
	onBlur: PropTypes.func,
	/** Callback function triggered on change. */
	onChange: PropTypes.func.isRequired,
	/** Callback function triggered on focus. */
	onFocus: PropTypes.func,
	/** Optional symbol appearing before input. */
	symbolPrefix: PropTypes.string,
	/** Optional symbol appearing after input. */
	symbolSuffix: PropTypes.string,
	/** The value of the input */
	value: PropTypes.number
};

BaseNumberInput.defaultProps = {};

var InternalDecimalInput = function (_Component) {
	inherits(InternalDecimalInput, _Component);

	function InternalDecimalInput(props) {
		classCallCheck(this, InternalDecimalInput);

		var _this = possibleConstructorReturn(this, (InternalDecimalInput.__proto__ || Object.getPrototypeOf(InternalDecimalInput)).call(this, props));

		var value = props.value;

		var decimalStore = value !== null && value !== undefined && value !== '' ? value.toString() : null;

		_this.state = {
			decimalStore: decimalStore
		};

		_this.onChangeHandler = _this.onChangeHandler.bind(_this);
		return _this;
	}

	createClass(InternalDecimalInput, [{
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			if (nextProps.value !== this.props.value) {
				var newValue = nextProps.value;


				if (newValue !== null && newValue !== undefined && newValue !== '') {
					var decimalStore = nextProps.value.toString();
					this.setState({ decimalStore: decimalStore });
				} else {
					this.setState({ decimalStore: null });
				}
			}
		}
	}, {
		key: 'onChangeHandler',
		value: function onChangeHandler(onChange, output) {
			var validationMessage = output.validationMessage,
			    value = output.value;


			if (value !== null && value !== undefined && value !== '') {
				var numericValue = parseInt(value, 10);
				this.setState({ decimalStore: value.toString() }, function () {
					onChange({ value: numericValue, validationMessage: validationMessage });
				});
			} else {
				this.setState({ decimalStore: null }, function () {
					onChange({ value: value, validationMessage: validationMessage });
				});
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    characterCount = _props.characterCount,
			    id = _props.id,
			    innerRef = _props.innerRef,
			    onBlur = _props.onBlur,
			    _onChange = _props.onChange,
			    onFocus = _props.onFocus,
			    symbolPrefix = _props.symbolPrefix,
			    symbolSuffix = _props.symbolSuffix;
			var decimalStore = this.state.decimalStore;


			return React.createElement(BaseNumberInput, {
				characterCount: characterCount,
				id: id,
				innerRef: innerRef,
				inputMode: 'decimal',
				onBlur: onBlur,
				onChange: function onChange(output) {
					return _this2.onChangeHandler(_onChange, output);
				},
				onFocus: onFocus,
				symbolPrefix: symbolPrefix,
				symbolSuffix: symbolSuffix,
				value: decimalStore
			});
		}
	}]);
	return InternalDecimalInput;
}(Component);

InternalDecimalInput.propTypes = {
	/** Character count as number. */
	characterCount: PropTypes.number,
	/** The id of the component. */
	id: PropTypes.string,
	/** Used to access the internal input inside the theme wrapper. */
	innerRef: PropTypes.func,
	/** Callback function triggered on blur. */
	onBlur: PropTypes.func,
	/** Callback function triggered on change. */
	onChange: PropTypes.func.isRequired,
	/** Callback function triggered on focus. */
	onFocus: PropTypes.func,
	/** Optional symbol appearing before input. */
	symbolPrefix: PropTypes.string,
	/** Optional symbol appearing after input. */
	symbolSuffix: PropTypes.string,
	/** The value of the input. */
	value: PropTypes.number
};

InternalDecimalInput.defaultProps = {};

var onChangeHandler$5 = function onChangeHandler(onChange) {
	return function (_ref) {
		var validationMessage = _ref.validationMessage,
		    value = _ref.value;

		if (value === '') {
			onChange({ validationMessage: validationMessage, value: null });
			return;
		}

		var isNumber = /[0-9]/.test(value);

		if (isNumber === false) {
			return;
		}

		onChange({ validationMessage: validationMessage, value: value });
	};
};

var InternalIntegerInput = function InternalIntegerInput(_ref2) {
	var characterCount = _ref2.characterCount,
	    id = _ref2.id,
	    innerRef = _ref2.innerRef,
	    onBlur = _ref2.onBlur,
	    onChange = _ref2.onChange,
	    onFocus = _ref2.onFocus,
	    symbolPrefix = _ref2.symbolPrefix,
	    symbolSuffix = _ref2.symbolSuffix,
	    value = _ref2.value;
	return React.createElement(BaseNumberInput, {
		characterCount: characterCount,
		id: id,
		innerRef: innerRef,
		inputMode: 'numeric',
		onBlur: onBlur,
		onChange: onChangeHandler$5(onChange),
		onFocus: onFocus,
		symbolPrefix: symbolPrefix,
		symbolSuffix: symbolSuffix,
		value: value
	});
};

InternalIntegerInput.propTypes = {
	/** Character count as number. */
	characterCount: PropTypes.number,
	/** The id of the component. */
	id: PropTypes.string,
	/** Used to access the internal input inside the theme wrapper. */
	innerRef: PropTypes.func,
	/** Callback function triggered on blur. */
	onBlur: PropTypes.func,
	/** Callback function triggered on change. */
	onChange: PropTypes.func.isRequired,
	/** Callback function triggered on focus. */
	onFocus: PropTypes.func,
	/** Optional symbol appearing before input. */
	symbolPrefix: PropTypes.string,
	/** Optional symbol appearing after input. */
	symbolSuffix: PropTypes.string,
	/** The value of the input. */
	value: PropTypes.number
};

InternalIntegerInput.defaultProps = {};

var main$d = "MoneyInput.js";
var variants$1 = ["PoundsOnly", "WithPence"];
var packageJson$d = {
	main: main$d,
	variants: variants$1,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var poundsOnChangeHandler = function poundsOnChangeHandler(onChange) {
	return function (_ref) {
		var validationMessage = _ref.validationMessage,
		    value = _ref.value;

		var newValue = value === null ? null : parseInt(value, 10);
		onChange({ value: newValue, validationMessage: validationMessage });
	};
};

var PoundsOnly = function PoundsOnly(_ref2) {
	var amountInPounds = _ref2.amountInPounds,
	    id = _ref2.id,
	    innerRef = _ref2.innerRef,
	    onBlur = _ref2.onBlur,
	    onChange = _ref2.onChange,
	    onFocus = _ref2.onFocus;

	var value = amountInPounds === null || amountInPounds === undefined || amountInPounds === '' ? null : amountInPounds;

	return React.createElement(
		InternalComponentFrame,
		{ variant: 'PoundsOnly', packageJson: packageJson$d },
		React.createElement(InternalIntegerInput, {
			characterCount: 7,
			id: id,
			innerRef: innerRef,
			onBlur: onBlur,
			onChange: poundsOnChangeHandler(onChange),
			onFocus: onFocus,
			symbolPrefix: '\xA3',
			symbolSuffix: '.00',
			value: value
		})
	);
};

var baseProps$1 = {
	/** The amount in pounds. */
	amountInPounds: PropTypes.number,
	/** The id of the component. */
	id: PropTypes.string.isRequired,
	/** Used to access the internal button inside the theme wrapper. */
	innerRef: PropTypes.func,
	/** Callback function triggered on blur. */
	onBlur: PropTypes.func,
	/** Callback function triggered on change. */
	onChange: PropTypes.func.isRequired,
	/** Callback function triggered on focus. */
	onFocus: PropTypes.func
};

PoundsOnly.propTypes = _extends({}, baseProps$1);

var PENCE_IN_POUND = 100;

var penceToPounds = function penceToPounds(amountInPence) {
	return amountInPence === null || amountInPence === undefined || amountInPence === '' ? null : amountInPence / PENCE_IN_POUND;
};

var poundsToPence = function poundsToPence(amountInPounds) {
	return amountInPounds === null || amountInPounds === undefined || amountInPounds === '' ? null : amountInPounds * PENCE_IN_POUND;
};

var penceOnChangeHandler = function penceOnChangeHandler(onChange) {
	return function (output) {
		var validationMessage = output.validationMessage,
		    value = output.value;


		var newValue = poundsToPence(value);
		onChange({ value: newValue, validationMessage: validationMessage });
	};
};

var WithPence = function (_Component) {
	inherits(WithPence, _Component);

	function WithPence(props) {
		classCallCheck(this, WithPence);
		return possibleConstructorReturn(this, (WithPence.__proto__ || Object.getPrototypeOf(WithPence)).call(this, props));
	}

	createClass(WithPence, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    amountInPence = _props.amountInPence,
			    id = _props.id,
			    innerRef = _props.innerRef,
			    onBlur = _props.onBlur,
			    onChange = _props.onChange,
			    onFocus = _props.onFocus;


			var value = penceToPounds(amountInPence);

			return React.createElement(
				InternalComponentFrame,
				{ variant: 'WithPence', packageJson: packageJson$d },
				React.createElement(InternalDecimalInput, {
					characterCount: 10,
					id: id,
					innerRef: innerRef,
					onBlur: onBlur,
					onChange: penceOnChangeHandler(onChange),
					onFocus: onFocus,
					symbolPrefix: '\xA3',
					value: value
				})
			);
		}
	}]);
	return WithPence;
}(Component);

WithPence.propTypes = _extends({}, baseProps$1);

var MoneyInput = {
	PoundsOnly: PoundsOnly,
	WithPence: WithPence
};

MoneyInput.PoundsOnly.defaultExample = function () {
	return React.createElement(MoneyInput.PoundsOnly, { amountInPounds: 100, id: 'money-input-pounds-only', onChange: function onChange() {} });
};

MoneyInput.WithPence.defaultExample = function () {
	return React.createElement(MoneyInput.WithPence, { amountInPence: 100, id: 'money-input-with-pence', onChange: function onChange() {} });
};

var _templateObject$j = taggedTemplateLiteral(['\n\tdisplay: flex;\n\tflex-wrap: ', ';\n\talign-items: ', ';\n\tjustify-content: center;\n\twidth: 100%;\n'], ['\n\tdisplay: flex;\n\tflex-wrap: ', ';\n\talign-items: ', ';\n\tjustify-content: center;\n\twidth: 100%;\n']),
    _templateObject2$8 = taggedTemplateLiteral(['\n\tdisplay: flex;\n\tflex-wrap: ', ';\n\talign-items: ', ';\n\tjustify-content: space-between;\n\twidth: 100%;\n'], ['\n\tdisplay: flex;\n\tflex-wrap: ', ';\n\talign-items: ', ';\n\tjustify-content: space-between;\n\twidth: 100%;\n']),
    _templateObject3$5 = taggedTemplateLiteral(['\n\tdisplay: flex;\n\tflex-wrap: ', ';\n\talign-items: ', ';\n\twidth: 100%;\n'], ['\n\tdisplay: flex;\n\tflex-wrap: ', ';\n\talign-items: ', ';\n\twidth: 100%;\n']),
    _templateObject4$4 = taggedTemplateLiteral(['\n\tdisplay: flex;\n\tflex-wrap: ', ';\n\talign-items: ', ';\n\tjustify-content: flex-end;\n\twidth: 100%;\n'], ['\n\tdisplay: flex;\n\tflex-wrap: ', ';\n\talign-items: ', ';\n\tjustify-content: flex-end;\n\twidth: 100%;\n']);

var baseProps$2 = {
	nodes: PropTypes.arrayOf(PropTypes.node).isRequired,
	isNonWrapping: PropTypes.bool,
	verticalAlignment: PropTypes.string
};

var defaultProps = {
	isNonWrapping: false,
	verticalAlignment: 'stretch'
};

var CenteredWrapper = styled('div')(_templateObject$j, function (props) {
	return props.isNonWrapping ? 'nowrap' : 'wrap';
}, function (props) {
	return props.alignItems;
});

var verticalAlignmentToAlignItems = function verticalAlignmentToAlignItems(verticalAlignment) {
	switch (verticalAlignment) {
		case 'top':
			return 'flex-start';
		case 'bottom':
			return 'flex-end';
		case 'center':
			return 'center';
		case 'baseline':
			return 'baseline';
		case 'stretch':
		default:
			return 'stretch';
	}
};

var Centered = function Centered(_ref) {
	var nodes = _ref.nodes,
	    isNonWrapping = _ref.isNonWrapping,
	    verticalAlignment = _ref.verticalAlignment;
	return React.createElement(
		CenteredWrapper,
		{ alignItems: verticalAlignmentToAlignItems(verticalAlignment), isNonWrapping: isNonWrapping },
		nodes.map(function (x, index) {
			return React.createElement(
				'div',
				{ key: index },
				x
			);
		})
	);
};

Centered.propTypes = _extends({}, baseProps$2);

Centered.defaultProps = _extends({}, defaultProps);

var JustifiedWrapper = styled('div')(_templateObject2$8, function (props) {
	return props.isNonWrapping ? 'nowrap' : 'wrap';
}, function (props) {
	return props.alignItems;
});

var Justified = function Justified(_ref2) {
	var nodes = _ref2.nodes,
	    isNonWrapping = _ref2.isNonWrapping,
	    verticalAlignment = _ref2.verticalAlignment;
	return React.createElement(
		JustifiedWrapper,
		{ alignItems: verticalAlignmentToAlignItems(verticalAlignment), isNonWrapping: isNonWrapping },
		nodes.map(function (x, index) {
			return React.createElement(
				'div',
				{ key: index },
				x
			);
		})
	);
};

Justified.propTypes = _extends({}, baseProps$2);

Justified.defaultProps = _extends({}, defaultProps);

var LeftAlignedWrapper = styled('div')(_templateObject3$5, function (props) {
	return props.isNonWrapping ? 'nowrap' : 'wrap';
}, function (props) {
	return props.alignItems;
});

var LeftAligned = function LeftAligned(_ref3) {
	var nodes = _ref3.nodes,
	    isNonWrapping = _ref3.isNonWrapping,
	    verticalAlignment = _ref3.verticalAlignment;
	return React.createElement(
		LeftAlignedWrapper,
		{ alignItems: verticalAlignmentToAlignItems(verticalAlignment), isNonWrapping: isNonWrapping },
		nodes.map(function (x, index) {
			return React.createElement(
				'div',
				{ key: index },
				x
			);
		})
	);
};

LeftAligned.propTypes = _extends({}, baseProps$2);

LeftAligned.defaultProps = _extends({}, defaultProps);

var RightAlignedWrapper = styled('div')(_templateObject4$4, function (props) {
	return props.isNonWrapping ? 'nowrap' : 'wrap';
}, function (props) {
	return props.alignItems;
});

var RightAligned = function RightAligned(_ref4) {
	var nodes = _ref4.nodes,
	    isNonWrapping = _ref4.isNonWrapping,
	    verticalAlignment = _ref4.verticalAlignment;
	return React.createElement(
		RightAlignedWrapper,
		{ alignItems: verticalAlignmentToAlignItems(verticalAlignment), isNonWrapping: isNonWrapping },
		nodes.map(function (x, index) {
			return React.createElement(
				'div',
				{ key: index },
				x
			);
		})
	);
};

RightAligned.propTypes = _extends({}, baseProps$2);

RightAligned.defaultProps = _extends({}, defaultProps);

var Inline = {
	Centered: Centered,
	Justified: Justified,
	LeftAligned: LeftAligned,
	RightAligned: RightAligned
};

var exampleContent = [React.createElement(
	'div',
	{ key: '123' },
	'123'
), React.createElement(
	'div',
	{ key: '456' },
	'456'
), React.createElement(
	'div',
	{ key: '789' },
	'789'
)];

Inline.Centered.defaultExample = function () {
	return React.createElement(Inline.Centered, { nodes: exampleContent });
};

Inline.Justified.defaultExample = function () {
	return React.createElement(Inline.Justified, { nodes: exampleContent });
};

Inline.LeftAligned.defaultExample = function () {
	return React.createElement(Inline.LeftAligned, { nodes: exampleContent });
};

Inline.RightAligned.defaultExample = function () {
	return React.createElement(Inline.RightAligned, { nodes: exampleContent });
};

var main$e = "MonthAndYearDateInput.js";
var packageJson$e = {
	main: main$e,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$k = taggedTemplateLiteral(['\n\tborder: ', ';\n\tborder-radius: ', ';\n\tbox-sizing: border-box;\n\tfont-size: ', ';\n\tmin-height: ', ';\n\tpadding: ', ';\n\ttext-align: center;\n\twidth: 100%;\n\n\t&.error {\n\t\tborder: ', ';\n\t}\n'], ['\n\tborder: ', ';\n\tborder-radius: ', ';\n\tbox-sizing: border-box;\n\tfont-size: ', ';\n\tmin-height: ', ';\n\tpadding: ', ';\n\ttext-align: center;\n\twidth: 100%;\n\n\t&.error {\n\t\tborder: ', ';\n\t}\n']),
    _templateObject2$9 = taggedTemplateLiteral(['\n\twidth: 60px;\n\tmargin-right: ', ';\n'], ['\n\twidth: 60px;\n\tmargin-right: ', ';\n']),
    _templateObject3$6 = taggedTemplateLiteral(['\n\twidth: 100px;\n'], ['\n\twidth: 100px;\n']);

var StyledInput$4 = styled('input')(_templateObject$k, function (props) {
	return props.theme.borderWidth + ' solid ' + props.theme.colours.borderInteraction;
}, function (props) {
	return props.theme.borderRadius;
}, function (props) {
	return props.theme.isCompact ? '12px' : '16px';
}, spacing.SEXTUPLE, spacing.SINGLE, function (props) {
	return props.theme.borderWidth + ' solid ' + colours.utility.error;
});

var StyledMonthInput$1 = styled('div')(_templateObject2$9, spacing.DOUBLE);

var StyledYearInput$1 = styled('div')(_templateObject3$6);

var MAX_MONTHS = 12;
var MAX_YEAR = 2100;
var MONTH_MAX_LENGTH = 2;
var YEAR_LENGTH = 4;

var checkIsMonthInvalid = function checkIsMonthInvalid(month) {
	return month !== null ? month > MAX_MONTHS || month < 1 : false;
};

var checkIsYearInvalid = function checkIsYearInvalid(year) {
	return year !== null ? year > MAX_YEAR || year.toString().length < YEAR_LENGTH : false;
};

var keyHandler$1 = function keyHandler(event) {
	var NUMPAD_PERIOD = 110;
	var NUMPAD_MINUS = 109;
	var NUMPAD_PLUS = 107;

	var MINUS = 189;
	var PERIOD = 190;
	var PLUS = 187;

	var keyCode = event.keyCode;


	var hasNonNumberKey = [NUMPAD_PERIOD, NUMPAD_MINUS, NUMPAD_PLUS, MINUS, PERIOD, PLUS].some(function (x) {
		return x === keyCode;
	});

	if (hasNonNumberKey) {
		event.preventDefault();
		event.stopPropagation();
	}
};

var onChangeHandler$6 = function onChangeHandler(maxLength, settingFunc) {
	return function (_ref) {
		var target = _ref.target;

		var newValue = target.value;

		var isNumber = /[0-9]/.test(newValue);

		if (isNumber === false && newValue !== '') {
			return;
		}

		if (newValue.length > maxLength) {
			return;
		}

		var valueAsNumber = newValue !== '' ? parseInt(newValue, 10) : null;

		settingFunc(valueAsNumber);
	};
};

var setValidationErrorReason = function setValidationErrorReason(newState) {
	var isMonthInvalid = checkIsMonthInvalid(newState.value.month);
	var isYearInvalid = checkIsYearInvalid(newState.value.year);

	if (isMonthInvalid && isYearInvalid) {
		return _extends({}, newState, { validationErrorReason: 'INVALID_MONTH_AND_YEAR' });
	}

	if (isMonthInvalid) {
		return _extends({}, newState, { validationErrorReason: 'INVALID_MONTH' });
	}

	if (isYearInvalid) {
		return _extends({}, newState, { validationErrorReason: 'INVALID_YEAR' });
	}

	return _extends({}, newState, { validationErrorReason: '' });
};

var MonthAndYearDateInput = function (_Component) {
	inherits(MonthAndYearDateInput, _Component);

	function MonthAndYearDateInput(props) {
		classCallCheck(this, MonthAndYearDateInput);

		var _this = possibleConstructorReturn(this, (MonthAndYearDateInput.__proto__ || Object.getPrototypeOf(MonthAndYearDateInput)).call(this, props));

		_this.refInput = null;
		return _this;
	}

	createClass(MonthAndYearDateInput, [{
		key: 'focus',
		value: function focus() {
			if (this.refInput) {
				this.refInput.focus();
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    hasValidationEnabled = _props.hasValidationEnabled,
			    id = _props.id,
			    innerRef = _props.innerRef,
			    onBlur = _props.onBlur,
			    onChange = _props.onChange,
			    onFocus = _props.onFocus,
			    value = _props.value;


			var normalisedValue = function () {
				if (!value) {
					return {
						month: null,
						year: null
					};
				}

				if (!value.month && !value.year) {
					return { month: null, year: null };
				}

				if (!value.month) {
					return _extends({}, value, { month: null });
				}

				if (!value.year) {
					return _extends({}, value, { year: null });
				}

				return value;
			}();

			var month = normalisedValue.month,
			    year = normalisedValue.year;


			var monthAsString = month !== null ? month.toString() : '';
			var yearAsString = year !== null ? year.toString() : '';

			var setMonth = function setMonth(month) {
				var newState = {
					value: _extends({}, normalisedValue, { month: month })
				};

				onChange(setValidationErrorReason(newState));
			};

			var setYear = function setYear(year) {
				var newState = {
					value: _extends({}, normalisedValue, { year: year })
				};

				onChange(setValidationErrorReason(newState));
			};

			var monthHasError = checkIsMonthInvalid(month);
			var yearHasError = checkIsYearInvalid(year);

			if (innerRef) {
				innerRef(this);
			}

			return React.createElement(
				InternalComponentFrame,
				{ packageJson: packageJson$e },
				React.createElement(Inline.LeftAligned, {
					nodes: [React.createElement(
						StyledMonthInput$1,
						{ key: 'month' },
						React.createElement(
							InternalControlLabel,
							{ htmlFor: id + '-month' },
							'Month'
						),
						React.createElement(StyledInput$4, {
							id: id + '-month',
							inputMode: 'numeric',
							innerRef: function innerRef(element) {
								_this2.refInput = element;
							},
							min: 0,
							name: id + '-month',
							onChange: onChangeHandler$6(MONTH_MAX_LENGTH, setMonth),
							onFocus: onFocus,
							onKeyDown: function onKeyDown(event) {
								return keyHandler$1(event);
							},
							size: MONTH_MAX_LENGTH,
							type: 'number',
							value: monthAsString,
							className: monthHasError && hasValidationEnabled ? 'error' : ''
						})
					), React.createElement(
						StyledYearInput$1,
						{ key: 'year' },
						React.createElement(
							InternalControlLabel,
							{ htmlFor: id + '-year' },
							'Year'
						),
						React.createElement(StyledInput$4, {
							id: id + '-Year',
							inputMode: 'numeric',
							min: 0,
							name: id + '-year',
							onBlur: onBlur,
							onChange: onChangeHandler$6(YEAR_LENGTH, setYear),
							onKeyDown: function onKeyDown(event) {
								return keyHandler$1(event);
							},
							size: YEAR_LENGTH,
							type: 'number',
							value: yearAsString,
							className: yearHasError && hasValidationEnabled ? 'error' : ''
						})
					)]
				})
			);
		}
	}]);
	return MonthAndYearDateInput;
}(Component);

MonthAndYearDateInput.propTypes = {
	/** Sets if validation highlighting is shown. */
	hasValidationEnabled: PropTypes.bool,
	/** The id of the component. */
	id: PropTypes.string.isRequired,
	/** Used to access the internal input inside the theme wrapper. */
	innerRef: PropTypes.func,
	/** Callback function triggered on blur. */
	onBlur: PropTypes.func,
	/** Callback function triggered on change.
  *
  * returns: {
  *   value: {
  *     month: number,
  *     year: number
  *   },
  *   validationErrorReason: [INVALID_MONTH|INVALID_YEAR|INVALID_MONTH_AND_YEAR]
  * }
  */
	onChange: PropTypes.func.isRequired,
	/** Callback function triggered on focus. */
	onFocus: PropTypes.func,
	/** Values passed into the input. */
	value: PropTypes.shape({
		month: PropTypes.number,
		year: PropTypes.number
	})
};

MonthAndYearDateInput.defaultProps = {};

MonthAndYearDateInput.defaultExample = function () {
	return React.createElement(MonthAndYearDateInput, { id: 'default-month-year', onChange: function onChange() {}, value: { month: 2, year: 1995 } });
};

var main$f = "SortcodeInput.js";
var packageJson$f = {
	main: main$f,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$l = taggedTemplateLiteral(['\n\tdisplay: flex;\n\n\tinput[type=\'number\'] {\n\t\t-moz-appearance: textfield;\n\t}\n\tinput[type=\'number\']::-webkit-inner-spin-button,\n\tinput[type=\'number\']::-webkit-outer-spin-button {\n\t\t-webkit-appearance: none;\n\t\tmargin: 0;\n\t}\n'], ['\n\tdisplay: flex;\n\n\tinput[type=\'number\'] {\n\t\t-moz-appearance: textfield;\n\t}\n\tinput[type=\'number\']::-webkit-inner-spin-button,\n\tinput[type=\'number\']::-webkit-outer-spin-button {\n\t\t-webkit-appearance: none;\n\t\tmargin: 0;\n\t}\n']),
    _templateObject2$a = taggedTemplateLiteral(['\n\twidth: 50px;\n\tmargin-right: 16px;\n'], ['\n\twidth: 50px;\n\tmargin-right: 16px;\n']),
    _templateObject3$7 = taggedTemplateLiteral(['\n\tborder: ', ';\n\tborder-color: ', ';\n\tborder-radius: ', ';\n\t', ';\n\tbox-sizing: border-box;\n\tfont-size: ', ';\n\tmin-height: ', ';\n\tpadding: ', ';\n\twidth: 100%;\n\ttext-align: center;\n'], ['\n\tborder: ', ';\n\tborder-color: ', ';\n\tborder-radius: ', ';\n\t', ';\n\tbox-sizing: border-box;\n\tfont-size: ', ';\n\tmin-height: ', ';\n\tpadding: ', ';\n\twidth: 100%;\n\ttext-align: center;\n']);

var CONSTS = {
	MAX_LENGTH: 6,
	BANK_ID: 0,
	BRANCH_ID_1: 1,
	BRANCH_ID_2: 2
};

var StyledWrapper$7 = styled('div')(_templateObject$l);

var StyledInputWrapper$1 = styled('div')(_templateObject2$a);

var StyledInput$5 = styled('input')(_templateObject3$7, function (props) {
	return props.theme.borderWidth + ' solid ' + props.theme.colours.borderInteraction;
}, function (props) {
	return props.hasError ? colours.utility.error : props.theme.colours.borderInteraction;
}, function (props) {
	return props.theme.borderRadius;
}, externalMarginRegular, function (props) {
	return props.theme.isCompact ? '12px' : '16px';
}, spacing.SEXTUPLE, spacing.SINGLE);

var SortcodeInput = function (_Component) {
	inherits(SortcodeInput, _Component);

	function SortcodeInput(props) {
		classCallCheck(this, SortcodeInput);

		var _this = possibleConstructorReturn(this, (SortcodeInput.__proto__ || Object.getPrototypeOf(SortcodeInput)).call(this, props));

		var VALUE_1_START = 0;
		var VALUE_1_END = 2;
		var VALUE_2_END = 4;
		var VALUE_3_END = 6;

		var inputValue1 = props.value ? props.value.slice(VALUE_1_START, VALUE_1_END) : [];
		var inputValue2 = props.value ? props.value.slice(VALUE_1_END, VALUE_2_END) : [];
		var inputValue3 = props.value ? props.value.slice(VALUE_2_END, VALUE_3_END) : [];

		_this.state = {
			inputValue1: inputValue1,
			inputValue2: inputValue2,
			inputValue3: inputValue3
		};

		_this.setSortcodeValue = function (id, value) {
			switch (id) {
				case CONSTS.BANK_ID:
					_this.setState({ inputValue1: value }, function () {
						return _this.returnValidSortcode();
					});
					break;
				case CONSTS.BRANCH_ID_1:
					_this.setState({ inputValue2: value }, function () {
						return _this.returnValidSortcode();
					});
					break;
				case CONSTS.BRANCH_ID_2:
					_this.setState({ inputValue3: value }, function () {
						return _this.returnValidSortcode();
					});
					break;
			}
		};

		_this.returnValidSortcode = function () {
			var sortcodeString = '' + _this.state.inputValue1 + _this.state.inputValue2 + _this.state.inputValue3;
			var isValid = sortcodeString.length === CONSTS.MAX_LENGTH;

			props.onChange({ isValid: isValid, value: sortcodeString });
		};

		_this.handleChange = function (event, inputRef, id) {
			var value = event.target.value;


			var formattedValue = _this.formatValue(value);

			if (formattedValue.length > 1 && inputRef) {
				inputRef.focus();
			}

			_this.setSortcodeValue(id, formattedValue);
		};

		_this.formatValue = function (value) {
			var newValue = value.slice(0, 2).replace(/[^0-9]/g, '');
			if (newValue === '') {
				newValue = [];
			}

			return newValue;
		};
		return _this;
	}

	createClass(SortcodeInput, [{
		key: 'focus',
		value: function focus() {
			if (this.refInput) {
				this.refInput.focus();
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _state = this.state,
			    inputValue1 = _state.inputValue1,
			    inputValue2 = _state.inputValue2,
			    inputValue3 = _state.inputValue3;
			var _props = this.props,
			    hasValidationEnabled = _props.hasValidationEnabled,
			    id = _props.id,
			    innerRef = _props.innerRef,
			    onBlur = _props.onBlur,
			    onFocus = _props.onFocus;


			var inputvalue1Error = inputValue1.length < 2;
			var inputvalue2Error = inputValue2.length < 2;
			var inputvalue3Error = inputValue3.length < 2;

			if (innerRef) {
				innerRef(this);
			}

			return React.createElement(
				InternalComponentFrame,
				{ packageJson: packageJson$f, hasCustomMargins: true },
				React.createElement(
					StyledWrapper$7,
					null,
					React.createElement(
						StyledInputWrapper$1,
						null,
						React.createElement(StyledInput$5, {
							id: id,
							innerRef: function innerRef(element) {
								_this2.refInput = element;
							},
							hasError: hasValidationEnabled && inputvalue1Error,
							onChange: function onChange(event) {
								_this2.handleChange(event, _this2.numberInput2, CONSTS.BANK_ID);
							},
							onFocus: onFocus,
							type: 'number',
							value: inputValue1
						})
					),
					React.createElement(
						StyledInputWrapper$1,
						null,
						React.createElement(StyledInput$5, {
							hasError: hasValidationEnabled && inputvalue2Error,
							onChange: function onChange(event) {
								_this2.handleChange(event, _this2.numberInput3, CONSTS.BRANCH_ID_1);
							},
							type: 'number',
							value: inputValue2
						})
					),
					React.createElement(
						StyledInputWrapper$1,
						null,
						React.createElement(StyledInput$5, {
							hasError: hasValidationEnabled && inputvalue3Error,
							onBlur: onBlur,
							onChange: function onChange(event) {
								_this2.handleChange(event, null, CONSTS.BRANCH_ID_2);
							},
							type: 'number',
							value: inputValue3
						})
					)
				)
			);
		}
	}]);
	return SortcodeInput;
}(Component);

SortcodeInput.propTypes = {
	/** Validation visual hints enabled boolean. */
	hasValidationEnabled: PropTypes.bool,
	/** Input id attribute string.  */
	id: PropTypes.string,
	/** Used to access the internal input inside the theme wrapper. */
	innerRef: PropTypes.func,
	/** Callback function triggered on blur. */
	onBlur: PropTypes.func,
	/** Callback function triggered on change. */
	onChange: PropTypes.func.isRequired,
	/** Callback function triggered on focus. */
	onFocus: PropTypes.func,
	/** Sort code value string. */
	value: PropTypes.string
};

SortcodeInput.defaultExample = function () {
	return React.createElement(SortcodeInput, { onChange: function onChange(val) {
			return val;
		} });
};

var _extends$4 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$3(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$3(_ref, ["styles"]);

  return React.createElement("svg", _extends$4({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M95.802 3.212c0-.006.003-.013.003-.02l-.003-.018-.004-.176c0-.717-.31-1.347-.758-1.86-.057-.076-.099-.162-.166-.233-.067-.064-.157-.105-.234-.163C94.122.301 93.485 0 92.77.003h-.176L92.57 0c-.012 0-.022.006-.035.006L60.411.208c-1.67.006-3.016 1.443-3.007 3.212.003 1.77 1.363 3.196 3.033 3.19l24.48-.15-52.01 52.201a3.118 3.118 0 0 0 .02 4.422 3.147 3.147 0 0 0 4.44-.016l52.046-52.24.153 24.323c.01 1.667 1.453 3.01 3.232 2.998 1.775-.007 3.212-1.357 3.202-3.02l-.198-31.916zM83.18 86.348a3.2 3.2 0 0 1-3.2 3.2H9.598a3.2 3.2 0 0 1-3.2-3.2V15.964a3.2 3.2 0 0 1 3.2-3.199h41.59V6.367H6.398A6.4 6.4 0 0 0 0 12.765v76.782a6.4 6.4 0 0 0 6.399 6.399H83.18a6.399 6.399 0 0 0 6.398-6.399v-44.79h-6.398v41.59z" }));
});

var _extends$5 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$4(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$4(_ref, ["styles"]);

  return React.createElement("svg", _extends$5({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M36.888 4.096v8H8.336v71.996h72v-32h8v40h-88V4.096zM92.464.364v24h-8l-.001-10.344-20.201 20.203a44.03 44.03 0 0 1-11.88 8.338A80.542 80.542 0 0 1 56 67.266V76h-8v-8.734A73.774 73.774 0 0 0 44.969 45.5a61.199 61.199 0 0 1-11.586 2.414 13.904 13.904 0 0 1-11.445-4.016l-.297-.33c-4.983-5.435-4.998-13.773-.036-19.226l.29-.32c5.471-5.46 14.329-5.46 19.8 0a41.831 41.831 0 0 1 7.7 11.1 35.775 35.775 0 0 0 9.21-6.556L78.807 8.364H68.464v-8zM27.695 29.537a6.278 6.278 0 0 0 .047 8.848 5.953 5.953 0 0 0 4.758 1.578 53.648 53.648 0 0 0 9.48-1.908 32.764 32.764 0 0 0-5.773-8.211 6.08 6.08 0 0 0-8.512-.307z" }));
});

var getPopoutOutlineLarge = getThemeIcon(VMIcon$1, GenericIcon$1);

var main$g = "WebsiteLink.js";
var packageJson$g = {
	main: main$g,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$m = taggedTemplateLiteral(['\n\tdisplay: inline-flex;\n\tmargin-left: ', ';\n\n\t> svg {\n\t\tfill: ', ';\n\t\theight: ', ';\n\t\twidth: ', ';\n\t}\n'], ['\n\tdisplay: inline-flex;\n\tmargin-left: ', ';\n\n\t> svg {\n\t\tfill: ', ';\n\t\theight: ', ';\n\t\twidth: ', ';\n\t}\n']),
    _templateObject2$b = taggedTemplateLiteral(['\n\tcolor: ', ';\n\ttext-decoration: underline;\n\tword-wrap: break-word;\n'], ['\n\tcolor: ', ';\n\ttext-decoration: underline;\n\tword-wrap: break-word;\n']);

var StyledIcon = styled('span')(_templateObject$m, function (props) {
	return props.theme.isCompact ? '2px' : '4px';
}, function (props) {
	return props.theme.colours.links;
}, function (props) {
	return props.theme.isCompact ? '8px' : '16px';
}, function (props) {
	return props.theme.isCompact ? '8px' : '16px';
});

var StyledLink = styled('a')(_templateObject2$b, function (props) {
	return props.theme.colours.links;
});

/**
 * When willOpenNewWindow is true `<a>` tag will have `rel = noopener noreferrer`.
 * @example ./Design.md
 */
// eslint-disable-next-line react/prop-types
var WebsiteLink = function WebsiteLink(_ref) {
	var linkText = _ref.linkText,
	    linkTitle = _ref.linkTitle,
	    theme = _ref.theme,
	    url = _ref.url,
	    willOpenNewWindow = _ref.willOpenNewWindow;

	var target = willOpenNewWindow ? '_blank' : '_self';
	var PopoutIcon = getPopoutOutlineLarge(theme.name);

	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$g, hasCustomMargins: true, layout: 'inline' },
		React.createElement(
			StyledLink,
			{
				href: '' + url,
				target: target,
				title: linkTitle,
				rel: willOpenNewWindow ? 'noopener noreferrer' : null
			},
			React.createElement(
				'span',
				null,
				linkText || url
			),
			willOpenNewWindow && React.createElement(
				StyledIcon,
				null,
				React.createElement(PopoutIcon, null)
			)
		)
	);
};

WebsiteLink.propTypes = {
	/** Displayed text */
	linkText: PropTypes.string,
	/** Native 'a' title attribute text */
	linkTitle: PropTypes.string,
	/** Website url */
	url: PropTypes.string.isRequired,
	/* Opens link in a new tab or window when clicked */
	willOpenNewWindow: PropTypes.bool
};

WebsiteLink.defaultProps = {
	willOpenNewWindow: false
};

var WrappedWebsiteLink = withTheme(WebsiteLink);

WrappedWebsiteLink.defaultExample = function () {
	return React.createElement(WrappedWebsiteLink, { url: 'https://uk.virginmoney.com/' });
};

var main$h = "UKOnlyMobileNumberInput.js";
var packageJson$h = {
	main: main$h,
	"component-id": 1013,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$n = taggedTemplateLiteral(['\n\tinput {\n\t\tmargin-bottom: ', ';\n\n\t\t', '};\n\t}\n'], ['\n\tinput {\n\t\tmargin-bottom: ', ';\n\n\t\t', '};\n\t}\n']);

var StyledWrapper$8 = styled('div')(_templateObject$n, spacing.DOUBLE, function (props) {
	return props.hasValidationError && 'border: ' + props.theme.borderWidth + ' solid ' + colours.utility.error;
});

var validationReasons$3 = {
	BELOW_MIN: 'BELOW_MIN',
	ABOVE_MAX: 'ABOVE_MAX'
};

var getValidationErrorReason$1 = function getValidationErrorReason(maxLength, minLength, valueToCheck) {
	var valueLength = valueToCheck.replace(/\s+/g, '').length;

	if (valueLength > maxLength) {
		return validationReasons$3.ABOVE_MAX;
	}

	if (valueLength < minLength) {
		return validationReasons$3.BELOW_MIN;
	}

	return '';
};

var onChangeHandler$7 = function onChangeHandler(maxLength, minLength, onChange) {
	return function (output) {
		var value = output.value;


		onChange({
			value: value,
			validationErrorReason: getValidationErrorReason$1(maxLength, minLength, value)
		});
	};
};

/**
 * @example ./Design.md
 */

var UKOnlyMobileNumberInput = function (_Component) {
	inherits(UKOnlyMobileNumberInput, _Component);

	function UKOnlyMobileNumberInput(props) {
		classCallCheck(this, UKOnlyMobileNumberInput);

		var _this = possibleConstructorReturn(this, (UKOnlyMobileNumberInput.__proto__ || Object.getPrototypeOf(UKOnlyMobileNumberInput)).call(this, props));

		_this.refInput = null;
		return _this;
	}

	createClass(UKOnlyMobileNumberInput, [{
		key: 'focus',
		value: function focus() {
			if (this.refInput) {
				this.refInput.focus();
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    id = _props.id,
			    hasValidationEnabled = _props.hasValidationEnabled,
			    value = _props.value,
			    onBlur = _props.onBlur,
			    onChange = _props.onChange,
			    onFocus = _props.onFocus,
			    innerRef = _props.innerRef,
			    contactUsUrl = _props.contactUsUrl,
			    maxLength = _props.maxLength,
			    minLength = _props.minLength;


			var hasValidationError = getValidationErrorReason$1(maxLength, minLength, value) !== '';

			if (innerRef) {
				innerRef(this);
			}

			return React.createElement(
				InternalComponentFrame,
				{ packageJson: packageJson$h },
				React.createElement(
					StyledWrapper$8,
					null,
					React.createElement(InternalTelephoneInput, {
						characterCount: 18,
						hasValidationError: hasValidationError && hasValidationEnabled,
						id: id,
						innerRef: function innerRef(element) {
							_this2.refInput = element;
						},
						onBlur: onBlur,
						onChange: onChangeHandler$7(maxLength, minLength, onChange),
						onFocus: onFocus,
						value: value
					}),
					React.createElement(
						StandardBody,
						{ isFlush: true },
						'If you want to use an overseas number, please',
						' ',
						React.createElement(WrappedWebsiteLink, { willOpenNewWindow: true, linkText: 'get in touch with us', url: contactUsUrl }),
						'.'
					)
				)
			);
		}
	}]);
	return UKOnlyMobileNumberInput;
}(Component);

UKOnlyMobileNumberInput.propTypes = {
	/** Url used in the 'get in touch with us' link. */
	contactUsUrl: PropTypes.string.isRequired,
	/** Sets if validation highlighting is shown. */
	hasValidationEnabled: PropTypes.bool,
	/** Sets the ID attribute on the component, needed to attach it to an associated label in the DOM. */
	id: PropTypes.string.isRequired,
	/** Used to access the internal input inside the theme wrapper. */
	innerRef: PropTypes.func,
	/** The maximum character length of the input after space removal. */
	maxLength: PropTypes.number,
	/** The minimum character length of the input after space removal. */
	minLength: PropTypes.number,
	/** Callback function triggered on blur. */
	onBlur: PropTypes.func,
	/** Callback function triggered on change.
  *
  * Returns object:
  *
  * value [number],
  *
  * validationErrorReason [string]
  */
	onChange: PropTypes.func.isRequired,
	/** Callback function triggered on focus. */
	onFocus: PropTypes.func,
	/** The value of the input. */
	value: PropTypes.string.isRequired
};

UKOnlyMobileNumberInput.defaultProps = {
	maxLength: 11,
	minLength: 6
};

UKOnlyMobileNumberInput.defaultExample = function () {
	return React.createElement(UKOnlyMobileNumberInput, {
		id: 'default-uk-mobile-number',
		onChange: function onChange() {},
		value: '1234 567 8901',
		contactUsUrl: 'https://uk.virginmoney.com/'
	});
};

var main$i = "UKOnlyPostcodeInput.js";
var packageJson$i = {
	main: main$i,
	"component-id": 1006,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var MAX_CHARS = 8;

var POSTCODE_REGEX = /^(([A-Z]{1,2}\d[A-Z\d]?|ASCN|STHL|TDCU|BBND|[BFS]IQQ|PCRN|TKCA) ?\d[A-Z]{2}|(KY\d|MSR|VG|AI)[ -]?\d{4}|[A-Z]{2} ?\d{2}|GE ?CX)$/;
var BFPO_REGEX = /^BF\d ?\d[A-Z]{2}|BFPO ?\d{1,4}$/;
var ALPHANUMERIC_OR_SPACE_REGEX = /^[A-Z0-9\s]*$/;

var validationErrorReasons$1 = {
	INVALID_POSTCODE: 'INVALID_POSTCODE',
	BFPO_POSTCODE: 'BFPO_POSTCODE'
};

var getNormalisedValue$1 = function getNormalisedValue(value) {
	return value === null || value === undefined ? '' : value;
};

var getValidationErrorReason$2 = function getValidationErrorReason(allowBFPO, value) {
	var valueForComparison = value.toUpperCase().replace(' ', '');

	var isBritishForcesPostcode = BFPO_REGEX.test(valueForComparison);

	if (isBritishForcesPostcode && allowBFPO === false) {
		return validationErrorReasons$1.BFPO_POSTCODE;
	}

	var isValidPostcode = POSTCODE_REGEX.test(valueForComparison);

	return isValidPostcode ? '' : validationErrorReasons$1.INVALID_POSTCODE;
};

var onChangeHandler$8 = function onChangeHandler(allowBFPO, onChange) {
	return function (containedValue) {
		//TODOxVMUI: Need to look at merging reasons with internal input reasons.
		var value = containedValue.value,
		    _validationErrorReason = containedValue._validationErrorReason;

		var normalisedValue = getNormalisedValue$1(value);
		var isLetterOrNumberOrSpace = ALPHANUMERIC_OR_SPACE_REGEX.test(normalisedValue.toUpperCase());

		if (isLetterOrNumberOrSpace === false && normalisedValue !== '') {
			return;
		}

		if (value.length > MAX_CHARS) {
			return;
		}

		onChange({
			value: normalisedValue,
			validationErrorReason: getValidationErrorReason$2(allowBFPO, normalisedValue)
		});
	};
};

var UKOnlyPostcodeInput = function UKOnlyPostcodeInput(_ref) {
	var allowBFPO = _ref.allowBFPO,
	    hasValidationEnabled = _ref.hasValidationEnabled,
	    id = _ref.id,
	    innerRef = _ref.innerRef,
	    onBlur = _ref.onBlur,
	    onChange = _ref.onChange,
	    onFocus = _ref.onFocus,
	    value = _ref.value;

	var normalisedValue = getNormalisedValue$1(value);
	var hasValueError = getValidationErrorReason$2(allowBFPO, normalisedValue) !== '';

	var hasValidationError = !!hasValidationEnabled && hasValueError;

	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$i, layout: 'inline' },
		React.createElement(InternalStandardTextInput, {
			characterCount: MAX_CHARS,
			hasValidationError: hasValidationError,
			id: id,
			innerRef: innerRef,
			maxLength: MAX_CHARS,
			onBlur: onBlur,
			onChange: onChangeHandler$8(allowBFPO, onChange),
			onFocus: onFocus,
			value: normalisedValue
		})
	);
};

UKOnlyPostcodeInput.propTypes = {
	/** Sets if British Forces Post Office (BFPO) address will not cause validation error. */
	allowBFPO: PropTypes.bool,
	/** Sets if validation highlighting is shown. */
	hasValidationEnabled: PropTypes.bool,
	/** Sets the ID attribute on the component, needed to attach it to an associated label in the DOM. */
	id: PropTypes.string.isRequired,
	/** Used to access the internal input inside the theme wrapper. */
	innerRef: PropTypes.func,
	/** Callback function triggered on blur. */
	onBlur: PropTypes.func,
	/** Callback function triggered on change.
  *
  * returns: {
  *   validationErrorReason: 'INVALID_POSTCODE'|'BFPO_POSTCODE',
  *   value: string,
  * }
  */
	onChange: PropTypes.func.isRequired,
	/** Callback function triggered on focus. */
	onFocus: PropTypes.func,
	/** values passed into the input. */
	value: PropTypes.string
};

UKOnlyPostcodeInput.defaultProps = {
	allowBFPO: false
};

UKOnlyPostcodeInput.validationLiterals = _extends({ WHEN_VALID: '' }, validationErrorReasons$1);

UKOnlyPostcodeInput.defaultExample = function () {
	return React.createElement(UKOnlyPostcodeInput, { id: 'default-postcode-example', onChange: function onChange() {}, value: 'A12 3BC' });
};

var _extends$6 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$5(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon$2 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$5(_ref, ["styles"]);

  return React.createElement("svg", _extends$6({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M48 62.862l39.413-40.354a4.972 4.972 0 0 1 7.114 0l.144.148a5 5 0 0 1 0 6.988L51.845 73.492A4.96 4.96 0 0 1 48 74.982a4.959 4.959 0 0 1-3.845-1.49L1.329 29.644a5 5 0 0 1 0-6.988l.144-.148a4.972 4.972 0 0 1 7.114 0L48 62.862z" }));
});

var _extends$7 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$6(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon$2 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$6(_ref, ["styles"]);

  return React.createElement("svg", _extends$7({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M48.799 76.174a7.134 7.134 0 0 1-5.06-2.097L.8 31.137l10.12-10.12 37.88 37.88 37.88-37.88 10.12 10.12-42.94 42.94a7.134 7.134 0 0 1-5.06 2.097z" }));
});

var getChevronDownSolidLarge = getThemeIcon(VMIcon$2, GenericIcon$2);

var _extends$8 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$7(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var CycleLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$7(_ref, ["styles"]);

  return React.createElement("svg", _extends$8({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("title", null, "icon-cycle-large"), React.createElement("path", { d: "M11.786 14.123l.81 1.467c.138.246.028.427-.24.41l-3.92-.275c-.266-.018-.39-.24-.27-.49l1.732-3.676c.117-.252.324-.26.458-.016l.793 1.428c.323-.223.626-.48.9-.767a6.08 6.08 0 0 0 1.677-4.224c0-1.605-.61-3.11-1.676-4.223a5.844 5.844 0 0 0-.92-.78.681.681 0 0 1-.184-.92.62.62 0 0 1 .882-.19c.404.275.78.595 1.122.95A7.443 7.443 0 0 1 15 7.982a7.441 7.441 0 0 1-2.05 5.164c-.354.37-.744.698-1.164.98zm-6.94-11.13c-.32.22-.62.477-.896.763A6.088 6.088 0 0 0 2.273 7.98c0 1.607.61 3.11 1.677 4.224.28.293.59.553.92.78.294.2.376.612.184.92a.617.617 0 0 1-.88.19 6.965 6.965 0 0 1-1.124-.95C1.745 11.784 1 9.944 1 7.98c0-1.962.748-3.802 2.05-5.163a7.282 7.282 0 0 1 1.16-.976L3.418.41C3.282.166 3.392-.016 3.66 0l3.86.262c.27.017.39.237.27.49L6.078 4.366c-.12.254-.326.26-.46.016l-.77-1.39z" }));
});

var _extends$9 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$8(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GridLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$8(_ref, ["styles"]);

  return React.createElement("svg", _extends$9({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { fillRule: "evenodd", d: "M7 9h2V7H7v2zm-1 1h4V6H6v4zm1-7h2V1H7v2zM6 4h4V0H6v4zm1 11h2v-2.001H7v2zm-1 1h4v-4H6v4zm7-7h2V7h-2v2zm-1 1h4V6h-4v4zm1-7h2V1h-2v2zm-1 1h4V0h-4v4zm1 11h2v-2.001h-2v2zm-1 1h4v-4h-4v4zM1 15h2v-2.001H1v2zm-1 1h4v-4H0v4zM1 3h2V1H1v2zM0 4h4V0H0v4zm1 5h2V7H1v2zm-1 1h4V6H0v4z" }));
});

var _extends$a = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$9(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var RadioIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$9(_ref, ["styles"]);

  return React.createElement("svg", _extends$a({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("circle", { cx: "48", cy: "48", r: "35" }));
});

var _extends$b = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$a(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon$3 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$a(_ref, ["styles"]);

  return React.createElement("svg", _extends$b({ xmlns: "http://www.w3.org/2000/svg", width: "32", height: "32", viewBox: "0 0 32 32" }, props), React.createElement("title", null, "icon list"), React.createElement("path", { d: "M6.5 9a2.5 2.5 0 0 1 0-5 2.5 2.5 0 0 1 0 5zm0 8a2.5 2.5 0 0 1 0-5 2.5 2.5 0 0 1 0 5zm0 8.5a2.5 2.5 0 0 1 0-5 2.5 2.5 0 0 1 0 5zM12 7a1 1 0 0 1 1-1h13.26a1 1 0 0 1 0 2H13c-.552 0-1-.45-1-1zm0 8a1 1 0 0 1 1-1h13.26a1 1 0 0 1 0 2H13c-.552 0-1-.45-1-1zm0 8a1 1 0 0 1 1-1h13.26a1 1 0 0 1 0 2H13c-.552 0-1-.45-1-1z" }));
});

var _extends$c = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$b(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon$3 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$b(_ref, ["styles"]);

  return React.createElement("svg", _extends$c({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M33.48 67.516l5.656 5.656L18.164 94.14 5.196 81.172l5.656-5.656 7.312 7.312zm59.984 8.828v8h-48v-8zM33.48 35.516l5.656 5.656L18.164 62.14 5.196 49.172l5.656-5.656 7.312 7.312zm59.984 8.828v8h-48v-8zM33.48 3.516l5.656 5.656L18.164 30.14 5.196 17.172l5.656-5.656 7.312 7.312zm59.984 8.828v8h-48v-8z" }));
});

var main$j = "ConditionalPanel.js";
var packageJson$j = {
	main: main$j,
	"component-id": 981,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$o = taggedTemplateLiteral(['\n\tbackground-color: white;\n\tborder-radius: 4px 0 0 4px;\n\t', ';\n\tmargin: 0 16px 24px 10px;\n\tpadding-bottom: 8px;\n\tpadding-left: 16px;\n\tposition: relative;\n\n\t:after {\n\t\tcontent: \'\';\n\t\twidth: 4px;\n\t\theight: 100%;\n\t\tdisplay: block;\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\tborder-radius: 4px;\n\t\tbackground-color: ', ';\n\t}\n'], ['\n\tbackground-color: white;\n\tborder-radius: 4px 0 0 4px;\n\t', ';\n\tmargin: 0 16px 24px 10px;\n\tpadding-bottom: 8px;\n\tpadding-left: 16px;\n\tposition: relative;\n\n\t:after {\n\t\tcontent: \'\';\n\t\twidth: 4px;\n\t\theight: 100%;\n\t\tdisplay: block;\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\tborder-radius: 4px;\n\t\tbackground-color: ', ';\n\t}\n']);

var StyledWrapper$9 = styled('div')(_templateObject$o, function (props) {
	return !props.isVisible && 'display: none;';
}, function (props) {
	return props.theme.colours.interaction;
});

/**
 * @example ./Design.md
 */
var ConditionalPanel = function ConditionalPanel(_ref) {
	var children = _ref.children,
	    isVisible = _ref.isVisible;
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$j, hasCustomMargins: true },
		React.createElement(
			StyledWrapper$9,
			{ isVisible: isVisible },
			children
		)
	);
};

ConditionalPanel.propTypes = {
	/** Content of the Panel. */
	children: PropTypes.node.isRequired,
	/** This will hide the panel when set to false. */
	isVisible: PropTypes.bool.isRequired
};

ConditionalPanel.defaultProps = {};

ConditionalPanel.defaultExample = function () {
	return React.createElement(
		ConditionalPanel,
		{ isVisible: true },
		React.createElement(
			'p',
			null,
			'Conent.'
		)
	);
};

var getListOutlineLarge = getThemeIcon(VMIcon$3, GenericIcon$3);

var _templateObject$p = taggedTemplateLiteral(['\n\talign-items: center;\n\tbackground: ', ';\n\tborder-color: ', ';\n\tborder-style: solid;\n\tborder-width: ', ';\n\t', '\n\t', '\n\tborder-radius: ', ';\n\tdisplay: inline-flex;\n\tposition: relative;\n\n\t', ';\n\t\n\tlabel {\n\t\talign-items: center;\n\t\tbox-sizing: border-box;\n\t\tcolor: ', ';\n\t\tcursor: ', ';\n\t\tdisplay: inline-flex;\n\t\t', ';\n\t\t\n\t\t// IE11 Solution to content stress test\n\t\t&:after {\n\t\t\tdisplay: block;\n\t\t\tcontent: \'\';\n\t\t\tmin-height: inherit;\n\t\t\tfont-size: 0;\n\t\t}\n\t}\n\n\tsvg {\n\t\tborder: 2px solid ', ';\n\t\tbackground: ', ';\n\t\tborder-radius: 100%;\n\t\theight: 24px;\n\t\tmargin-right: ', ';\n\t\twidth: 24px;\n\t}\n\n\tinput + label svg {\n\t\t', '\n\t\t', '\n\t\tflex-shrink: 0;\n\t}\n\t\n\t', '\n\t', '\n'], ['\n\talign-items: center;\n\tbackground: ', ';\n\tborder-color: ', ';\n\tborder-style: solid;\n\tborder-width: ', ';\n\t', '\n\t', '\n\tborder-radius: ', ';\n\tdisplay: inline-flex;\n\tposition: relative;\n\n\t', ';\n\t\n\tlabel {\n\t\talign-items: center;\n\t\tbox-sizing: border-box;\n\t\tcolor: ', ';\n\t\tcursor: ', ';\n\t\tdisplay: inline-flex;\n\t\t', ';\n\t\t\n\t\t// IE11 Solution to content stress test\n\t\t&:after {\n\t\t\tdisplay: block;\n\t\t\tcontent: \'\';\n\t\t\tmin-height: inherit;\n\t\t\tfont-size: 0;\n\t\t}\n\t}\n\n\tsvg {\n\t\tborder: 2px solid ', ';\n\t\tbackground: ', ';\n\t\tborder-radius: 100%;\n\t\theight: 24px;\n\t\tmargin-right: ', ';\n\t\twidth: 24px;\n\t}\n\n\tinput + label svg {\n\t\t', '\n\t\t', '\n\t\tflex-shrink: 0;\n\t}\n\t\n\t', '\n\t', '\n']),
    _templateObject2$c = taggedTemplateLiteral(['\n\tdisplay: flex;\n'], ['\n\tdisplay: flex;\n']);

var StyledWrapper$a = styled('div')(_templateObject$p, function (props) {
	return props.isDisabled ? colours.disabled.background : colours.backgrounds.component;
}, colours.disabled.border, function (props) {
	return props.theme.borderWidth;
}, function (props) {
	return !props.hasIcon && props.theme.name === 'vm' && 'background: transparent;\n\tborder: none;';
}, function (props) {
	return props.isChecked && !props.isDisabled && 'border-color: ' + props.theme.colours.interaction + ';';
}, function (props) {
	return props.theme.borderRadius;
}, inputStyles, function (props) {
	return props.theme.colours.bodyText;
}, function (props) {
	return props.isDisabled ? 'not-allowed' : 'pointer';
}, function (props) {
	return !props.hasIcon && props.theme.name === 'vm' ? 'padding: 0' : 'min-height: 32px; min-width: 98px; padding: ' + spacing.SINGLE + ' ' + spacing.DOUBLE;
}, function (props) {
	return props.theme.colours.interaction;
}, function (props) {
	return props.isDisabled ? colours.disabled.background : colours.backgrounds.component;
}, spacing.SINGLE, function (props) {
	return props.isDisabled && 'border-color: ' + colours.disabled.border + ';';
}, function (props) {
	return props.hasError && !props.isDisabled && 'border-color: ' + colours.utilitySupremacy.errorPrimary + ';';
}, function (props) {
	return props.hasIcon && '\n\t\tsvg {\n\t\t\tborder: 0;\n\t\t\tborder-radius: 0;\n\t\t\tfill: ' + (props.isChecked ? props.theme.colours.primary : colours.disabled.border) + ';\n\t\t}\n\t';
}, function (props) {
	return props.hasGridIcon && 'svg { margin-right: ' + spacing.ONE_AND_HALF + '; }';
});

var StyledRadioIcon = styled('div')(_templateObject2$c);

var getIconFillColour$1 = function getIconFillColour(isChecked, isDisabled, hasError, theme) {
	if (isChecked && isDisabled) {
		return colours.disabled.border;
	}
	if (hasError && isChecked) {
		return colours.utilitySupremacy.errorPrimary;
	}
	if (isChecked) {
		return theme.colours.interaction;
	}
	if (isDisabled) {
		return colours.disabled.background;
	}
	return 'transparent';
};

var BaseInputRadio = function (_Component) {
	inherits(BaseInputRadio, _Component);

	function BaseInputRadio(props) {
		classCallCheck(this, BaseInputRadio);

		var _this = possibleConstructorReturn(this, (BaseInputRadio.__proto__ || Object.getPrototypeOf(BaseInputRadio)).call(this, props));

		_this.refInput = null;
		return _this;
	}

	createClass(BaseInputRadio, [{
		key: 'focus',
		value: function focus() {
			if (this.refInput) {
				this.refInput.focus();
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    hasError = _props.hasError,
			    id = _props.id,
			    innerRef = _props.innerRef,
			    isChecked = _props.isChecked,
			    isDisabled = _props.isDisabled,
			    labelText = _props.labelText,
			    name = _props.name,
			    onBlur = _props.onBlur,
			    onChange = _props.onChange,
			    onFocus = _props.onFocus,
			    theme = _props.theme;


			if (innerRef) {
				innerRef(this);
			}

			return React.createElement(
				StyledWrapper$a,
				{
					hasError: hasError,
					numberOfWords: labelText.split(' ').length,
					isChecked: isChecked,
					isDisabled: isDisabled
				},
				React.createElement('input', {
					checked: isChecked,
					disabled: isDisabled,
					id: id,
					name: name,
					onBlur: onBlur,
					onChange: onChange,
					onFocus: onFocus,
					type: 'radio',
					value: labelText,
					ref: function ref(element) {
						_this2.refInput = element;
					}
				}),
				React.createElement(
					'label',
					{ htmlFor: id },
					React.createElement(
						StyledRadioIcon,
						null,
						React.createElement(RadioIcon, { fill: getIconFillColour$1(isChecked, isDisabled, hasError, theme) })
					),
					React.createElement(
						InternalStandardBody,
						{ isFlush: true },
						React.createElement(
							'span',
							null,
							labelText
						)
					)
				)
			);
		}
	}]);
	return BaseInputRadio;
}(Component);

var GridViewInputRadio = function (_Component2) {
	inherits(GridViewInputRadio, _Component2);

	function GridViewInputRadio(props) {
		classCallCheck(this, GridViewInputRadio);

		var _this3 = possibleConstructorReturn(this, (GridViewInputRadio.__proto__ || Object.getPrototypeOf(GridViewInputRadio)).call(this, props));

		_this3.refInput = null;
		return _this3;
	}

	createClass(GridViewInputRadio, [{
		key: 'focus',
		value: function focus() {
			if (this.refInput) {
				this.refInput.focus();
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this4 = this;

			var _props2 = this.props,
			    hasError = _props2.hasError,
			    id = _props2.id,
			    isChecked = _props2.isChecked,
			    isDisabled = _props2.isDisabled,
			    innerRef = _props2.innerRef,
			    labelText = _props2.labelText,
			    name = _props2.name,
			    onBlur = _props2.onBlur,
			    onChange = _props2.onChange,
			    onFocus = _props2.onFocus;


			if (innerRef) {
				innerRef(this);
			}

			return React.createElement(
				StyledWrapper$a,
				{ hasError: hasError, isChecked: isChecked, isDisabled: isDisabled, hasIcon: true, hasGridIcon: true },
				React.createElement('input', {
					checked: isChecked,
					disabled: isDisabled,
					id: id,
					name: name,
					onBlur: onBlur,
					onChange: onChange,
					onFocus: onFocus,
					type: 'radio',
					value: labelText,
					ref: function ref(element) {
						_this4.refInput = element;
					}
				}),
				React.createElement(
					'label',
					{ htmlFor: id },
					React.createElement(GridLarge, null),
					labelText
				)
			);
		}
	}]);
	return GridViewInputRadio;
}(Component);

var ListViewInputRadio = function (_Component3) {
	inherits(ListViewInputRadio, _Component3);

	function ListViewInputRadio(props) {
		classCallCheck(this, ListViewInputRadio);

		var _this5 = possibleConstructorReturn(this, (ListViewInputRadio.__proto__ || Object.getPrototypeOf(ListViewInputRadio)).call(this, props));

		_this5.refInput = null;
		return _this5;
	}

	createClass(ListViewInputRadio, [{
		key: 'focus',
		value: function focus() {
			if (this.refInput) {
				this.refInput.focus();
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this6 = this;

			// eslint-disable-next-line react/prop-types
			var _props3 = this.props,
			    hasError = _props3.hasError,
			    id = _props3.id,
			    innerRef = _props3.innerRef,
			    isChecked = _props3.isChecked,
			    isDisabled = _props3.isDisabled,
			    labelText = _props3.labelText,
			    name = _props3.name,
			    onBlur = _props3.onBlur,
			    onChange = _props3.onChange,
			    onFocus = _props3.onFocus,
			    theme = _props3.theme;

			var ListOutlineLargeIcon = getListOutlineLarge(theme.name);

			if (innerRef) {
				innerRef(this);
			}

			return React.createElement(
				StyledWrapper$a,
				{ hasError: hasError, isChecked: isChecked, isDisabled: isDisabled, hasIcon: true, hasListIcon: true },
				React.createElement('input', {
					checked: isChecked,
					disabled: isDisabled,
					id: id,
					name: name,
					onBlur: onBlur,
					onChange: onChange,
					onFocus: onFocus,
					type: 'radio',
					value: labelText,
					ref: function ref(element) {
						_this6.refInput = element;
					}
				}),
				React.createElement(
					'label',
					{ htmlFor: id },
					React.createElement(ListOutlineLargeIcon, null),
					labelText
				)
			);
		}
	}]);
	return ListViewInputRadio;
}(Component);

var basePropTypes$1 = {
	/** Changes radio colour when set to true. */
	hasError: PropTypes.bool,
	/** An ID HTML attribute for the radio element. Must be unique on any individual page. */
	id: PropTypes.string.isRequired,
	/** Boolean controlling whether radio input is checked. */
	isChecked: PropTypes.bool,
	/** Boolean controlling whether radio input is disabled. */
	isDisabled: PropTypes.bool,
	/** Used to access the internal input inside the theme wrapper. */
	innerRef: PropTypes.func,
	/** The radio input label. */
	labelText: PropTypes.string.isRequired,
	/** HTML name attribute value that this radio option belongs to. */
	name: PropTypes.string.isRequired,
	/** Callback function triggered on blur. */
	onBlur: PropTypes.func,
	/** Callback function triggered on change. */
	onChange: PropTypes.func.isRequired,
	/** Callback function triggered on focus. */
	onFocus: PropTypes.func
};

var baseDefaultProps$1 = {
	hasError: false,
	isChecked: false,
	isDisabled: false
};

BaseInputRadio.propTypes = basePropTypes$1;
BaseInputRadio.defaultProps = baseDefaultProps$1;

GridViewInputRadio.propTypes = basePropTypes$1;
GridViewInputRadio.defaultProps = baseDefaultProps$1;

ListViewInputRadio.propTypes = basePropTypes$1;
ListViewInputRadio.defaultProps = baseDefaultProps$1;

var InternalRadio = {
	Default: withTheme(BaseInputRadio),
	Grid: GridViewInputRadio,
	List: withTheme(ListViewInputRadio)
};

var main$k = "GenericRadio.js";
var variants$2 = ["InlineSet", "StackedSet"];
var packageJson$k = {
	main: main$k,
	variants: variants$2,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$q = taggedTemplateLiteral(['\n\t', ';\n'], ['\n\t', ';\n']),
    _templateObject2$d = taggedTemplateLiteral(['\n\tdisplay: flex;\n\tflex-direction: ', ';\n'], ['\n\tdisplay: flex;\n\tflex-direction: ', ';\n']);

var StyledInputWrapper$2 = styled('div')(_templateObject$q, function (props) {
	return props.isStacked ? '\n\t\tdisplay: flex;\n\t\tmargin-bottom: ' + (props.isLastRadio ? '0' : spacing.TRIPLE) + ';\n\t' : '\n\t\tdisplay: flex;\t\t\n\t\t@media (min-width: ' + breakpoints.sm1 + ') {\n\t\t\tdisplay: inline-flex;\n\t\t}\n\t\tmargin-right: ' + (props.isLastRadio ? '0' : spacing.TRIPLE) + ';\n\t';
});

var StyledWrapper$b = styled('div')(_templateObject2$d, function (props) {
	return props.isStacked ? 'column' : 'row';
});

var Base$1 = function (_Component) {
	inherits(Base, _Component);

	function Base(props) {
		classCallCheck(this, Base);

		var _this = possibleConstructorReturn(this, (Base.__proto__ || Object.getPrototypeOf(Base)).call(this, props));

		_this.radioRef = null;
		return _this;
	}

	createClass(Base, [{
		key: 'handleOnChange',
		value: function handleOnChange(id) {
			this.props.onChange(id);
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    groupName = _props.groupName,
			    hasError = _props.hasError,
			    items = _props.items,
			    innerRef = _props.innerRef,
			    isStacked = _props.isStacked,
			    onBlur = _props.onBlur,
			    onFocus = _props.onFocus,
			    selectedId = _props.selectedId;

			return React.createElement(
				StyledWrapper$b,
				{ isStacked: isStacked },
				items.map(function (_ref, index) {
					var id = _ref.id,
					    labelText = _ref.labelText;

					var blur = index === items.length - 1 ? onBlur : undefined;
					var focus = index === 0 ? onFocus : undefined;
					var ref = index === 0 ? innerRef : undefined;
					var isLastRadio = index === items.length - 1;
					return React.createElement(
						StyledInputWrapper$2,
						{ isLastRadio: isLastRadio, isStacked: isStacked, key: id },
						React.createElement(InternalRadio.Default, {
							hasError: hasError,
							id: groupName + '-' + id,
							isChecked: id === selectedId,
							innerRef: ref,
							labelText: labelText,
							name: groupName,
							onBlur: blur,
							onChange: function onChange() {
								return _this2.handleOnChange(id);
							},
							onFocus: focus
						})
					);
				})
			);
		}
	}]);
	return Base;
}(Component);

var InlineSet$1 = function InlineSet(_ref2) {
	var groupName = _ref2.groupName,
	    hasError = _ref2.hasError,
	    innerRef = _ref2.innerRef,
	    items = _ref2.items,
	    onBlur = _ref2.onBlur,
	    _onChange = _ref2.onChange,
	    onFocus = _ref2.onFocus,
	    selectedId = _ref2.selectedId,
	    xraySuppressed = _ref2.xraySuppressed;
	return React.createElement(
		InternalComponentFrame,
		{ variant: 'InlineSet', packageJson: packageJson$k, xraySuppressed: xraySuppressed },
		React.createElement(Base$1, {
			groupName: groupName,
			hasError: hasError,
			items: items,
			innerRef: innerRef,
			onBlur: onBlur,
			onChange: function onChange(id) {
				return _onChange(id);
			},
			onFocus: onFocus,
			selectedId: selectedId
		})
	);
};

var StackedSet$1 = function StackedSet(_ref3) {
	var groupName = _ref3.groupName,
	    hasError = _ref3.hasError,
	    items = _ref3.items,
	    innerRef = _ref3.innerRef,
	    onBlur = _ref3.onBlur,
	    _onChange2 = _ref3.onChange,
	    onFocus = _ref3.onFocus,
	    selectedId = _ref3.selectedId,
	    xraySuppressed = _ref3.xraySuppressed;
	return React.createElement(
		InternalComponentFrame,
		{ variant: 'StackedSet', packageJson: packageJson$k, xraySuppressed: xraySuppressed },
		React.createElement(Base$1, {
			groupName: groupName,
			hasError: hasError,
			innerRef: innerRef,
			items: items,
			isStacked: true,
			onBlur: onBlur,
			onChange: function onChange(id) {
				return _onChange2(id);
			},
			onFocus: onFocus,
			selectedId: selectedId
		})
	);
};

var baseProps$3 = {
	/** String applied to each radio elements html name attribute. */
	groupName: PropTypes.string.isRequired,
	/** Changes radio colour when set to true. */
	hasError: PropTypes.bool,
	/** Used to access the internal input inside the theme wrapper. */
	innerRef: PropTypes.func,
	/** Items. */
	items: PropTypes.arrayOf(PropTypes.shape({
		id: PropTypes.string.isRequired,
		labelText: PropTypes.string.isRequired
	})).isRequired,
	/** Callback function triggered on blur of the last radio. */
	onBlur: PropTypes.func,
	/** Callback function triggered on change of the first radio. */
	onChange: PropTypes.func.isRequired,
	/** Callback function triggered on focus. */
	onFocus: PropTypes.func,
	/** Selected radio id. */
	selectedId: PropTypes.string,
	xraySuppressed: PropTypes.bool
};

Base$1.propTypes = _extends({}, baseProps$3);
InlineSet$1.propTypes = _extends({}, baseProps$3);
StackedSet$1.propTypes = _extends({}, baseProps$3, { isStacked: PropTypes.bool });

var baseDefaultProps$2 = {
	hasError: false
};

Base$1.defaultProps = baseDefaultProps$2;
InlineSet$1.defaultProps = baseDefaultProps$2;
StackedSet$1.defaultProps = baseDefaultProps$2;

InlineSet$1.defaultExample = function () {
	var items = [{ id: 'unique-id-a', labelText: 'item 1' }, { id: 'unique-id-b', labelText: 'item 2' }, { id: 'unique-id-c', labelText: 'item 3' }];
	return React.createElement(GenericRadio.InlineSet, { groupName: 'radios1', items: items, onChange: function onChange(id) {
			return id;
		} });
};

StackedSet$1.defaultExample = function () {
	var items = [{ id: 'unique-id-1', labelText: 'item 1' }, { id: 'unique-id-2', labelText: 'item 2' }, { id: 'unique-id-3', labelText: 'item 3' }];
	return React.createElement(GenericRadio.StackedSet, { groupName: 'radios1', items: items, onChange: function onChange(id) {
			return id;
		} });
};

var GenericRadio = {
	InlineSet: InlineSet$1,
	StackedSet: StackedSet$1
};

var main$l = "WorldwideMobileNumberInput.js";
var packageJson$l = {
	main: main$l,
	"component-id": 1011,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$r = taggedTemplateLiteral(['\n\tinput {\n\t\tmargin-bottom: ', ';\n\n\t\t', '};\n\t}\n'], ['\n\tinput {\n\t\tmargin-bottom: ', ';\n\n\t\t', '};\n\t}\n']);

var StyledWrapper$c = styled('div')(_templateObject$r, spacing.DOUBLE, function (props) {
	return props.hasValidationError && 'border: ' + props.theme.borderWidth + ' solid ' + colours.utility.error;
});

var validationReasons$4 = {
	BELOW_MIN: 'BELOW_MIN',
	ABOVE_MAX: 'ABOVE_MAX',
	NOT_VALID_UK_MOBILE: 'NOT_VALID_UK_MOBILE'
};

var getValidationErrorReason$3 = function getValidationErrorReason(overseasMaxLength, overseasMinLength, ukMaxLength, ukMinLength, valueToCheck, region) {
	var valueLength = valueToCheck.replace(/\s+/g, '').length;

	// UK validation
	if (region === 'uk') {
		// UK & Overseas validation
		if (valueLength > ukMaxLength) {
			return validationReasons$4.ABOVE_MAX;
		}

		if (valueLength < ukMinLength) {
			return validationReasons$4.BELOW_MIN;
		}

		if (!valueToCheck.startsWith('07')) {
			return validationReasons$4.NOT_VALID_UK_MOBILE;
		}
	}

	// Overseas validation
	if (region === 'overseas') {
		// UK & Overseas validation
		if (valueLength > overseasMaxLength) {
			return validationReasons$4.ABOVE_MAX;
		}

		if (valueLength < overseasMinLength) {
			return validationReasons$4.BELOW_MIN;
		}
	}

	return '';
};

var valueOnChangeHandler = function valueOnChangeHandler(overseasMaxLength, overseasMinLength, ukMaxLength, ukMinLength, onChange, region) {
	return function (output) {
		var value = output.value;


		onChange({
			region: region,
			value: value,
			validationErrorReason: getValidationErrorReason$3(overseasMaxLength, overseasMinLength, ukMaxLength, ukMinLength, value, region)
		});
	};
};

var radioOnChangeHandler = function radioOnChangeHandler(overseasMaxLength, overseasMinLength, ukMaxLength, ukMinLength, onChange, value) {
	return function (id) {
		var type = id.startsWith('uk') ? 'uk' : id.startsWith('overseas') ? 'overseas' : '';

		onChange({
			region: type,
			value: value,
			validationErrorReason: getValidationErrorReason$3(overseasMaxLength, overseasMinLength, ukMaxLength, ukMinLength, value, type)
		});
	};
};

/**
 * @example ./Design.md
 */

var WorldwideMobileNumberInput = function (_Component) {
	inherits(WorldwideMobileNumberInput, _Component);

	function WorldwideMobileNumberInput(props) {
		classCallCheck(this, WorldwideMobileNumberInput);

		var _this = possibleConstructorReturn(this, (WorldwideMobileNumberInput.__proto__ || Object.getPrototypeOf(WorldwideMobileNumberInput)).call(this, props));

		_this.refInput = null;
		return _this;
	}

	createClass(WorldwideMobileNumberInput, [{
		key: 'focus',
		value: function focus() {
			if (this.refInput) {
				this.refInput.focus();
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    id = _props.id,
			    hasValidationEnabled = _props.hasValidationEnabled,
			    value = _props.value,
			    onBlur = _props.onBlur,
			    onChange = _props.onChange,
			    onFocus = _props.onFocus,
			    innerRef = _props.innerRef,
			    ukMaxLength = _props.ukMaxLength,
			    ukMinLength = _props.ukMinLength,
			    overseasMaxLength = _props.overseasMaxLength,
			    overseasMinLength = _props.overseasMinLength,
			    region = _props.region;


			var hasValidationError = getValidationErrorReason$3(overseasMaxLength, overseasMinLength, ukMaxLength, ukMinLength, value, region) !== '';

			if (innerRef) {
				innerRef(this);
			}

			var radioItems = [{ id: 'uk-radio-item-' + id, labelText: 'UK' }, { id: 'overseas-radio-item-' + id, labelText: 'Overseas' }];

			var selectedId = region !== '' ? region + '-radio-item-' + id : region;

			return React.createElement(
				InternalComponentFrame,
				{ packageJson: packageJson$l, hasCustomMargins: true },
				React.createElement(
					StyledWrapper$c,
					null,
					React.createElement(GenericRadio.InlineSet, {
						groupName: 'worldwide-radios-' + id,
						items: radioItems,
						onChange: radioOnChangeHandler(overseasMaxLength, overseasMinLength, ukMaxLength, ukMinLength, onChange, value),
						selectedId: selectedId,
						xraySuppressed: true
					}),
					React.createElement(
						ConditionalPanel,
						{ isVisible: selectedId !== '' },
						React.createElement(InternalTelephoneInput, {
							characterCount: 18,
							id: id,
							value: value,
							onBlur: onBlur,
							onChange: valueOnChangeHandler(overseasMaxLength, overseasMinLength, ukMaxLength, ukMinLength, onChange, region),
							onFocus: onFocus,
							innerRef: function innerRef(element) {
								_this2.refInput = element;
							},
							hasValidationError: hasValidationError && hasValidationEnabled
						})
					)
				)
			);
		}
	}]);
	return WorldwideMobileNumberInput;
}(Component);

WorldwideMobileNumberInput.propTypes = {
	/** Callback function triggered on change.
  *
  * Returns object:
  *
  * value [number],
  *
  * validationErrorReason [string]
  */
	onChange: PropTypes.func.isRequired,
	/** Callback function triggered on focus. */
	onFocus: PropTypes.func,
	/** Used to access the internal input inside the theme wrapper. */
	innerRef: PropTypes.func,
	/** Callback function triggered on blur. */
	onBlur: PropTypes.func,
	/** Sets the ID attribute on the component, needed to attach it to an associated label in the DOM. */
	id: PropTypes.string.isRequired,
	/** The value of the input. */
	value: PropTypes.string.isRequired,
	/** The maximum character length of the input after space removal. */
	ukMaxLength: PropTypes.number,
	/** The minimum character length of the input after space removal. */
	ukMinLength: PropTypes.number,
	/** The maximum character length of the input after space removal. */
	overseasMaxLength: PropTypes.number,
	/** The minimum character length of the input after space removal. */
	overseasMinLength: PropTypes.number,
	/** Sets if validation highlighting is shown. */
	hasValidationEnabled: PropTypes.bool,
	/** Sets where the number is located. An empty string leaves it unset.  */
	region: PropTypes.oneOf(['uk', 'overseas', '']).isRequired
};

WorldwideMobileNumberInput.defaultProps = {
	ukMaxLength: 11,
	ukMinLength: 6,
	overseasMaxLength: 14,
	overseasMinLength: 6
};

WorldwideMobileNumberInput.defaultExample = function () {
	return React.createElement(WorldwideMobileNumberInput, {
		id: 'default-worldwide-mobile-number',
		onChange: function onChange() {},
		value: '1234 567 8901',
		region: 'uk'
	});
};

var main$m = "YearsAndMonthsCountInput.js";
var packageJson$m = {
	main: main$m,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$s = taggedTemplateLiteral(['\n\tdisplay: flex;\n'], ['\n\tdisplay: flex;\n']),
    _templateObject2$e = taggedTemplateLiteral(['\n\tborder: ', ';\n\tborder-radius: ', ';\n\n\tbox-sizing: border-box;\n\tfont-size: ', ';\n\tmin-height: ', ';\n\tpadding: ', ';\n\twidth: 100%;\n\ttext-align: center;\n\n\t', '};\n'], ['\n\tborder: ', ';\n\tborder-radius: ', ';\n\n\tbox-sizing: border-box;\n\tfont-size: ', ';\n\tmin-height: ', ';\n\tpadding: ', ';\n\twidth: 100%;\n\ttext-align: center;\n\n\t', '};\n']),
    _templateObject3$8 = taggedTemplateLiteral(['\n\twidth: 60px;\n\tmargin-right: ', ';\n'], ['\n\twidth: 60px;\n\tmargin-right: ', ';\n']),
    _templateObject4$5 = taggedTemplateLiteral(['\n\twidth: 60px;\n'], ['\n\twidth: 60px;\n']);

var StyledYearsAndMonthsInput = styled('div')(_templateObject$s);

var StyledInput$6 = styled('input')(_templateObject2$e, function (props) {
	return props.theme.borderWidth + ' solid ' + props.theme.colours.borderInteraction;
}, function (props) {
	return props.theme.borderRadius;
}, function (props) {
	return props.theme.isCompact ? '12px' : '16px';
}, spacing.SEXTUPLE, spacing.SINGLE, function (props) {
	return props.hasError && 'border: ' + props.theme.borderWidth + ' solid ' + colours.utility.error;
});

var StyledYearsInput = styled('div')(_templateObject3$8, spacing.DOUBLE);

var StyledMonthsInput = styled('div')(_templateObject4$5);

var days$1 = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
var validationReasons$5 = {
	INVALID: 'INVALID'
};

var isNumValid$1 = function isNumValid(val, type) {
	var firstNum = null;
	var numToCheck = null;
	var validDays = [];

	// first number - allow all
	if (val.length === 1) {
		return true;
	}

	// second number
	if (val.length === 2) {
		var numbers = val.split('');

		// if month
		var _numbers = slicedToArray(numbers, 2);

		firstNum = _numbers[0];
		numToCheck = _numbers[1];
		if (type === 'months') {
			switch (firstNum) {
				case 1:
					validDays = days$1.slice(0, 2);
					break;
				default:
					validDays = days$1.slice(0, 0);
					break;
			}
		}

		// if year
		if (type === 'years') {
			switch (firstNum) {
				case 0:
					validDays = days$1.slice(0, 0);
					break;
				default:
					validDays = days$1;
					break;
			}
		}
	}

	// third number (2 char max)
	var THIRD_CHARACTER = 3;
	if (val.length === THIRD_CHARACTER) {
		return false;
	}

	// Check the number
	if (validDays.includes(numToCheck)) {
		return true;
	}

	// default
	return false;
};

// Limit the character input to a maximum length
// and stop invalid years and months
var limitInput$1 = function limitInput(e, type) {
	var v = e.target.value;

	if (!isNumValid$1(v, type)) {
		// bin last character
		e.target.value = v.slice(0, v.length - 1);
	}
};

var YearsAndMonthsCountInput = function (_Component) {
	inherits(YearsAndMonthsCountInput, _Component);

	function YearsAndMonthsCountInput(props) {
		classCallCheck(this, YearsAndMonthsCountInput);

		var _this = possibleConstructorReturn(this, (YearsAndMonthsCountInput.__proto__ || Object.getPrototypeOf(YearsAndMonthsCountInput)).call(this, props));

		_this.state = {
			years: parseInt(_this.props.value.years, 10) || undefined,
			months: parseInt(_this.props.value.months, 10) || undefined,
			hasError: false
		};

		_this.setMonths = _this.setMonths.bind(_this);
		_this.setYears = _this.setYears.bind(_this);
		return _this;
	}

	createClass(YearsAndMonthsCountInput, [{
		key: 'setMonths',
		value: function setMonths(event) {
			var value = event.target.value;
			var years = this.state.years;


			var stateObj = {
				months: value,
				years: years
			};

			this.updateState(stateObj);
		}
	}, {
		key: 'setYears',
		value: function setYears(event) {
			var value = event.target.value;
			var months = this.state.months;


			var stateObj = {
				months: months,
				years: value
			};

			this.updateState(stateObj);
		}
	}, {
		key: 'updateState',
		value: function updateState(stateObj) {
			var returnObj = {};
			var objIsValid = true;
			var hasError = false;

			// Check month and year are not empty
			if (stateObj.months === undefined || stateObj.years === undefined) {
				objIsValid = false;
				hasError = true;
			}

			var MAX_YEARS = 99;

			// Check years is less than 0 or greater than 99
			if (parseInt(stateObj.years, 10) < 0 || parseInt(stateObj.years, 10) > MAX_YEARS) {
				objIsValid = false;
				hasError = true;
			}

			// Check months are less than 0 or greater than 11
			var MAX_MONTHS = 11;
			if (parseInt(stateObj.months, 10) < 0 || parseInt(stateObj.months, 10) > MAX_MONTHS) {
				objIsValid = false;
				hasError = true;
			}

			if (objIsValid) {
				returnObj = {
					value: {
						months: stateObj.months,
						years: stateObj.years
					},
					validationErrorReason: null
				};
			} else {
				returnObj = {
					value: {
						months: stateObj.months,
						years: stateObj.years
					},
					validationErrorReason: validationReasons$5.INVALID
				};
			}

			this.props.onChange(returnObj);
			this.setState(_extends({}, stateObj, {
				hasError: hasError
			}));
		}
	}, {
		key: 'focus',
		value: function focus() {
			if (this.refInput) {
				this.refInput.focus();
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _state = this.state,
			    hasError = _state.hasError,
			    months = _state.months,
			    years = _state.years;
			var _props = this.props,
			    hasValidationEnabled = _props.hasValidationEnabled,
			    id = _props.id,
			    innerRef = _props.innerRef,
			    onBlur = _props.onBlur,
			    onFocus = _props.onFocus;


			if (innerRef) {
				innerRef(this);
			}

			return React.createElement(
				InternalComponentFrame,
				{ packageJson: packageJson$m },
				React.createElement(
					StyledYearsAndMonthsInput,
					null,
					React.createElement(
						StyledYearsInput,
						null,
						React.createElement(
							InternalControlLabel,
							{ htmlFor: id + '-years' },
							'Years'
						),
						React.createElement(StyledInput$6, {
							id: id + '-years',
							innerRef: function innerRef(element) {
								_this2.refInput = element;
							},
							inputMode: 'numeric',
							maxLength: 2,
							max: 99,
							min: 0,
							name: id + '-years',
							onChange: this.setYears,
							onFocus: onFocus,
							onInput: function onInput(e) {
								return limitInput$1(e, 'years');
							},
							size: 2,
							pattern: '[0-9]*',
							type: 'number',
							value: years,
							hasError: hasError && hasValidationEnabled
						})
					),
					React.createElement(
						StyledMonthsInput,
						null,
						React.createElement(
							InternalControlLabel,
							{ htmlFor: id + '-months' },
							'Months'
						),
						React.createElement(StyledInput$6, {
							id: id + '-months',
							inputMode: 'numeric',
							max: 11,
							maxLength: 2,
							min: 0,
							name: id + '-months',
							onBlur: onBlur,
							onChange: this.setMonths,
							onInput: function onInput(e) {
								return limitInput$1(e, 'months');
							},
							pattern: '[0-9]*',
							size: 2,
							type: 'number',
							value: months,
							hasError: hasError && hasValidationEnabled
						})
					)
				)
			);
		}
	}]);
	return YearsAndMonthsCountInput;
}(Component);

YearsAndMonthsCountInput.propTypes = {
	/** Sets if validation highlighting is shown. */
	hasValidationEnabled: PropTypes.bool,
	/** The unique id of the component. */
	id: PropTypes.string.isRequired,
	/** Used to access the internal input inside the theme wrapper. */
	innerRef: PropTypes.func,
	/** Callback function triggered on blur. */
	onBlur: PropTypes.func,
	/** Callback function triggered on change.
  *
  * Returns object:
  *
  * value { years: [number], months: [number] },
  *
  * validationErrorReason [string]
  */
	onChange: PropTypes.func.isRequired,
	/** Callback function triggered on focus. */
	onFocus: PropTypes.func,
	/** Sets the years and months. */
	value: PropTypes.shape({
		years: PropTypes.number,
		months: PropTypes.number
	})
};

YearsAndMonthsCountInput.defaultProps = {
	hasValidationEnabled: false
};

YearsAndMonthsCountInput.defaultExample = function () {
	return React.createElement(YearsAndMonthsCountInput, { id: 'example-years-months-count', onChange: function onChange() {}, value: { years: null, months: null } });
};

var main$n = "DayOfMonthPicker.js";
var packageJson$n = {
	main: main$n,
	"component-id": 949,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$t = taggedTemplateLiteral(['\n\tbackground-color: ', ';\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tmax-width: ', ';\n'], ['\n\tbackground-color: ', ';\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tmax-width: ', ';\n']),
    _templateObject2$f = taggedTemplateLiteral(['\n\talign-items: center;\n\tdisplay: flex;\n\theight: ', ';\n\tjustify-content: center;\n\twidth: ', ';\n\n\tinput[type=\'radio\'] {\n\t\tclip: rect(1px, 1px, 1px, 1px);\n\t\twidth: 1px;\n\t\theight: 1px;\n\t\toverflow: hidden;\n\t\tposition: absolute;\n\n\t\t+ span {\n\t\t\talign-items: center;\n\t\t\tdisplay: flex;\n\t\t\theight: ', ';\n\t\t\tjustify-content: center;\n\t\t\twidth: ', ';\n\t\t\tcursor: pointer;\n\n\t\t\t:hover {\n\t\t\t\tborder: 2px solid ', ';\n\t\t\t\tborder-radius: 100%;\n\t\t\t}\n\t\t}\n\n\t\t&:checked + span {\n\t\t\tbackground-color: ', ';\n\t\t\tborder-radius: 100%;\n\t\t\tcolor: ', ';\n\t\t}\n\n\t\t&:disabled + span {\n\t\t\tcolor: ', ';\n\t\t\tcursor: default;\n\t\t\tborder: 0;\n\t\t\tposition: relative;\n\n\t\t\t&::after {\n\t\t\t\tcontent: \'\';\n\t\t\t\tbackground-color: ', ';\n\t\t\t\theight: 80%;\n\t\t\t\twidth: 1px;\n\t\t\t\tposition: absolute;\n\t\t\t\ttransform: rotate(45deg);\n\t\t\t}\n\t\t}\n\t\t/* TODOxVM: Pull this from the theme/global colour config once available */\n\t\t&:focus + span {\n\t\t\tbox-shadow: 0 0 0 2px hsl(208, 59%, 60%);\n\t\t\tborder-radius: 100%;\n\t\t}\n\t}\n'], ['\n\talign-items: center;\n\tdisplay: flex;\n\theight: ', ';\n\tjustify-content: center;\n\twidth: ', ';\n\n\tinput[type=\'radio\'] {\n\t\tclip: rect(1px, 1px, 1px, 1px);\n\t\twidth: 1px;\n\t\theight: 1px;\n\t\toverflow: hidden;\n\t\tposition: absolute;\n\n\t\t+ span {\n\t\t\talign-items: center;\n\t\t\tdisplay: flex;\n\t\t\theight: ', ';\n\t\t\tjustify-content: center;\n\t\t\twidth: ', ';\n\t\t\tcursor: pointer;\n\n\t\t\t:hover {\n\t\t\t\tborder: 2px solid ', ';\n\t\t\t\tborder-radius: 100%;\n\t\t\t}\n\t\t}\n\n\t\t&:checked + span {\n\t\t\tbackground-color: ', ';\n\t\t\tborder-radius: 100%;\n\t\t\tcolor: ', ';\n\t\t}\n\n\t\t&:disabled + span {\n\t\t\tcolor: ', ';\n\t\t\tcursor: default;\n\t\t\tborder: 0;\n\t\t\tposition: relative;\n\n\t\t\t&::after {\n\t\t\t\tcontent: \'\';\n\t\t\t\tbackground-color: ', ';\n\t\t\t\theight: 80%;\n\t\t\t\twidth: 1px;\n\t\t\t\tposition: absolute;\n\t\t\t\ttransform: rotate(45deg);\n\t\t\t}\n\t\t}\n\t\t/* TODOxVM: Pull this from the theme/global colour config once available */\n\t\t&:focus + span {\n\t\t\tbox-shadow: 0 0 0 2px hsl(208, 59%, 60%);\n\t\t\tborder-radius: 100%;\n\t\t}\n\t}\n']);

var StyledWrapper$d = styled('div')(_templateObject$t, colours.neutral.white, function (props) {
	return props.theme.isCompact ? '14rem' : '21rem';
});

var StyledDayLabel = styled('label')(_templateObject2$f, function (props) {
	return props.theme.isCompact ? spacing.QUADRUPLE : spacing.SEXTUPLE;
}, function (props) {
	return props.theme.isCompact ? spacing.QUADRUPLE : spacing.SEXTUPLE;
}, function (props) {
	return props.theme.isCompact ? spacing.QUADRUPLE : spacing.SEXTUPLE;
}, function (props) {
	return props.theme.isCompact ? spacing.QUADRUPLE : spacing.SEXTUPLE;
}, function (props) {
	return props.theme.colours.interaction;
}, function (props) {
	return props.theme.colours.interaction;
}, colours.neutral.white, colours.utility.offDisabled, colours.utility.offDisabled);

/**
 * @example ./Design.md
 */
var DayOfMonthPicker = function DayOfMonthPicker(_ref) {
	var _onChange = _ref.onChange,
	    name = _ref.name,
	    selectedDay = _ref.selectedDay,
	    unselectableDays = _ref.unselectableDays;

	var days = [];
	var numOfDays = 31;

	// Check if day is active, selected or unselectable
	var getDay = function getDay(day) {
		var isDisabled = unselectableDays && unselectableDays.includes(day);

		return React.createElement(
			StyledDayLabel,
			{ key: day },
			React.createElement('input', {
				checked: day === selectedDay,
				disabled: isDisabled,
				type: 'radio',
				name: name,
				id: name + '_day' + day,
				value: day,
				onChange: function onChange() {
					return _onChange(day);
				}
			}),
			React.createElement(
				'span',
				{ 'aria-label': 'day ' + day + (isDisabled ? ', unselectable' : '') },
				day
			)
		);
	};

	// Loop through days and build days array
	for (var i = 1; i <= numOfDays; i += 1) {
		var day = getDay(i);
		days.push(day);
	}

	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$n, hasCustomMargins: true },
		React.createElement(
			StyledWrapper$d,
			null,
			days
		)
	);
};

DayOfMonthPicker.propTypes = {
	/** Callback function triggered on change. */
	onChange: PropTypes.func.isRequired,
	/** A _unique_ name for the group (used to group underlying radios).  */
	name: PropTypes.string.isRequired,
	/** Sets the selected day */
	selectedDay: PropTypes.number.isRequired,
	/** Array of days that cannot be selected. */
	unselectableDays: PropTypes.arrayOf(PropTypes.number)
};

DayOfMonthPicker.defaultProps = {};

DayOfMonthPicker.defaultExample = function () {
	return React.createElement(DayOfMonthPicker, { name: 'defaultPicker', onChange: function onChange() {}, selectedDay: 1 });
};

var main$o = "FileProgressTakeover.js";
var packageJson$o = {
	main: main$o,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$u = taggedTemplateLiteral(['\n\tbackground-color: ', ';\n\tbottom: 0;\n\tleft: 0;\n\tposition: absolute;\n\topacity: ', ';\n\tright: 0;\n\ttop: 0;\n\tz-index: ', ';\n'], ['\n\tbackground-color: ', ';\n\tbottom: 0;\n\tleft: 0;\n\tposition: absolute;\n\topacity: ', ';\n\tright: 0;\n\ttop: 0;\n\tz-index: ', ';\n']),
    _templateObject2$g = taggedTemplateLiteral(['\n\tdisplay: block;\n\theight: 100%;\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\tz-index: ', ';\n\t', ';\n'], ['\n\tdisplay: block;\n\theight: 100%;\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\tz-index: ', ';\n\t', ';\n']),
    _templateObject3$9 = taggedTemplateLiteral(['\n\talign-items: center;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\theight: 100%;\n\tpadding-left: ', ';\n\tpadding-right: ', ';\n'], ['\n\talign-items: center;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\theight: 100%;\n\tpadding-left: ', ';\n\tpadding-right: ', ';\n']),
    _templateObject4$6 = taggedTemplateLiteral(['\n\tpadding: ', ';\n\twidth: 100%;\n\tmax-width: 550px;\n\tbackground-color: ', ';\n'], ['\n\tpadding: ', ';\n\twidth: 100%;\n\tmax-width: 550px;\n\tbackground-color: ', ';\n']),
    _templateObject5$3 = taggedTemplateLiteral(['\n\tpadding: ', ' 0;\n'], ['\n\tpadding: ', ' 0;\n']),
    _templateObject6$2 = taggedTemplateLiteral([''], ['']),
    _templateObject7$1 = taggedTemplateLiteral(['\n\tdisplay: flex;\n\n\tsvg {\n\t\twidth: 18px;\n\t\theight: 24px;\n\t\tanimation: ', ' 1.25s linear infinite;\n\t}\n'], ['\n\tdisplay: flex;\n\n\tsvg {\n\t\twidth: 18px;\n\t\theight: 24px;\n\t\tanimation: ', ' 1.25s linear infinite;\n\t}\n']),
    _templateObject8$1 = taggedTemplateLiteral(['\n\tborder: 2px solid ', ';\n\tborder-radius: ', ';\n\theight: 50px;\n'], ['\n\tborder: 2px solid ', ';\n\tborder-radius: ', ';\n\theight: 50px;\n']),
    _templateObject9 = taggedTemplateLiteral(['\n\tbackground-color: ', ';\n\theight: 100%;\n\twidth: ', '%;\n\ttransition: width 0.2s ease-in-out;\n'], ['\n\tbackground-color: ', ';\n\theight: 100%;\n\twidth: ', '%;\n\ttransition: width 0.2s ease-in-out;\n']),
    _templateObject10 = taggedTemplateLiteral(['\n\ttext-align: center;\n\tpadding-top: ', ';\n'], ['\n\ttext-align: center;\n\tpadding-top: ', ';\n']);

var StyledModalBackdrop = styled('div')(_templateObject$u, function (props) {
	return props.theme.components.localLoader.colours.background;
}, function (props) {
	return props.theme.components.localLoader.root.opacity;
}, layers.sub);

var StyledTakeover = styled('div')(_templateObject2$g, layers.globalTakeover, function (props) {
	return !props.show && '\n\t\tdisplay: none!important\n\t';
});

var StyledContainerWrapper = styled('div')(_templateObject3$9, spacing.DOUBLE, spacing.DOUBLE);

var StyledContainer = styled('div')(_templateObject4$6, spacing.QUADRUPLE, colours.neutral.white);

var StyledBody = styled('div')(_templateObject5$3, spacing.DOUBLE);

var StyledProgressSection = styled('div')(_templateObject6$2);

var StyledProgressHeader = styled('div')(_templateObject7$1, animations.rotate);

var StyledProgressBar = styled('div')(_templateObject8$1, colours.neutral.greyDarker, function (props) {
	return props.theme.borderRadius;
});

var StyledProgressBarInner = styled('div')(_templateObject9, colours.utility.success, function (props) {
	return props.width;
});

var StyledPercentageSection = styled('div')(_templateObject10, spacing.SINGLE);

var MAX_PERCENTAGE = 100;

var FileProgressTakeover = function FileProgressTakeover(_ref) {
	var title = _ref.title,
	    children = _ref.children,
	    isOpen = _ref.isOpen,
	    percentage = _ref.percentage,
	    activityText = _ref.activityText;
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$o, hasCustomMargins: true },
		React.createElement(
			StyledTakeover,
			{ show: isOpen },
			React.createElement(
				StyledContainerWrapper,
				null,
				React.createElement(
					StyledContainer,
					null,
					React.createElement(
						SubHeading,
						{ isFlush: true },
						title
					),
					React.createElement(
						StyledBody,
						null,
						children
					),
					React.createElement(
						StyledProgressSection,
						null,
						React.createElement(
							StyledProgressHeader,
							null,
							React.createElement(
								ProminentLabel,
								null,
								percentage < MAX_PERCENTAGE ? activityText : 'Done'
							),
							percentage < MAX_PERCENTAGE && React.createElement(CycleLarge, null)
						),
						React.createElement(
							StyledProgressBar,
							null,
							React.createElement(StyledProgressBarInner, { width: percentage })
						),
						React.createElement(
							StyledPercentageSection,
							null,
							React.createElement(
								ProminentLabel,
								null,
								percentage.toString(),
								'%'
							)
						)
					)
				)
			),
			React.createElement(StyledModalBackdrop, null)
		)
	);
};

FileProgressTakeover.propTypes = {
	/** Text shown above the progress bar. */
	activityText: PropTypes.string.isRequired,
	/** Child content. */
	children: PropTypes.node,
	/** Determines if takeover is open */
	isOpen: PropTypes.bool,
	/** Percentage of the progress bar (number) (0-100). */
	percentage: PropTypes.number.isRequired,
	/** Title of the modal. */
	title: PropTypes.string.isRequired
};

FileProgressTakeover.defaultProps = {
	isOpen: false
};

var main$p = "GenericSelect.js";
var packageJson$p = {
	main: main$p,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$v = taggedTemplateLiteral(['\n\talign-items: center;\n\tborder-left: 2px solid ', ';\n\tdisplay: flex;\n\theight: 48px;\n\tjustify-content: center;\n\tpointer-events: none;\n\tposition: absolute;\n\tright: 0;\n\ttop: 0;\n\twidth: ', 'px;\n\n\tsvg {\n\t\tfill: ', ';\n\t\theight: 24px;\n\t\tpointer-events: none;\n\t\tspeak: none;\n\t\twidth: 24px;\n\t}\n'], ['\n\talign-items: center;\n\tborder-left: 2px solid ', ';\n\tdisplay: flex;\n\theight: 48px;\n\tjustify-content: center;\n\tpointer-events: none;\n\tposition: absolute;\n\tright: 0;\n\ttop: 0;\n\twidth: ', 'px;\n\n\tsvg {\n\t\tfill: ', ';\n\t\theight: 24px;\n\t\tpointer-events: none;\n\t\tspeak: none;\n\t\twidth: 24px;\n\t}\n']),
    _templateObject2$h = taggedTemplateLiteral(['\n\tappearance: none;\n\tborder-style: solid;\n\tbackground-color: ', ';\n\tborder: 2px solid ', ';\n\tborder-radius: ', ';\n\tcolor: ', ';\n\tcursor: pointer;\n\theight: 48px;\n\tpadding: ', ' ', ' ', ' ', ';\n\twidth: ', ';\n\n\t::-ms-expand {\n\t\tdisplay: none;\n\t}\n'], ['\n\tappearance: none;\n\tborder-style: solid;\n\tbackground-color: ', ';\n\tborder: 2px solid ', ';\n\tborder-radius: ', ';\n\tcolor: ', ';\n\tcursor: pointer;\n\theight: 48px;\n\tpadding: ', ' ', ' ', ' ', ';\n\twidth: ', ';\n\n\t::-ms-expand {\n\t\tdisplay: none;\n\t}\n']),
    _templateObject3$a = taggedTemplateLiteral(['\n\talign-items: center;\n\tdisplay: block;\n\tposition: relative;\n\twidth: ', ';\n'], ['\n\talign-items: center;\n\tdisplay: block;\n\tposition: relative;\n\twidth: ', ';\n']);

//TODOxVM: Remove this duplication from InternalInput sizing.
var MAX_CHAR_WIDTH$1 = 0.6725;
var ICON_WIDTH = 48;
var ICON_WIDTH_IN_REM = 3;
var PADDING$1 = 2 + ICON_WIDTH_IN_REM;

var getInputWidth$1 = function getInputWidth(characters, borderWidth) {
	if (!characters) {
		return '375px';
	}

	return parseInt(characters) * MAX_CHAR_WIDTH$1 + PADDING$1 + parseFloat(borderWidth) + 'rem';
};

var StyledIconWrapper = styled('div')(_templateObject$v, function (props) {
	return props.theme.colours.borderInteraction;
}, ICON_WIDTH, function (props) {
	return props.theme.colours.interaction;
});

var StyledSelect = styled('select')(_templateObject2$h, colours.backgrounds.component, function (props) {
	return props.theme.colours.borderInteraction;
}, function (props) {
	return props.theme.borderRadius;
}, function (props) {
	return props.value === '' ? 'hsl(0, 0%, 50%)' : props.theme.colours.bodyText;
}, spacing.SINGLE, spacing.SEPTUPLE, spacing.SINGLE, spacing.DOUBLE, function (props) {
	return getInputWidth$1(props.characterCount, props.theme.borderWidth);
});

var StyledWrapper$e = styled('div')(_templateObject3$a, function (props) {
	return getInputWidth$1(props.characterCount, props.theme.borderWidth);
});

var GenericSelect = function (_Component) {
	inherits(GenericSelect, _Component);

	function GenericSelect(props) {
		classCallCheck(this, GenericSelect);

		var _this = possibleConstructorReturn(this, (GenericSelect.__proto__ || Object.getPrototypeOf(GenericSelect)).call(this, props));

		_this.refInput = null;
		return _this;
	}

	createClass(GenericSelect, [{
		key: 'focus',
		value: function focus() {
			if (this.refInput) {
				this.refInput.focus();
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			// eslint-disable-next-line react/prop-types
			var _props = this.props,
			    characterCount = _props.characterCount,
			    id = _props.id,
			    items = _props.items,
			    innerRef = _props.innerRef,
			    onBlur = _props.onBlur,
			    _onChange = _props.onChange,
			    onFocus = _props.onFocus,
			    placeholderText = _props.placeholderText,
			    selectedId = _props.selectedId,
			    theme = _props.theme;

			var ChevronDownSmallIcon = getChevronDownSolidLarge(theme.name);

			if (innerRef) {
				innerRef(this);
			}

			return React.createElement(
				InternalComponentFrame,
				{ packageJson: packageJson$p },
				React.createElement(
					StyledWrapper$e,
					{ characterCount: characterCount },
					React.createElement(
						StyledSelect,
						{
							characterCount: characterCount,
							id: id,
							onBlur: onBlur,
							onChange: function onChange(event) {
								return _onChange(event.target.value);
							},
							onFocus: onFocus,
							innerRef: function innerRef(element) {
								_this2.refInput = element;
							},
							value: selectedId === null ? '' : selectedId
						},
						React.createElement(
							'option',
							{ disabled: true, value: '' },
							placeholderText
						),
						items.map(function (item, index) {
							var key = id + '-' + index;
							return React.createElement(
								'option',
								{ key: key, value: item.id },
								item.labelText
							);
						})
					),
					React.createElement(
						StyledIconWrapper,
						null,
						React.createElement(ChevronDownSmallIcon, null)
					)
				)
			);
		}
	}]);
	return GenericSelect;
}(Component);

GenericSelect.propTypes = {
	/** Character count as number, controls the select width. */
	characterCount: PropTypes.number,
	/** Unique string id. */
	id: PropTypes.string.isRequired,
	/** Used to access the internal input inside the theme wrapper. */
	innerRef: PropTypes.func,
	/** Callback function triggered on blur. */
	onBlur: PropTypes.func,
	/** Callback function triggered on change. */
	onChange: PropTypes.func.isRequired,
	/** Callback function triggered on focus. */
	onFocus: PropTypes.func,
	/** Array of item objects. */
	items: PropTypes.arrayOf(PropTypes.shape({
		id: PropTypes.string.isRequired,
		labelText: PropTypes.string.isRequired
	})).isRequired,
	/** Selected item id. */
	selectedId: PropTypes.string,
	/** Change placeholder text. */
	placeholderText: PropTypes.string
};

GenericSelect.defaultProps = {
	placeholderText: 'Please select'
};

var WrappedGenericSelect = withTheme(GenericSelect);

WrappedGenericSelect.defaultExample = function () {
	return React.createElement(WrappedGenericSelect, {
		id: 'select-1',
		items: [{ id: '1', labelText: 'Option 1' }, { id: '2', labelText: 'Option 2' }, { id: '3', labelText: 'Option 3' }, { id: '4', labelText: 'Option 4' }, { id: '5', labelText: 'Option 5' }, { id: '6', labelText: 'Option 6' }, { id: '7', labelText: 'Option 7' }, { id: '8', labelText: 'Option 8' }, { id: '9', labelText: 'Option 9' }],
		onChange: function onChange() {},
		selectedId: '1'
	});
};

var main$q = "GenericTextArea.js";
var packageJson$q = {
	main: main$q,
	"component-id": 1001,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$w = taggedTemplateLiteral(['\n\tcolor: ', ';\n\t', ';\n'], ['\n\tcolor: ', ';\n\t', ';\n']),
    _templateObject2$i = taggedTemplateLiteral(['\n\tbackground-color: ', ';\n\tborder-color: ', ';\n\tborder-radius: ', ';\n\tborder-style: solid;\n\tborder-width: 1px;\n\tcolor: ', ';\n\tpadding: ', ';\n\twidth: ', ';\n\n\t&[disabled] {\n\t\tcolor: ', ';\n\t\tborder-color: ', ';\n\t\tbackground-color: ', ';\n\n\t\t&:hover {\n\t\t\tcursor: default;\n\t\t}\n\t}\n'], ['\n\tbackground-color: ', ';\n\tborder-color: ', ';\n\tborder-radius: ', ';\n\tborder-style: solid;\n\tborder-width: 1px;\n\tcolor: ', ';\n\tpadding: ', ';\n\twidth: ', ';\n\n\t&[disabled] {\n\t\tcolor: ', ';\n\t\tborder-color: ', ';\n\t\tbackground-color: ', ';\n\n\t\t&:hover {\n\t\t\tcursor: default;\n\t\t}\n\t}\n']),
    _templateObject3$b = taggedTemplateLiteral(['\n\tclip: rect(1px, 1px, 1px, 1px) !important;\n\theight: 1px !important;\n\twidth: 1px !important;\n\toverflow: hidden !important;\n\tposition: absolute;\n'], ['\n\tclip: rect(1px, 1px, 1px, 1px) !important;\n\theight: 1px !important;\n\twidth: 1px !important;\n\toverflow: hidden !important;\n\tposition: absolute;\n']);

var StyledWrapper$f = styled('div')(_templateObject$w, function (props) {
	return props.theme.colours.bodyText;
}, function (props) {
	return !props.isValidInput && 'color: ' + colours.utility.error + ';';
});

var StyledTextarea = styled('textarea')(_templateObject2$i, colours.backgrounds.component, function (props) {
	return props.theme.colours.borderInteraction;
}, spacing.QUARTER, function (props) {
	return props.theme.colours.bodyText;
}, spacing.SINGLE, function (props) {
	return getInputWidth(props.characterWidth, '1px');
}, function (props) {
	return props.theme.colours.bodyText;
}, colours.disabled.border, colours.disabled.background);

var StyledSpan = styled('span')(_templateObject3$b);

var getCharacterCount = function getCharacterCount(event, onChange, max) {
	var value = event.target.value;

	var isValid = value.length <= max;
	onChange({ value: value, isValid: isValid });
};

var getOnBlurValue = function getOnBlurValue(event, onBlur) {
	var value = event.target.value;

	if (onBlur) {
		onBlur(value);
	}
};

/**
 * Uses `<textarea>` tag internally.
 * @example ./Design.md
 */

var GenericTextArea = function (_Component) {
	inherits(GenericTextArea, _Component);

	function GenericTextArea(props) {
		classCallCheck(this, GenericTextArea);

		var _this = possibleConstructorReturn(this, (GenericTextArea.__proto__ || Object.getPrototypeOf(GenericTextArea)).call(this, props));

		_this.refInput = null;
		return _this;
	}

	createClass(GenericTextArea, [{
		key: 'focus',
		value: function focus() {
			if (this.refInput) {
				this.refInput.focus();
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    characterWidth = _props.characterWidth,
			    hideCharacterCount = _props.hideCharacterCount,
			    id = _props.id,
			    isDisabled = _props.isDisabled,
			    innerRef = _props.innerRef,
			    _onBlur = _props.onBlur,
			    _onChange = _props.onChange,
			    onFocus = _props.onFocus,
			    maximumCharacters = _props.maximumCharacters,
			    rowCount = _props.rowCount,
			    value = _props.value;


			if (innerRef) {
				innerRef(this);
			}

			return React.createElement(
				InternalComponentFrame,
				{ packageJson: packageJson$q },
				React.createElement(
					StyledWrapper$f,
					{
						'aria-label': 'Maximum character allowance is ' + maximumCharacters,
						maxLength: maximumCharacters,
						isValidInput: value.length <= maximumCharacters
					},
					React.createElement(StyledTextarea, {
						characterWidth: characterWidth,
						disabled: isDisabled,
						id: id,
						onBlur: function onBlur(event) {
							return getOnBlurValue(event, _onBlur);
						},
						onFocus: onFocus,
						onChange: function onChange(event) {
							return getCharacterCount(event, _onChange, maximumCharacters);
						},
						rows: rowCount,
						value: value,
						innerRef: function innerRef(element) {
							_this2.refInput = element;
						}
					}),
					!hideCharacterCount && React.createElement(
						SubBody,
						null,
						React.createElement(
							'span',
							null,
							'Characters: ',
							value.length,
							' of ',
							maximumCharacters,
							' used'
						)
					),
					value.length > maximumCharacters && React.createElement(
						StyledSpan,
						{ role: 'alert' },
						'Maximum character limit has been exceeded. Current character count is ',
						value.length,
						' of a maximum of',
						' ',
						maximumCharacters,
						'.'
					)
				)
			);
		}
	}]);
	return GenericTextArea;
}(Component);

GenericTextArea.propTypes = {
	/** Overrides the width of the input. */
	characterWidth: PropTypes.number,
	/** If character counter is present. */
	hideCharacterCount: PropTypes.bool,
	/** Unique string id. */
	id: PropTypes.string,
	/** Used to access the internal input inside the theme wrapper. */
	innerRef: PropTypes.func,
	/** If textarea input is disabled or not. */
	isDisabled: PropTypes.bool,
	/** Maximum number of characters allowed. */
	maximumCharacters: PropTypes.number.isRequired,
	/** Callback function triggered on blur. */
	onBlur: PropTypes.func,
	/** Callback function triggered on focus. */
	onFocus: PropTypes.func,
	/** Callback function triggered on change. */
	onChange: PropTypes.func.isRequired,
	/** Specifies te height of the textarea. */
	rowCount: PropTypes.number,
	/** The value. */
	value: PropTypes.string
};

GenericTextArea.defaultProps = {
	hideCharacterCount: false,
	isDisabled: false,
	rowCount: 8,
	value: ''
};

GenericTextArea.defaultExample = function () {
	return React.createElement(GenericTextArea, { maximumCharacters: 50, onChange: function onChange() {}, value: '' });
};

export { AccountNumberInput, DateOfBirthInput, DayOfMonthPicker, FileProgressTakeover, FileUploadInput, GenericAlphaNumericInput, GenericCheckbox, GenericRadio, WrappedGenericSelect as GenericSelect, GenericTextArea, GenericTextInput, LandlineNumberInput, MoneyInput, MonthAndYearDateInput, SortcodeInput, StandaloneCheckbox, UKOnlyMobileNumberInput, UKOnlyPostcodeInput, WorldwideMobileNumberInput, YearsAndMonthsCountInput };
